(function() {
    'use strict';

    angular
        .module('edistradadhluiApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngAnimate',
            'ngCacheBuster',
            'ngFileUpload',
            'ngFileSaver',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'ngMaterial',
            'uuid',
            'ngLoadingSpinner'
        ])
        .run(run);

    run.$inject = ['$rootScope', 'stateHandler', 'translationHandler', 'Principal', 'DEBUG_INFO_ENABLED', 'VERSION', '$translate'];

    function run($rootScope, stateHandler, translationHandler, Principal, DEBUG_INFO_ENABLED, VERSION, $translate) {
        stateHandler.initialize();
        translationHandler.initialize();
        $rootScope.Principal = Principal;
        $rootScope.DEBUG_INFO_ENABLED = DEBUG_INFO_ENABLED;
        $rootScope.VERSION = VERSION;
        angular.element(window).on("resize", function() {
            $rootScope.$apply();
        });

        $rootScope.$translate = $translate;
        $rootScope.$conditionalTranslate = function(condition, phrase) {
            if (condition)
                return $translate.instant(phrase);
            else return "";
        };

        //        PDFViewerApplication.isViewerEmbedded = true; //This prevents PDF.js to change view title
        //        PDFViewerApplication.postMessageTransfers = false; //This prevents PDF.js to log unnecesarry things
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('UsersController', UsersController);

    UsersController.$inject = ['$scope', '$state', '$stateParams', '$translate', '$uibModal', 'UsersService', 'UtilService', 'AlertService'];

    function UsersController($scope, $state, $stateParams, $translate, $uibModal, UsersService, UtilService, AlertService) {
        var vm = this;
        vm.translate = $translate.instant;

        /*Declare variables*/
        vm.filter = {
            data: {
                size: 25,
                page: 0,
                email: "",
                clientNumber: "",
                clientName: ""
            },
            clear: function() {
                vm.filter.data.email = "";
                vm.filter.data.clientNumber = "";
                vm.filter.data.clientName = "";
            },
            save: function() {
                if (vm.data && vm.data.page)
                    vm.filter.data.page = vm.data.page.number;
                $state.transitionTo($state.current, vm.filter.data, {
                    location: true,
                    inherit: true,
                    notify: false
                });
            },
            read: function() {
                angular.copy($stateParams, vm.filter.data);
            }
        };

        vm.data = null;

        /*Declare functions*/
        //Controller init
        vm.init = function() {
            vm.filter.read();
            if (UtilService.isFilled(vm.filter.data))
                vm.list.current();
        };

        //Getting users
        vm.list = {
            //List users
            current: function() {
                vm.filter.data.page = 0;
                UsersService.listWithParams(vm.filter.data)
                    .then(vm.list.then);
            },
            //Go to the first page
            first: function() {
                UtilService.get(vm.data, 'first', null, null)
                    .then(vm.list.then);
            },
            //Go to the previous page
            previous: function() {
                UtilService.get(vm.data, 'prev', null, null)
                    .then(vm.list.then);
            },
            //Go to the next page
            next: function() {
                UtilService.get(vm.data, 'next', null, null)
                    .then(vm.list.then);
            },
            //Go to the last page
            last: function() {
                UtilService.get(vm.data, 'last', null, null)
                    .then(vm.list.then);
            },
            then: function(response) {
                //Set data to controller data
                vm.data = response.data;
                if (response.data._embedded == null) {
                    AlertService.error('users.users.noUsersFound');
                } else {
                    AlertService.clear();
                }
                //Write state to URL
                vm.filter.save();
            }
        };

        //Managing user
        vm.user = {
            form: function() {
                var newUserModal = $uibModal.open({
                    templateUrl: 'app/views/users/newUser/newUser.html',
                    controller: 'NewUserController',
                    controllerAs: 'vm',
                    size: 'md'
                });

                newUserModal.result.then(function(newUser) {
                    UsersService.create(newUser).then(function() {
                        vm.list.current();
                    });
                });
            }
        };

        //Navigating
        vm.nav = {
            user: function(user) {
                $state.go('user', user);
            }
        };

        //Generating report
        vm.report = {
            form: function() {
                var reportModal = $uibModal.open({
                    templateUrl: 'app/views/users/report/userReport.html',
                    controller: 'UserReportController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        filter: angular.copy(vm.filter.data)
                    }
                });

                reportModal.result.then(function(result) {});
            }
        };

        //Init controller
        vm.init();

        //Position fix-table
        var fixed = $('#fixed'),
            underFixed = $('#under-fixed');
        $scope.$watch(
            function() {
                return fixed.outerHeight();
            },
            function(newValue) {
                underFixed.css('padding-top', newValue);
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('usersPanel', {
                parent: 'application',
                url: '/usersPanel',
                views: {
                    'content@application': {
                        templateUrl: 'app/views/users/usersPanel.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('documents');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('users');
                        return $translate.refresh();
                    }]
                },
                redirectTo: 'users'
            })
            .state('users', {
                parent: 'usersPanel',
                url: '/users?size&page&email&clientNumber&clientName',
                params: {
                    size: '25',
                    page: '0',
                    email: null,
                    clientNumber: null,
                    clientName: null
                },
                data: {
                    pageTitle: 'global.menu.users'
                },
                views: {
                    'innerContent@usersPanel': {
                        templateUrl: 'app/views/users/users/users.html',
                        controller: 'UsersController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('users');
                        return $translate.refresh();
                    }]
                }
            })
            .state('user', {
                parent: 'usersPanel',
                url: '/user?email',
                params: {
                    email: null
                },
                data: {
                    pageTitle: 'global.menu.user'
                },
                views: {
                    'innerContent@usersPanel': {
                        templateUrl: 'app/views/users/user/user.html',
                        controller: 'UserController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('users');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('UserController', UserController);

    UserController.$inject = ['$state', '$stateParams', '$translate', '$uibModal', 'UsersService', 'RolesService', 'UtilService', 'AlertService', 'Principal'];

    function UserController($state, $stateParams, $translate, $uibModal, UsersService, RolesService, UtilService, AlertService, Principal) {
        var vm = this;
        vm.translate = $translate.instant;

        /*Declare variables*/
        vm.filter = {
            data: {
                size: 10,
                page: 0,
                email: "",
                clientNumber: "",
                clientName: ""
            },
            clear: function() {
                vm.filter.data.email = "";
                vm.filter.data.clientNumber = "";
                vm.filter.data.clientName = "";
            },
            save: function() {
                $state.transitionTo($state.current, vm.filter.data, {
                    location: true,
                    inherit: true,
                    notify: false
                });
            },
            read: function() {
                angular.copy($stateParams, vm.filter.data);
            }
        };

        vm.data = {};
        vm.rolesChangeError = null;
        vm.rolesChangeSuccess = null;
        vm.deleteMessage = null;

        /*Declare functions*/
        //Controller init
        vm.init = function() {
            vm.filter.read();
            if (UtilService.isFilled(vm.filter.data)) {
                vm.user.get();
            } else
                $state.go('users');
        };

        //Managing user
        vm.user = {
            get: function() {
                UsersService.get(vm.filter.data.email)
                    //If successful
                    .then(vm.user.then)
                    //If there were errors
                    .catch(function(response) {})
                    .finally(function(response) {});
            },
            then: function(response) {
                //Set data to controller data
                vm.data.user = response.data;

                if(Principal.hasUserWrite()) {
                    vm.user.deleteMessage();
                }

                vm.user.getClients();
                vm.user.getUserRoles();
                vm.user.hasDocumentsAccess();
                vm.user.getUserDates();
                //vm.user.getFirstActivationDate();
                //vm.user.getLastActivityDate();
                vm.user.getLastFailedLoginDate();
                vm.user.getLastSuccessfulLoginDate();


                //Write state to URL
                vm.filter.save();
            },
            getClients: function() {
                UtilService.get /*his clients*/ (vm.data.user, 'clients', null, null)
                    .then(function(response) {
                        //Set clients to user
                        if(response.data != null && response.data._embedded != null) {
                            vm.data.user.clients = response.data._embedded.dhlClients;
                        }
                    });
            },
            getUserRoles: function() {
                if (Principal.hasSystemAccess()) {
                    vm.roles.getAll(); //all roles
                    UtilService.get /*his roles*/ (vm.data.user, 'roles', null, null)
                        .then(function(response) {
                            response.data._embedded.ediRoles.forEach(function(userRole) {
                                if (vm.data.roles) {
                                    vm.data.roles.forEach(function(role) {
                                        if (userRole.roleName === role.roleName)
                                            role.active = true;
                                    });
                                }
                            });
                        });
                }
            },
            getUserDates: function() {
                UsersService.getUserDates(vm.data.user.ediUserId)
                    .then(function(response) {
                        vm.data.user.firstActivationDate = response.data.firstActivationDate;
                        vm.data.user.lastActivityDate = response.data.lastActivity;
                    });
            },
            getFirstActivationDate: function() {
                UsersService.getFirstActivationDate(vm.data.user.ediUserId)
                    .then(function(response) {
                        vm.data.user.firstActivationDate = response.data;
                    });
            },
            getLastActivityDate: function() {
                UsersService.getLastActivityDate(vm.data.user.ediUserId)
                    .then(function(response) {
                        vm.data.user.lastActivityDate = response.data;
                    });
            },
            getLastFailedLoginDate: function() {
                UsersService.getLastFailedLoginDate(vm.data.user.ediUserId)
                    .then(function(response) {
                        vm.data.user.lastFailedLoginDate = response.data;
                    });
            },
            getLastSuccessfulLoginDate: function() {
                UsersService.getLastSuccessfulLoginDate(vm.data.user.ediUserId)
                    .then(function(response) {
                        vm.data.user.lastSuccessfulLoginDate = response.data;
                    });
            },
            clients: function() {
                var reportModal = $uibModal.open({
                    templateUrl: 'app/views/users/user/clients/userClients.html',
                    controller: 'UserClientsController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        filter: {
                            email: vm.data.user.email,
                            ediUserId: vm.data.user.ediUserId
                        }
                    }
                });

                reportModal.result.then(function(result) {
                    AlertService.clear();
                    result.response
                        .then(function(response) {
                            var alertData = {
                                email: response.config.params.email,
                                clientNumber: response.config.params.clientNumber
                            };
                            if (result.type === 'add') {
                                AlertService.success("users.user.clients.successfullyAssigned", alertData);
                            } else if (result.type === 'removeOne'){
                                AlertService.success("users.user.clients.successfullyRemoved", alertData);
                            } else {
                                AlertService.success("users.user.clients.successfullyRemovedAll", {clientNumber: result.clientNumber});
                            }
                            vm.user.get();
                        })
                        .catch(function(response) {
                            if (result.type === 'add' && response.status === 409) {
                                AlertService.warning("users.user.clients.alreadyAssigned", {
                                    email: response.config.params.email,
                                    clientNumber: response.config.params.clientNumber
                                });
                            } else {
                                AlertService.error("users.errors.occurred");
                            }
                        });
                });
            },

            unlock: function() {
                UsersService.unlock(vm.data.user.ediUserId)
                    .then(function(response) {
                        AlertService.success("users.user.userUnlocked");
                        vm.data.user.locked = false;
                    })
                    .catch(function(response) {
                        AlertService.error("users.errors.occurred");
                    });
            },
            lock: function() {
                UsersService.lock(vm.data.user.ediUserId)
                    .then(function(response) {
                        AlertService.success("users.user.userLocked");
                        vm.data.user.locked = true;
                    })
                    .catch(function(response) {
                        AlertService.error("users.errors.occurred");
                    });
            },

            unlockDocuments: function() {
                UsersService.unlockDocuments(vm.data.user.ediUserId)
                    .then(function(response) {
                        AlertService.success("users.user.receivables.documentsUnlockSuccess");
                        vm.data.user.documentsLocked = false;
                    })
                    .catch(function(response) {
                        AlertService.error("users.user.receivables.documentsUnlockFail");
                    });
            },

            lockDocuments: function() {
                UsersService.lockDocuments(vm.data.user.ediUserId)
                    .then(function(response) {
                        AlertService.success("users.user.receivables.documentsLockSuccess");
                        vm.data.user.documentsLocked = true;
                    })
                    .catch(function(response) {
                        AlertService.error("users.user.receivables.documentsLockFail");
                    });
            },

            resetPassword: function() {
                UsersService.resetPassword(vm.data.user.ediUserId)
                    .then(function(response) {
                        AlertService.success("users.user.passResetSent");
                    })
                    .catch(function(response) {
                        AlertService.error("users.errors.occurred");
                    });
            },
            toggleActivation: function() {
                if (vm.data.user.activated)
                    vm.user.deactivate();
                else
                    vm.user.activate();
            },
            activate: function() {
                UsersService.activate(vm.data.user.ediUserId)
                    .then(function(response) {
                        AlertService.success("users.user.userActivated");
                        vm.data.user.activated = true;
                    })
                    .catch(function(response) {
                        AlertService.error("users.errors.occurred");
                    });
            },
            deactivate: function() {
                UsersService.deactivate(vm.data.user.ediUserId)
                    .then(function(response) {
                        AlertService.success("users.user.userDeactivated");
                        vm.data.user.activated = false;
                    })
                    .catch(function(response) {
                        AlertService.error("users.errors.occurred");
                    });
            },
            delete: function() {
                UsersService.delete(vm.data.user.ediUserId)
                    .then(function(response) {
                        $state.go("users");
                        setTimeout(function() {
                            AlertService.success("users.user.userDeleted", {email: vm.data.user.email});
                        }, 100);
                    })
                    .catch(function(response) {
                        AlertService.error("users.errors.occurred");
                    });
            },
            deleteMessage: function() {
                UsersService.hasReceivablesClients(vm.data.user.ediUserId)
                    .then(function(response) {
                        if(response.data.message === true) {
                            vm.deleteMessage = $translate.instant("users.user.hasReceivablesClients");
                        } else {
                            vm.deleteMessage = $translate.instant("confirm.areYouSure");
                        }
                    })
                    .catch(function(response) {
                        AlertService.error("users.errors.occurred");
                        vm.deleteMessage = $translate.instant("users.user.mayHaveReceivablesClients");
                    });
            },
            //not used anymore
            // isLocked: function() {
            //     return UsersService.isLocked(vm.data.user.ediUserId)
            //         .then(function(response) {
            //             vm.data.user.locked = response.data;
            //             return response.data;
            //         });
            // },
            hasDocumentsAccess: function() {
                UsersService.hasDocumentsAccess(vm.data.user.ediUserId)
                    .then(function(response) {
                        if(response.data.message === true)
                            vm.data.user.documentsLocked = false;
                        else 
                            vm.data.user.documentsLocked = true;
                    });
            }
        };

        vm.roles = {
            getAll: function() {
                RolesService.list()
                    .then(function(response) {
                        vm.data.roles = response.data._embedded.ediRoles;
                    });
            },
            change: function() {
                var roles = [];
                vm.data.roles.forEach(function(role) {
                    if (role.active)
                        roles.push(role.roleName);
                });
                UsersService.changeRoles(vm.data.user.ediUserId, roles)
                    .then(function(response) {
                        vm.rolesChangeError = null;
                        vm.rolesChangeSuccess = true;
                    })
                    .catch(function(response) {
                        vm.rolesChangeError = true;
                        vm.rolesChangeSuccess = null;
                    });
            }
        };

        //Navigating
        vm.nav = {
            users: function() {
                $state.go('users');
            },
            client: function(client) {
                $state.go('client', client);
            }
        };

        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('UserClientsController', UserClientsController);

    UserClientsController.$inject = ['$uibModalInstance', '$translate', 'filter', 'UsersService', 'ClientsService'];

    function UserClientsController($uibModalInstance, $translate, filter, UsersService, ClientsService) {
        var vm = this;
        vm.translate = $translate.instant;

        vm.data = {
            userId: filter.ediUserId,
            email: filter.email,
            clientNumber: "",
            clientName: null
        };

        vm.clients = {
            timeout: null,
            lookup: function() {
                clearTimeout(vm.clients.timeout);
                vm.clients.timeout = setTimeout(function() {
                    vm.data.clientName = null;
                    ClientsService.findByClientNumber(vm.data.clientNumber)
                        .then(function(response) {
                            vm.data.clientName = response.data.clientName;
                        })
                        .catch(function(response) {
                            vm.data.clientName = null;
                        });
                }, 500);
            },
            addClient: function() {
                var result = {
                    response: UsersService.addClient(vm.data.userId, vm.data.email, vm.data.clientNumber),
                    type:'add'
                };
                $uibModalInstance.close(result);
            },
            removeClient: function() {
                var result = {
                    response: UsersService.removeClient(vm.data.userId, vm.data.email, vm.data.clientNumber),
                    type:'removeOne'
                };
                $uibModalInstance.close(result);
            },
            removeAllClients: function() {
                var result = {
                    response: UsersService.removeAllClients(vm.data.userId, vm.data.email),
                    type:'removeAll',
                    clientNumber: vm.data.clientNumber
                };
                $uibModalInstance.close(result);
            }
        };

        vm.modal = {
            cancel: function() {
                $uibModalInstance.dismiss('cancel');
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('UserReportController', UserReportController);

    UserReportController.$inject = ['$uibModalInstance', '$translate', 'UsersService', 'UtilService'];

    function UserReportController($uibModalInstance, $translate, UsersService, UtilService) {
        var vm = this;
        vm.translate = $translate.instant;
        vm.filter = {};
        vm.modal = {
            generate: function() {
                $uibModalInstance.close(vm.data);
            },
            getGenerateURL: function(){
                var filterToSend = angular.copy(vm.filter);
                if (vm.active == 0)
//                    UsersService.usersReport(vm.filter)
//                    .then(function(response) {
//                        var date = new Date();
//                        FileSaver.saveAs(new Blob([response.data], { type: "text/csv" }),
//                            $translate.instant("users.report.listPrefix") + (date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()) + ".xlsx");
//                    });
                    return UsersService.getUsersReportURL(filterToSend);
                else {

                    if (UtilService.isFilled(vm.filter.activityDateFrom))
                        filterToSend.activityDateFrom = new Date(vm.filter.activityDateFrom);

                    if (UtilService.isFilled(vm.filter.activityDateTo)) {
                        var activityDateTo = new Date(vm.filter.activityDateTo);
                        activityDateTo.setHours(23);
                        activityDateTo.setMinutes(59);
                        activityDateTo.setSeconds(59);
                        filterToSend.activityDateTo = activityDateTo;
                    }

                    if (UtilService.isFilled(vm.filter.activityUserTypes))
                        filterToSend.activityUserTypes = vm.filter.activityUserTypes.split(",");

                    if (UtilService.isFilled(vm.filter.activityOperators))
                        filterToSend.activityOperators = vm.filter.activityOperators.split(",");

                    if (UtilService.isFilled(vm.filter.activityUserEmails))
                        filterToSend.activityUserEmails = vm.filter.activityUserEmails.split(",");

                    if (UtilService.isFilled(vm.filter.activityClientNames))
                        filterToSend.activityClientNames = vm.filter.activityClientNames.split(",");

                    if (UtilService.isFilled(vm.filter.activityClientNumbers))
                        filterToSend.activityClientNumbers = vm.filter.activityClientNumbers.split(",");

                    if (UtilService.isFilled(vm.filter.activityDocumentNumbers))
                        filterToSend.activityDocumentNumbers = vm.filter.activityDocumentNumbers.split(",");

                    if (UtilService.isFilled(vm.filter.useArchiveUsers))
                        filterToSend.useArchiveUsers = vm.filter.useArchiveUsers;

//                    UsersService.activityReport(vm.filter)
//                        .then(function(response) {
//                            var date = new Date();
//                            FileSaver.saveAs(new Blob([response.data], { type: "text/csv" }),
//                                $translate.instant("users.report.activitiesPrefix") + (date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()) + ".xlsx");
//                        });
                    return UsersService.getActivityReportURL(filterToSend);
                }
            },
            cancel: function() {
                $uibModalInstance.dismiss('cancel');
            }
        };

        setTimeout(function() {
            $('#actionTypeMultiselect').multiselect({
                includeSelectAllOption: true,
                dropUp: true,
                buttonText: function(options, select) {
                    if (options.length === 11) {
                        return $translate.instant("users.report.actions.all");
                    } else if (options.length === 0) {
                        return $translate.instant("users.report.actions.choose");
                    } else if (options.length % 10 === 1) {
                        return $translate.instant("users.report.actions.chosen") + options.length + $translate.instant("users.report.actions.1action");
                    } else if (options.length % 10 > 1 && options.length % 10 < 5) {
                        return $translate.instant("users.report.actions.chosen") + options.length + $translate.instant("users.report.actions.2actions");
                    } else if (options.length % 10 > 4) {
                        return $translate.instant("users.report.actions.chosen") + options.length + $translate.instant("users.report.actions.5actions");
                    }
                },
                selectAllText: $translate.instant("users.report.selectAll")
            });
        }, 1);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('NewUserController', NewUserController);

    NewUserController.$inject = ['$uibModalInstance', '$translate', 'AlertService', 'UsersService'];

    function NewUserController($uibModalInstance, $translate, AlertService, UsersService) {
        var vm = this;

        vm.data = {
            email: null,
            password: null
        };

        vm.modal = {
            add: function() {
                UsersService.isEmailUnique(vm.data.email)
                    .then(function(response){
                        UsersService.checkNewUsersPasswordValid(vm.data.password)
                            .then(function(response){
                                $uibModalInstance.close(vm.data);
                            }).catch(function(response){
                                var passwordChangeError;
                                switch (response.data.message) {
                                    case 1:
                                        passwordChangeError = "users.newUser.error1";
                                        break;
                                    case 4:
                                        passwordChangeError = "users.newUser.error4";
                                        break;
                                    case 5:
                                        passwordChangeError = "users.newUser.error5";
                                        break;
                                    default:
                                        passwordChangeError = "error.occurred";
                                }
                                AlertService.error(passwordChangeError);
                            });
                    }).catch(function(response){
                        AlertService.error("users.newUser.exists");
                    });
            },
            cancel: function() {
                $uibModalInstance.dismiss('cancel');
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('SystemSettingsModalController', SystemSettingsModalController);

    SystemSettingsModalController.$inject = ['$uibModalInstance'];

    function SystemSettingsModalController($uibModalInstance) {
        var vm = this;

        vm.modal = {
            go: function() {
                $uibModalInstance.close(true);
            },
            cancel: function() {
                $uibModalInstance.close(false);
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('system-settings', {
            parent: 'application',
            url: '/system-settings',
            data: {
                pageTitle: 'global.menu.system-settings'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/system-settings/system-settings.html',
                    controller: 'SystemSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('global');
                	$translatePartialLoader.addPart('system-settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('SystemSettingsController', SystemSettingsController);

    SystemSettingsController.$inject = ['$scope', '$translate', 'ConstantsService', 'Upload', 'API_URL', 'MailTemplatesService', '$uibModal', 'FileSaver', 'Blob', 'UtilService', 'filterFilter', 'ClientsService'];

    function SystemSettingsController($scope, $translate, ConstantsService, Upload, API_URL, MailTemplatesService, $uibModal, FileSaver, Blob, UtilService, filterFilter, ClientsService) {
        var vm = this;
        vm.translate = $translate.instant;
        vm.ActivityTypes = [{
            name: 'ACCOUNT_OPENED',
            text: function() {
                return $translate.instant('systemSettings.templateType.open');
            }
        }, {
            name: 'EMAIL_ADDED',
            text: function() {
                return $translate.instant('systemSettings.templateType.emailAdded');
            }
        }, {
            name: 'REGISTRATION_FAIL',
            text: function() {
                return $translate.instant('systemSettings.templateType.invalidRegistration');
            }
        }, {
            name: 'PASSWORD_CHANGE',
            text: function() {
                return $translate.instant('systemSettings.templateType.reset');
            }
        }, {
            name: 'PAPER_INVOICE',
            text: function() {
                return $translate.instant('systemSettings.templateType.paperInvoice');
            }
        }, {
            name: 'INVOICE_WITH_LINK',
            text: function() {
                return $translate.instant('systemSettings.templateType.invoiceLink');
            }
        }, {
            name: 'INVOICE_WITH_PDF',
            text: function() {
                return $translate.instant('systemSettings.templateType.invoicePdf');
            }
        }, {
            name: 'INVOICE_WITH_LINK_AND_XLSX',
            text: function() {
                return $translate.instant('systemSettings.templateType.invoiceLinkAndXlsx');
            }
        }, {
            name: 'INVOICE_WITH_PDF_AND_XLSX',
            text: function() {
                return $translate.instant('systemSettings.templateType.invoicePdfAndXlsx');
            }
        }, {
            name: 'CORRECTION_INVOICE',
            text: function() {
                return $translate.instant('systemSettings.templateType.correctingInvoice');
            }
        }, {
            name: 'INVOICE_TOO_LARGE',
            text: function() {
                return $translate.instant('systemSettings.templateType.tooBig');
            }
        }, {
            name: 'ANNEX',
            text: function() {
                return $translate.instant('systemSettings.templateType.annex');
            }
        }];
        vm.languages = [{
            name: 'pl',
            text: function() {
                return $translate.instant('systemSettings.templateLanguage.pl');
            }
        }, {
            name: 'en',
            text: function() {
                return $translate.instant('systemSettings.templateLanguage.en');
            }
        }];
        vm.ifContinue = true;
        vm.dhlTemplates = [];
        vm.dhlTitles = [];
        vm.dhlEmailTempaltes = null;
        vm.dhlEmailTempaltesIds = null;
        vm.templatesToSend = [];
        vm.clientId = null;
        vm.dhlClient = null;
        vm.addingEmailTemplateErrorText = null;
        vm.addingEmailTemplateSuccessText = null;
        vm.getDataErrorText = null;
        vm.clientErrorText = null;
        vm.clientSuccessText = null;
        vm.htmlTooltip = false;
        vm.chooseOrDrop = chooseOrDrop;

        vm.client = {
            templates: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null
                },
                PAPER_INVOICE: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                CORRECTION_INVOICE: {
                    name: null,
                    template_id: null
                },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null
                }
            },
            titles: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null
                },
                PAPER_INVOICE: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                CORRECTION_INVOICE: {
                    name: null,
                    template_id: null
                },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null
                }
            },
            templatesEN: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null
                },
                PAPER_INVOICE: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                CORRECTION_INVOICE: {
                    name: null,
                    template_id: null
                },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null
                }
            },
            titlesEN: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null
                },
                PAPER_INVOICE: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                CORRECTION_INVOICE: {
                    name: null,
                    template_id: null
                },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null
                }
            }
        };


        vm.upload = upload;
        vm.submit = submit;
        vm.chectUniqueNameAndType = chectUniqueNameAndType;
        vm.getTitleTemplates = getTitleTemplates;
        vm.getContentTemplates = getContentTemplates;
        vm.download = download;
        vm.addClientNumber = addClientNumber;
        vm.addInvoiceNumber = addInvoiceNumber;
        vm.addInvoiceDate = addInvoiceDate;
        vm.addNettoValue = addNettoValue;
        vm.checkTemplateTitle = checkTemplateTitle;
        vm.addTemplateTitle = addTemplateTitle;
        vm.clearForms = clearForms;
        vm.getAllEmailTemplates = getAllEmailTemplates;
        vm.getUserTemplatesId = getUserTemplatesId;
        vm.sendNewUserTemplates = sendNewUserTemplates;
        vm.getCommonElementFromLists = getCommonElementFromLists;
        vm.getClientByNumber = getClientByNumber;
        vm.changeActionTypeToText = changeActionTypeToText;
        vm.setTooltip = setTooltip;
        vm.disableTooltip = disableTooltip;


        vm.init = function() {
            vm.interval.get();
            vm.showInterval.get();
            vm.getContentTemplates();
            vm.getTitleTemplates();
            vm.clearForms();
        };

        function clearForms() {
            vm.template = {
                activity: vm.ActivityTypes[0],
                name: null,
                language: vm.languages[0]
            };
            vm.title = {
                activity: vm.ActivityTypes[0],
                name: null,
                text: "",
                language: vm.languages[0]
            };
        }

        vm.interval = {
            current: null,
            new: null,
            measure: "days",
            set: function() {
                var interval = vm.interval.new;
                switch (vm.interval.measure) {
                    case "days":
                        interval *= 24 /*h*/ * 60 /*min*/ * 60 /*s*/ * 1000 /*ms*/ ;
                        break;
                    case "months":
                        interval *= 30 /*days*/ * 24 /*h*/ * 60 /*min*/ * 60 /*s*/ * 1000 /*ms*/ ;
                        break;
                    case "years":
                        interval *= 365 /*days*/ * 24 /*h*/ * 60 /*min*/ * 60 /*s*/ * 1000 /*ms*/ ;
                        break;
                }
                ConstantsService.set({
                    name: 'PASSWORD_CHANGE_INTERVAL',
                    value: interval
                })
                .then(function(response) {
                    vm.interval.get();
                });
            },
            get: function() {
                ConstantsService.get('PASSWORD_CHANGE_INTERVAL')
                    .then(function(response) {
                        var interval = response.data.value;
                        //Convert to days
                        interval = interval / 1000 /*ms*/ / 60 /*s*/ / 60 /*min*/ / 24 /*h*/ ;
                        vm.interval.current = interval;
                    });
            }
        };

        vm.showInterval = {
            current: null,
            new: null,
            measure: "days",
            set: function() {
                var interval = vm.showInterval.new;
                switch (vm.showInterval.measure) {
                    case "days":
                        interval *= 24 /*h*/ * 60 /*min*/ * 60 /*s*/ * 1000 /*ms*/ ;
                        break;
                    case "months":
                        interval *= 30 /*days*/ * 24 /*h*/ * 60 /*min*/ * 60 /*s*/ * 1000 /*ms*/ ;
                        break;
                    case "years":
                        interval *= 365 /*days*/ * 24 /*h*/ * 60 /*min*/ * 60 /*s*/ * 1000 /*ms*/ ;
                        break;
                }
                ConstantsService.set({
                    name: 'PASSWORD_SHOW_CHANGE_INTERVAL',
                    value: interval
                })
                .then(function(response) {
                    vm.showInterval.get();
                });
            },
            get: function() {
                ConstantsService.get('PASSWORD_SHOW_CHANGE_INTERVAL')
                    .then(function(response) {
                        var interval = response.data.value;
                        //Convert to days
                        interval = interval / 1000 /*ms*/ / 60 /*s*/ / 60 /*min*/ / 24 /*h*/ ;
                        vm.showInterval.current = interval;
                    });
            }
        };

        function submit(file) {
            if (typeof file !== "undefined" && file) {
                vm.upload(file);
            } else {
                vm.addingEmailTemplateErrorText = $translate.instant('systemSettings.messages.choseFile');
                vm.addingEmailTemplateSuccessText = null;
            }
        }

        // upload on file select or drop
        function upload(file) {
            Upload.upload({
                url: API_URL + 'api/dhlTemplates/upload',
                fields: { 'name': vm.template.name, 'type': vm.template.activity, 'language': vm.template.language },
                file: file
            }).then(function(resp) {
                vm.getContentTemplates();
                vm.clearForms();
                vm.addingEmailTemplateSuccessText = $translate.instant('systemSettings.messages.templateSuccess');
                vm.addingEmailTemplateErrorText = null;
            }, function(resp) {
                vm.addingEmailTemplateErrorText = $translate.instant('error.occurred');
                vm.addingEmailTemplateSuccessText = null;
            });
        }

        function chectUniqueNameAndType(file, size) {
            MailTemplatesService.checkUnique(vm.template.name, vm.template.activity, vm.template.language, 'EMAIL_CONTENT').then(function(response) {
                vm.submit(file);
            }).catch(function(response) {
                if (!response.data.unique) {
                    var modalInstance = $uibModal.open({
                        animation: true,
                        ariaLabelledBy: 'modal-title',
                        ariaDescribedBy: 'modal-body',
                        templateUrl: 'app/views/system-settings/template-upload-modal/system-settings.modal.html',
                        controller: 'SystemSettingsModalController',
                        controllerAs: 'vm',
                        size: size
                    });

                    modalInstance.result.then(function(go) {
                        if (go) {
                            vm.submit(file);
                        }
                    });
                } else {
                    vm.addingEmailTemplateErrorText = $translate.instant('error.occurred');
                    vm.addingEmailTemplateSuccessText = null;
                }
            });
        }

        function getContentTemplates() {
            MailTemplatesService.getTemplatesByType("EMAIL_CONTENT").then(function(response) {
                vm.dhlTemplates = response.data;
            }).catch(function(response) {
                vm.getDataErrorText = $translate.instant('systemSettings.dataError');
            });
        }

        function getTitleTemplates() {
            MailTemplatesService.getTemplatesByType("EMAIL_TITLE").then(function(response) {
                vm.dhlTitles = response.data;
            }).catch(function(response) {
                vm.getDataErrorText = $translate.instant('systemSettings.dataError');
            });
        }

        function download(name, type, language, filename) {
            MailTemplatesService.download(name, type, language).then(function(response) {
                FileSaver.saveAs(new Blob([response.data], { type: "text/html" }), filename);
            }).catch(function(response) {
                //blad pobrania danych
            });
        }

        function addClientNumber() {
            if (vm.title.text) {
                vm.title.text = [vm.title.text.slice(0, $('#titleArea').prop("selectionStart")), "{{clientNumber}}",
                    vm.title.text.slice($('#titleArea').prop("selectionStart"))
                ].join('');
            } else {
                vm.title.text = "{{clientNumber}}";
            }
        }

        function addInvoiceNumber() {
            if (vm.title.text) {
                vm.title.text = [vm.title.text.slice(0, $('#titleArea').prop("selectionStart")), "{{invoiceNumber}}",
                    vm.title.text.slice($('#titleArea').prop("selectionStart"))
                ].join('');
            } else {
                vm.title.text = "{{invoiceNumber}}";
            }
        }

        function addInvoiceDate() {
            if (vm.title.text) {
                vm.title.text = [vm.title.text.slice(0, $('#titleArea').prop("selectionStart")), "{{invoiceDate}}",
                    vm.title.text.slice($('#titleArea').prop("selectionStart"))
                ].join('');
            } else {
                vm.title.text = "{{invoiceDate}}";
            }
        }

        function addNettoValue() {
            if (vm.title.text) {
                vm.title.text = [vm.title.text.slice(0, $('#titleArea').prop("selectionStart")), "{{nettoValue}}",
                    vm.title.text.slice($('#titleArea').prop("selectionStart"))
                ].join('');
            } else {
                vm.title.text = "{{nettoValue}}";
            }
        }

        function checkTemplateTitle(size) {
            MailTemplatesService.checkUnique(vm.title.name, vm.title.activity, vm.title.language, 'EMAIL_TITLE').then(function(response) {
                vm.addTemplateTitle(vm.title.name, vm.title.activity, vm.title.text, vm.title.language);
            }).catch(function(response) {
                if (response.data.unique == false) {
                    var modalInstance = $uibModal.open({
                        animation: true,
                        ariaLabelledBy: 'modal-title',
                        ariaDescribedBy: 'modal-body',
                        templateUrl: 'app/views/system-settings/template-upload-modal/system-settings.modal.html',
                        controller: 'SystemSettingsModalController',
                        controllerAs: 'vm',
                        size: size
                    });

                    modalInstance.result.then(function(go) {
                        if (go) {
                            vm.addTemplateTitle(vm.title.name, vm.title.activity, vm.title.text, vm.title.language);
                        }
                    });
                } else {
                    vm.addingEmailTitleSuccessText = null;
                    vm.addingEmailTitleErrorText = $translate.instant('error.occurred');
                }
            });
        }


        function addTemplateTitle(name, activity, text, language) {
            MailTemplatesService.addTemplateTitle(name, activity, text, language).then(function(response) {
                vm.getTitleTemplates();
                vm.clearForms();
                vm.addingEmailTitleSuccessText = $translate.instant('systemSettings.messages.templateSuccess');
                vm.addingEmailTitleErrorText = null;
            }).catch(function(response) {
                vm.addingEmailTitleSuccessText = null;
                vm.addingEmailTitleErrorText = $translate.instant('error.occurred');
            });
        }

        function getClientByNumber() {
            ClientsService.findByClientNumber(vm.clientId).then(function(response) {
                vm.dhlClient = response.data;
                vm.getAllEmailTemplates();
            }).catch(function(response) {
                vm.dhlClient = null;
                if (response.status == 404) {
                    vm.clientErrorText = $translate.instant('systemSettings.messages.noClientFound');
                    vm.clientSuccessText = null;
                } else {
                    vm.clientErrorText = $translate.instant('error.occurred');
                    vm.clientSuccessText = null;
                }
            });

        }

        function getAllEmailTemplates() {
            MailTemplatesService.getAllTemplates().then(function(response) {
                if (response.data._embedded != null) {
                    vm.dhlEmailTempaltes = response.data._embedded.dhlTemplates;
                    vm.getUserTemplatesId();
                } else {
                    vm.clientErrorText = $translate.instant('systemSettings.messages.templatesDownloadFailed');
                    vm.clientSuccessText = null;
                }
            }).catch(function(response) {
                vm.clientErrorText = $translate.instant('systemSettings.messages.templatesDownloadFailed');
                vm.clientSuccessText = null;
            });
        }

        function getUserTemplatesId() {
            ClientsService.getClientTemplates(vm.dhlClient.ediClientId).then(function(response) {
                vm.dhlEmailTempaltesIds = response.data;


                var id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'ACCOUNT_OPENED', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titles.ACCOUNT_OPENED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'EMAIL_ADDED', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titles.EMAIL_ADDED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'REGISTRATION_FAIL', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titles.REGISTRATION_FAIL = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'PASSWORD_CHANGE', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titles.PASSWORD_CHANGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'PAPER_INVOICE', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titles.PAPER_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_LINK', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titles.INVOICE_WITH_LINK = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titles.INVOICE_WITH_PDF = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_LINK_AND_XLSX', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titles.INVOICE_WITH_LINK_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF_AND_XLSX', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titles.INVOICE_WITH_PDF_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'CORRECTION_INVOICE', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titles.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_TOO_LARGE', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titles.INVOICE_TOO_LARGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];




                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'ACCOUNT_OPENED', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templates.ACCOUNT_OPENED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'EMAIL_ADDED', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templates.EMAIL_ADDED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'REGISTRATION_FAIL', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templates.REGISTRATION_FAIL = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'PASSWORD_CHANGE', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templates.PASSWORD_CHANGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'PAPER_INVOICE', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templates.PAPER_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_LINK', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templates.INVOICE_WITH_LINK = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templates.INVOICE_WITH_PDF = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_LINK_AND_XLSX', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templates.INVOICE_WITH_LINK_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF_AND_XLSX', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templates.INVOICE_WITH_PDF_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'CORRECTION_INVOICE', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templates.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_TOO_LARGE', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templates.INVOICE_TOO_LARGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];




                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'ACCOUNT_OPENED', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titlesEN.ACCOUNT_OPENED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'EMAIL_ADDED', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titlesEN.EMAIL_ADDED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'REGISTRATION_FAIL', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titlesEN.REGISTRATION_FAIL = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'PASSWORD_CHANGE', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titlesEN.PASSWORD_CHANGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'PAPER_INVOICE', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titlesEN.PAPER_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_LINK', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titlesEN.INVOICE_WITH_LINK = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titlesEN.INVOICE_WITH_PDF = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_LINK_AND_XLSX', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titlesEN.INVOICE_WITH_LINK_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF_AND_XLSX', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titlesEN.INVOICE_WITH_PDF_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'CORRECTION_INVOICE', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titlesEN.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_TOO_LARGE', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.titlesEN.INVOICE_TOO_LARGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];




                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'ACCOUNT_OPENED', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templatesEN.ACCOUNT_OPENED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'EMAIL_ADDED', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templatesEN.EMAIL_ADDED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'REGISTRATION_FAIL', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templatesEN.REGISTRATION_FAIL = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'PASSWORD_CHANGE', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templatesEN.PASSWORD_CHANGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'PAPER_INVOICE', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templatesEN.PAPER_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_LINK', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templatesEN.INVOICE_WITH_LINK = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templatesEN.INVOICE_WITH_PDF = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_LINK_AND_XLSX', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templatesEN.INVOICE_WITH_LINK_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF_AND_XLSX', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templatesEN.INVOICE_WITH_PDF_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'CORRECTION_INVOICE', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templatesEN.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_TOO_LARGE', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                vm.client.templatesEN.INVOICE_TOO_LARGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];


            }).catch(function(response) {
                vm.clientErrorText = $translate.instant('systemSettings.messages.templatesDownloadFailed');
                vm.clientSuccessText = null;
            });
        }

        function getCommonElementFromLists(list1, list2) {
            var id;
            angular.forEach(list1, function(value, key) {
                if (list2.indexOf(value.ediTemplateId) > -1) {
                    id = value.ediTemplateId;
                }
            });
            return id;
        }

        //client + listofid
        function sendNewUserTemplates() {
            vm.templatesToSend = [];

            vm.templatesToSend.push(vm.client.titles.ACCOUNT_OPENED.ediTemplateId);
            vm.templatesToSend.push(vm.client.titles.EMAIL_ADDED.ediTemplateId);
            vm.templatesToSend.push(vm.client.titles.REGISTRATION_FAIL.ediTemplateId);
            vm.templatesToSend.push(vm.client.titles.PASSWORD_CHANGE.ediTemplateId);
            vm.templatesToSend.push(vm.client.titles.PAPER_INVOICE.ediTemplateId);
            vm.templatesToSend.push(vm.client.titles.INVOICE_WITH_LINK.ediTemplateId);
            vm.templatesToSend.push(vm.client.titles.INVOICE_WITH_PDF.ediTemplateId);
            vm.templatesToSend.push(vm.client.titles.INVOICE_WITH_LINK_AND_XLSX.ediTemplateId);
            vm.templatesToSend.push(vm.client.titles.INVOICE_WITH_PDF_AND_XLSX.ediTemplateId);
            vm.templatesToSend.push(vm.client.titles.CORRECTION_INVOICE.ediTemplateId);
            vm.templatesToSend.push(vm.client.titles.INVOICE_TOO_LARGE.ediTemplateId);

            vm.templatesToSend.push(vm.client.templates.ACCOUNT_OPENED.ediTemplateId);
            vm.templatesToSend.push(vm.client.templates.EMAIL_ADDED.ediTemplateId);
            vm.templatesToSend.push(vm.client.templates.REGISTRATION_FAIL.ediTemplateId);
            vm.templatesToSend.push(vm.client.templates.PASSWORD_CHANGE.ediTemplateId);
            vm.templatesToSend.push(vm.client.templates.PAPER_INVOICE.ediTemplateId);
            vm.templatesToSend.push(vm.client.templates.INVOICE_WITH_LINK.ediTemplateId);
            vm.templatesToSend.push(vm.client.templates.INVOICE_WITH_PDF.ediTemplateId);
            vm.templatesToSend.push(vm.client.templates.INVOICE_WITH_LINK_AND_XLSX.ediTemplateId);
            vm.templatesToSend.push(vm.client.templates.INVOICE_WITH_PDF_AND_XLSX.ediTemplateId);
            vm.templatesToSend.push(vm.client.templates.CORRECTION_INVOICE.ediTemplateId);
            vm.templatesToSend.push(vm.client.templates.INVOICE_TOO_LARGE.ediTemplateId);

            vm.templatesToSend.push(vm.client.titlesEN.ACCOUNT_OPENED.ediTemplateId);
            vm.templatesToSend.push(vm.client.titlesEN.EMAIL_ADDED.ediTemplateId);
            vm.templatesToSend.push(vm.client.titlesEN.REGISTRATION_FAIL.ediTemplateId);
            vm.templatesToSend.push(vm.client.titlesEN.PASSWORD_CHANGE.ediTemplateId);
            vm.templatesToSend.push(vm.client.titlesEN.PAPER_INVOICE.ediTemplateId);
            vm.templatesToSend.push(vm.client.titlesEN.INVOICE_WITH_LINK.ediTemplateId);
            vm.templatesToSend.push(vm.client.titlesEN.INVOICE_WITH_PDF.ediTemplateId);
            vm.templatesToSend.push(vm.client.titlesEN.INVOICE_WITH_LINK_AND_XLSX.ediTemplateId);
            vm.templatesToSend.push(vm.client.titlesEN.INVOICE_WITH_PDF_AND_XLSX.ediTemplateId);
            vm.templatesToSend.push(vm.client.titlesEN.CORRECTION_INVOICE.ediTemplateId);
            vm.templatesToSend.push(vm.client.titlesEN.INVOICE_TOO_LARGE.ediTemplateId);

            vm.templatesToSend.push(vm.client.templatesEN.ACCOUNT_OPENED.ediTemplateId);
            vm.templatesToSend.push(vm.client.templatesEN.EMAIL_ADDED.ediTemplateId);
            vm.templatesToSend.push(vm.client.templatesEN.REGISTRATION_FAIL.ediTemplateId);
            vm.templatesToSend.push(vm.client.templatesEN.PASSWORD_CHANGE.ediTemplateId);
            vm.templatesToSend.push(vm.client.templatesEN.PAPER_INVOICE.ediTemplateId);
            vm.templatesToSend.push(vm.client.templatesEN.INVOICE_WITH_LINK.ediTemplateId);
            vm.templatesToSend.push(vm.client.templatesEN.INVOICE_WITH_PDF.ediTemplateId);
            vm.templatesToSend.push(vm.client.templatesEN.INVOICE_WITH_LINK_AND_XLSX.ediTemplateId);
            vm.templatesToSend.push(vm.client.templatesEN.INVOICE_WITH_PDF_AND_XLSX.ediTemplateId);
            vm.templatesToSend.push(vm.client.templatesEN.CORRECTION_INVOICE.ediTemplateId);
            vm.templatesToSend.push(vm.client.templatesEN.INVOICE_TOO_LARGE.ediTemplateId);


            ClientsService.postClientTemplates(vm.dhlClient.ediClientId, vm.templatesToSend).then(function(response) {
                vm.clientErrorText = null;
                vm.clientSuccessText = $translate.instant('systemSettings.messages.templatesEditSuccess');
            }).catch(function(response) {
                vm.clientErrorText = $translate.instant('systemSettings.messages.templatesEditFail');
                vm.clientSuccessText = null;
            });
        }

        function changeActionTypeToText(actionType) {
            return filterFilter(vm.ActivityTypes, { name: actionType }, true)[0].text();
        }

        vm.listTemplates = {
            first: function() {
                UtilService.get(vm.dhlTemplates, 'first', null, null)
                    .then(vm.listTemplates.then);
            },
            previous: function() {
                UtilService.get(vm.dhlTemplates, 'prev', null, null)
                    .then(vm.listTemplates.then);
            },
            next: function() {
                UtilService.get(vm.dhlTemplates, 'next', null, null)
                    .then(vm.listTemplates.then);
            },
            last: function() {
                UtilService.get(vm.dhlTemplates, 'last', null, null)
                    .then(vm.listTemplates.then);
            },
            then: function(response) {
                vm.dhlTemplates = response.data;
            }
        };
        vm.listTitles = {
            first: function() {
                UtilService.get(vm.dhlTitles, 'first', null, null)
                    .then(vm.listTitles.then);
            },
            previous: function() {
                UtilService.get(vm.dhlTitles, 'prev', null, null)
                    .then(vm.listTitles.then);
            },
            next: function() {
                UtilService.get(vm.dhlTitles, 'next', null, null)
                    .then(vm.listTitles.then);
            },
            last: function() {
                UtilService.get(vm.dhlTitles, 'last', null, null)
                    .then(vm.listTitles.then);
            },
            then: function(response) {
                vm.dhlTitles = response.data;
            }
        };

        function setTooltip() {
            vm.htmlTooltip = true;
        }

        function disableTooltip() {
            vm.htmlTooltip = false;
        }

        function chooseOrDrop() {
            return $translate.instant('systemSettings.chooseOrDrop');
        }

        $scope.$watch(function() {
            var element = angular.element(document.querySelector('.html-input'));
            return element.attr('class');
        },
        function(newValue) {
            if (newValue && newValue.indexOf('ng-invalid-pattern') !== -1) {
                vm.htmlTooltip = true;
            } else if (!newValue || newValue.indexOf('ng-valid') !== -1) {
                vm.htmlTooltip = false;
            }
        });

        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'application',
            url: '/settings',
            data: {
                pageTitle: 'global.menu.settings'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['$sce', '$state', 'Principal', 'PasswordResetInit', '$filter', 'UsersService', '$translate'];

    function SettingsController($sce, $state, Principal, PasswordResetInit, $filter, UsersService, $translate) {
        var vm = this;

        //Declare variables
        vm.filter = null;
        vm.data = {
            user: {
                user: {
                    passwordExpireDate: null,
                    accountLanguage: null,
                    language: 'Polski'
                },
                lastLoginFailure: null,
                onePageDocumentShown: true
            }
        };
        vm.language = "Polski";
        vm.language1 = null;
        vm.passwordChangeSuccessText = null;
        vm.passwordChangeErrorText = null;
        vm.languageChangeSuccessText = null;
        vm.languageChangeErrorText = null;
        vm.getUserErrorText = null;
        vm.lastLoginFail = null;
        //TODO for now needs refresh to function
        vm.safePassword = $sce.trustAsHtml($translate.instant('settings.toolTips.safePassword'));
        vm.documentSettingChangeErrorText = null;
        vm.documentSettingChangeSuccessText = null;
        vm.userId = null;
        //Declare functions
        vm.init = init;
        vm.setLanguage = setLanguage;
        vm.getUser = getUser;
        vm.resetPassword = resetPassword;
        // vm.changeDocumentSetting = changeDocumentSetting; //NOT USED
        vm.clientNav = clientNav;
        vm.passwordTooltip = passwordTooltip;

        function passwordTooltip() {
            return $sce.trustAsHtml($translate.instant('settings.toolTips.safePassword'));
        }


        //Init functions
        function init() {
            if (Principal.isAuthenticated()) {
                vm.userId = Principal.getProperty('userId');
                vm.getUser();
            }
        }

        function setLanguage() {
            vm.language1 = $filter('findKeyFromLanguage')(vm.language);
            vm.data.user.user.accountLanguage = vm.language1;


            UsersService.postChanges(vm.data.user.user.ediUserId, vm.data.user.user.accountLanguage).then(function(response) {
                vm.languageChangeSuccessText = 'settings.toolTips.languageChangeSuccess';
                vm.languageChangeErrorText = null;
            }).catch(function(response) {
                vm.languageChangeSuccessText = null;
                vm.languageChangeErrorText = 'error.occurred';
            });
        }

        function getUser() {
            if (Principal.isAuthenticated()) {
                UsersService.getDetails(Principal.getProperty('userId')).then(function(response) {
                    vm.data.user = response.data;
                    vm.language = $filter('findLanguageFromKey')($filter('lowercase')(response.data.user.accountLanguage));
                }).catch(function(response) {
                    vm.data = {
                        user: {
                            user: {
                                passwordExpireDate: null,
                                accountLanguage: null,
                                language: 'Polski'
                            },
                            lastLoginFailure: null,
                            onePageDocumentShown: true
                        }
                    };
                    vm.getUserErrorText = 'error.occurred';
                });
            } else {
                vm.data = {
                    user: {
                        user: {
                            passwordExpireDate: null,
                            accountLanguage: null,
                            language: 'Polski'
                        }
                    },
                    lastLoginFailure: null,
                    onePageDocumentShown: true
                };
                vm.getUserErrorText = 'error.occurred';
            }
        }

        function resetPassword(user) {
            if (Principal.isAuthenticated()) {
                PasswordResetInit.resetPassword(vm.data.user.user.ediUserId, user).then(function(response) {
                    vm.passwordChangeSuccessText = 'settings.toolTips.passwordChangeSuccess';
                    vm.passwordChangeErrorText = null;
                }).catch(function(response) {
                    vm.passwordChangeSuccessText = null;
                    switch (response.data.message) {
                        case 1:
                            vm.passwordChangeErrorText = 'settings.toolTips.noFieldsEmpty';
                            break;
                        case 2:
                            vm.passwordChangeErrorText = 'settings.toolTips.invalidCurrentPassword';
                            break;
                        case 3:
                            vm.passwordChangeErrorText = 'global.messages.error.dontmatch';
                            break;
                        case 4:
                            vm.passwordChangeErrorText = 'settings.messages.error.minlength';
                            break;
                        case 5:
                            vm.passwordChangeErrorText = 'settings.toolTips.passwordValidationDescription';
                            break;
                        case 6:
                            vm.passwordChangeErrorText = 'settings.toolTips.passwordNoRepeat';
                            break;
                        default:
                            vm.passwordChangeErrorText = 'error.occurred';
                    }
                });
            } else {
                vm.passwordChangeErrorText = 'error.relog';
            }
        }

        //NOT USED
        // function changeDocumentSetting(documentSetting) {
        //     if (documentSetting != null && vm.data.user.user.ediUserId != null) {
        //         UsersService.setOnePagePdf(vm.data.user.user.ediUserId, documentSetting).then(function(response) {
        //             vm.documentSettingChangeSuccessText = $translate.instant('settings.toolTips.changeSuccessful');
        //             vm.documentSettingChangeErrorText = null;
        //         }).catch(function(response) {
        //             vm.documentSettingChangeSuccessText = null;
        //             vm.documentSettingChangeErrorText = $translate.instant('error.occurred');
        //         });
        //     } else {
        //         vm.documentSettingChangeSuccessText = null;
        //         vm.documentSettingChangeErrorText = $translate.instant('error.occurred');
        //     }

        // }

        function clientNav(client) {
            $state.go('client', client);
        }


        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('roles', {
            parent: 'application',
            url: '/roles',
            data: {
                pageTitle: 'global.menu.roles'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/roles/roles.html',
                    controller: 'RolesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('roles');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('RolesController', RolesController);

    RolesController.$inject = ['$uibModal', 'RolesService', 'AlertService'];

    function RolesController($uibModal, RolesService, AlertService) {
        var vm = this;

        vm.roles = [];

        vm.init = init;
        vm.goToAddRole = goToAddRole;
        vm.goToEditRole = goToEditRole;

        function goToAddRole() {
            var newUserModal = $uibModal.open({
                templateUrl: 'app/views/roles/addRole.html',
                controller: 'AddRoleController',
                controllerAs: 'vm',
                size: 'md'
            });
            newUserModal.result.then(function(response) {
                if (response.result === 'added') {
                    delete response.result;
                    vm.init();
                } else if (response.result === 'warn') {
                    delete response.result;
                    vm.init();
                    AlertService.error("roles.assignError");
                } else if (response.result === 'error') {
                    delete response.result;
                    AlertService.error("roles.addingError");
                }
            });
        }

        function goToEditRole(event, index, role) {
            var newUserModal2 = $uibModal.open({
                templateUrl: 'app/views/roles/editRole.html',
                controller: 'EditRoleController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    passRole: role
                }
            });

            newUserModal2.result.then(function(response) {
                if (response.result === 'updated' || response.result === 'deleted') {
                    delete response.result;
                    vm.init();
                } else if (response.result === 'error') {
                    delete response.result;
                    AlertService.error("roles.updateError");
                }
            });
        }

        function init() {
            RolesService.getRoles()
                .then(function(response) {
                    vm.roles = response.data._embedded.ediRoles;
                })
                .catch(function(response) {
                    AlertService.error("roles.getError");
                });
        }

        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('EditRoleController', EditRoleController);

    EditRoleController.$inject = ['$uibModalInstance','RolesService','passRole','AlertService'];

    function EditRoleController($uibModalInstance, RolesService, passRole, AlertService) {
        var vm = this;

        vm.allPermissions = [];
        vm.newRole = {
            ediRoleId:passRole.ediRoleId,
            description:passRole.description,
            roleName:passRole.roleName,
            sourceName:'DHL',
            allPermissions: []
        };

        vm.data = {
            email: null,
            password: null
        };

        vm.init = init;
        vm.toggleSelection = toggleSelection;
        vm.matchPermissions = matchPermissions;

        vm.modal = {
            update: function() {
                RolesService.updateRole(vm.newRole.ediRoleId, vm.newRole)
                    .then(function(response){
                        vm.newRole.result = "updated";
                        $uibModalInstance.close(vm.newRole);
                    })
                    .catch(function(response){
                        vm.newRole.result = "error";
                        $uibModalInstance.close(vm.newRole);
                    });
            },
            delete: function(){
                RolesService.deleteRole(passRole.ediRoleId)
                    .then(function(response){
                        vm.newRole.result = 'deleted';
                        $uibModalInstance.close(vm.newRole);
                    })
                    .catch(function(response){
                        vm.newRole.result = 'error';
                        $uibModalInstance.close(vm.newRole);
                    });
            },
            cancel: function() {
                $uibModalInstance.dismiss('cancel');
            }
        };

        function init(){
            RolesService.getPermissions()
                .then(function(response) {
                    vm.allPermissions = response.data._embedded.ediPermissions;
                    RolesService.getPermissionsByRoleId(passRole.ediRoleId)
                        .then(function(response) {
                            for(var i=0; i<response.data._embedded.ediPermissions.length; i++){
                                vm.newRole.allPermissions.push(response.data._embedded.ediPermissions[i].ediPermissionId);
                            }
                            vm.matchPermissions(vm.allPermissions, vm.newRole.allPermissions);
                        })
                        .catch(function(response) {
                            AlertService.error("roles.getPermissionsError");
                        });
                })
                .catch(function(response) {
                    AlertService.error("roles.getPermissionsError");
                });
        }

        function matchPermissions(allPermissions, rolePermissions){
            var i;
            var j;
            for (i = 0; i <  allPermissions.length; i++) {
                vm.allPermissions[i].checked = false;
                for (j = 0; j <  rolePermissions.length; j++){
                    if(allPermissions[i].ediPermissionId == rolePermissions[j]){
                        vm.allPermissions[i].checked = true;
                    }
                }
            }
        }

        function toggleSelection(event,index,permission){
            if (event.target.checked){
                vm.newRole.allPermissions.push(permission.ediPermissionId);
            }
            else{
                var i;
                for (i = 0; i <  vm.newRole.allPermissions.length; ++i) {
                    if( vm.newRole.allPermissions[i] ==  vm.allPermissions[index].ediPermissionId)
                        vm.newRole.allPermissions.splice(i, 1);
                }
            }
        }
        
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('AddRoleController', AddRoleController);

    AddRoleController.$inject = ['$uibModalInstance','RolesService', 'uuid4', 'AlertService', '$translate'];

    function AddRoleController($uibModalInstance, RolesService, uuid4, AlertService, $translate) {
        var vm = this;

        vm.allPermissions = [];
        vm.newRole = {
            description:null,
            name:null,
            sourceName:'DHL',
            allPermissions: []
        };

        //Declare functions
        vm.init = init;
        vm.toggleSelection = toggleSelection;

        //Functions implementations
        vm.modal = {
            add: function() {
                vm.newRole.ediRoleId = uuid4.generate();
                RolesService.createRole(vm.newRole)
                    .then(function(response){
                        RolesService.updateRole(vm.newRole.ediRoleId, vm.newRole)
                            .then(function(response){
                                vm.newRole.result = "added";
                                $uibModalInstance.close(vm.newRole);
                            })
                            .catch(function(response){
                                vm.newRole.result = "warn";
                                $uibModalInstance.close(vm.newRole);
                            });
                    })
                    .catch(function(response){
                        vm.newRole.result = "error";
                        $uibModalInstance.close(vm.newRole);
                    });
            },
            cancel: function() {
                $uibModalInstance.dismiss('cancel');
            }
        };

        function init(){
            RolesService.getPermissions()
                .then(function(response) {
                    vm.allPermissions = response.data._embedded.ediPermissions;
                })
                .catch(function(response) {
                    AlertService.error("roles.getPermissionsError");
                });
        }

        function toggleSelection(event,index,permission){
            if (event.target.checked){
                vm.newRole.allPermissions.push(permission.ediPermissionId);
            }
            else{
                var i;
                for (i = 0; i <  vm.newRole.permissions.length; ++i) {
                    if( vm.newRole.permissions[i] ==  vm.allPermissions[index].ediPermissionId)
                        vm.newRole.permissions.splice(i, 1);
                }
            }
        }

        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register_end', {
            parent: 'application',
            url: '/register_end',
            data: {
                pageTitle: 'global.menu.register_end'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/register/register_end.html',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'site',
            url: '/register',
            data: {
                pageTitle: 'global.menu.register'
            },
            views: {
                'content@': {
                    templateUrl: 'app/views/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('RegisterController', RegisterController);

    RegisterController.$inject = ['$scope', '$state', '$stateParams', 'UsersService', '$animate', 'uuid4', '$sce','$translate'];

    function RegisterController($scope, $state, $stateParams, UsersService, $animate, uuid4, $sce, $translate) {
        var vm = this;
        vm.translate = $translate.instant;
        $scope.invoiceNumberTooltip = $sce.trustAsHtml($translate.instant('register.invoiceNumberTooltip'));

        //Declare variables
        vm.filter = null;
        vm.data = null;
        vm.data = {
            uuid: null,
            email: null,
            nip: null,
            invoiceNr: null,
            totalAmount: null,
            clientCode: null
        };
        vm.uuid = null;

        //Declare functions
        vm.init = init;
        vm.send = send;
        vm.invalid = invalid;

        //Init functions
        function init() {
            vm.data.uuid = uuid4.generate();
        }

        function send() {
            vm.registerErrorText = null;

            var registerData = {
                uuid: vm.data.uuid,
                email: vm.data.email,
                nip: vm.data.nip,
                invoiceNumber: vm.data.invoiceNr,
                grossAmount: parseFloat(vm.data.totalAmount.replace(',', '.')),
                clientCode: vm.data.clientCode
            };

            UsersService.createNewUser(registerData).then(function(response) {
                $state.go('register_end');
            }).catch(function(response) {


            });
        }


         function invalid() {
            vm.registerErrorText=$translate.instant("register.registerErrorText");
            if($( "#dhlEmail" ).hasClass( "ng-invalid" ))
                $( "#dhlEmailLabel" ).addClass("red")
            else
                $( "#dhlEmailLabel" ).removeClass("red")

            if($( "#dhlNip" ).hasClass( "ng-invalid" ))
                $( "#dhlNipLabel" ).addClass("red")
            else
                $( "#dhlNipLabel" ).removeClass("red")

            if($( "#dhlInvoice" ).hasClass( "ng-invalid" ))
                $( "#dhlInvoicedhlLabel" ).addClass("red")
            else
                $( "#dhlInvoicedhlLabel" ).removeClass("red")

            if($( "#dhlGrossAmount" ).hasClass( "ng-invalid" ))
                $( "#dhlGrossAmountLabel" ).addClass("red")
            else
                $( "#dhlGrossAmountLabel" ).removeClass("red")

            if($( "#dhlClientCode" ).hasClass( "ng-invalid" ))
                $( "#dhlClientCodeLabel" ).addClass("red")
            else
                $( "#dhlClientCodeLabel" ).removeClass("red")
         }
        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('receivables', {
            parent: 'application',
            url: '/receivables',
            data: {
                pageTitle: 'global.menu.receivables'

            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/receivables/receivables.html',
                    controller: 'ReceivablesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('receivables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('ReceivablesController', ReceivablesController);

    ReceivablesController.$inject = ['$window', '$rootScope', '$scope', 'Principal', '$timeout', 'ReceivablesService', 'AlertService'];

    function ReceivablesController($window, $rootScope, $scope, Principal, $timeout, ReceivablesService, AlertService) {
        var vm = this;
        
        vm.getXlsxURL = getXlsxURL;
        vm.sortType = 'dateIssue';
        vm.sortReverse = true;
        vm.sort = '';

        //Declare functions exposed to view (html)
        vm.init = init;
        vm.list = list;
        vm.sortBy = sortBy;
        vm.switchHidePaid = switchHidePaid;
        vm.checkboxClicked = checkboxClicked;
        vm.redirectComplaint = redirectComplaint;
        vm.redirectDuplicate = redirectDuplicate;
        vm.closeBlockedPayersAlert = closeBlockedPayersAlert;
        vm.closeDuplicateAlert = closeDuplicateAlert;
        vm.closeComplaintAlert = closeComplaintAlert;

        //variables
        vm.selectedIndex = null;
        vm.hidePaid = true;
        vm.duplicateDisabled = null;
        vm.complaintDisabled = null;
        vm.allPaid = false;
        vm.noDocumentsFound = null;
        vm.duplicateAlertMsg = null;
        vm.complaintAlertMsg = null;
        vm.receivablesStatusDate = null;
        vm.blockedPayersList = null;
        vm.blockedPayersListMsg = null;
        vm.blockedPayersMsg = null;
        vm.invoices = [];
        vm.debtContacts = [];
        vm.showDebtContacts = false;

        vm.Principal = Principal;
        vm.window = $(window);
        vm.table = $("#fixtable[fix-table]");
        vm.topSpacer = $('#topSpacer').find("td");
        vm.bottomSpacer = $('#bottomSpacer').find("td");
        vm.topIndex = 0;
        vm.height = 31;
        vm.limit = Math.max(Math.ceil(vm.window.height() / vm.height) + 10, 50);

        vm.window.resize(function() {
            vm.height = vm.table.find("td").eq(2).outerHeight();
            vm.limit = Math.ceil(vm.window.height() / vm.height) + 10;
            vm.window.trigger("scroll");
        });

        var windowScrollTimeout;
        vm.window.scroll(function() {
            $timeout.cancel(windowScrollTimeout);

            windowScrollTimeout = $timeout(function() {
                var numberOfRows = Math.floor((vm.window.scrollTop() - vm.table.offset().top) / vm.height);
                vm.topIndex = Math.max(0, numberOfRows % 2 !== 0 ? numberOfRows + 1 : numberOfRows);
            }, 20);
        });

        $scope.$watchGroup(["vm.topIndex", "vm.height"], resizePlaceholders);

        $scope.$watchCollection("vm.invoices", resizePlaceholders);

        function resizePlaceholders() {
            vm.topSpacer.height(vm.topIndex * vm.height);
            vm.bottomSpacer.height(vm.invoices.length < vm.limit ? 0 : (vm.invoices.length - vm.limit - vm.topIndex) * vm.height);
        }

        vm.filter = {
            clientNo: null,
            hidePaid: vm.hidePaid
        };

        vm.columns = {
            clientNumber: true,
            clientName: true,
            documentNumber: true,
            dateIssue: true,
            dueDate: true,
            totalGross: true,
            left: true,
            currency: true,
            remarks: true,
            eInvoice: true
        };

        vm.columns.totalVisible = 10;

        //table header layout sometimes breaks, i.e. after alert messages shown/closed
        //workaround: refresh it by simulating page scroll
        function refreshTable() {
            var y = $(window).scrollTop();  //current position on the page
            $(window).scrollTop(y+1);   
            $(window).scrollTop(y-1);
        }

        function getInvoiceIndex(entityId) {
            var i;
            for (i = 0; i < vm.invoices.length; ++i) {
                if (vm.invoices[i].entityId === entityId)
                    return i;
            }
        }

        function checkboxClicked(event, entityId) {
            event.stopPropagation();
            if (event.target.checked) {
                if(vm.selectedIndex !== null) {
                    vm.invoices[vm.selectedIndex].selected = false;
                }
                vm.selectedIndex = getInvoiceIndex(entityId);
            } else {
                vm.selectedIndex = null;
            }
            complaintBtnCheck();
            duplicateBtnCheck();
            closeDuplicateAlert();
            closeComplaintAlert();
        }

        function duplicateBtnCheck() {
            if(vm.selectedIndex != null) {
                if(vm.invoices[vm.selectedIndex].eInvoice === false) {
                    var documentNumber = vm.invoices[vm.selectedIndex].docNumber;
                    if(documentNumber.length === 10) {
                        var prefix = documentNumber.substr(0, 2);
                        if(prefix === '11' || prefix === '21') {
                            vm.duplicateDisabled = false;
                            return;
                        }
                    }
                } else {
                    vm.duplicateDisabled = 'receivables.messages.duplicateErrorE'; //message for e-invoice
                    return;
                }
            }
            vm.duplicateDisabled = 'receivables.messages.duplicateError'; //message for paper invoice
        }

        function complaintBtnCheck() {
            if(vm.selectedIndex != null) {
                var documentNumber = vm.invoices[vm.selectedIndex].docNumber;
                var prefix = documentNumber.substr(0, 2);
                if(prefix === '11' || prefix === '21') {
                    vm.complaintDisabled = false;
                    return;
                }
            }
            vm.complaintDisabled = 'receivables.messages.complaintError';
        }

        function closeComplaintAlert() {
            vm.complaintAlertMsg = null;
            refreshTable();
        }

        function redirectComplaint() {
            if(vm.complaintDisabled) {
                if(vm.complaintAlertMsg === null) {
                    vm.complaintAlertMsg = vm.complaintDisabled;
                    refreshTable();
                }
            } else {
                closeComplaintAlert();
                $window.open("https://ecom.dhl.com.pl/reklamacjefaktur/", "_blank");
            }
        }

        function closeDuplicateAlert() {
            vm.duplicateAlertMsg = null;
            refreshTable();
        }

        function redirectDuplicate() {
            if(vm.duplicateDisabled) {
                if(vm.duplicateAlertMsg === null) {
                    vm.duplicateAlertMsg = vm.duplicateDisabled;
                    refreshTable();
                }
            } else {
                closeDuplicateAlert();
                $window.open("https://ecom.dhl.com.pl/duplikatyfaktur/", "_blank");
            }
        }

        function getBlockedPayers() {
            ReceivablesService.getBlockedPayers(Principal.getProperty('userId'))
                .then(function(response) {
                    if (response.data != null) {
                        if(response.data.length > 0) {
                            vm.blockedPayersList = response.data;
                            showBlockedPayersAlert();
                        } else {
                            vm.blockedPayersList = [];
                        }
                    }
                });
        }
        
        function payersBlockedAlert() { //checks whether alert about blocked payers should be shown
            if(!$rootScope.blockedPayersAlertClosed) {  //if user has not closed alert manually yet
                if(vm.blockedPayersList === null) { //if blocked payers have not been fetched from server yet 
                    getBlockedPayers();
                } else if (vm.blockedPayersList.length > 0) { //if there are some blocked payers show alert
                    showBlockedPayersAlert();
                }
            }
        }

        function showBlockedPayersAlert() {
            vm.blockedPayersMsg = 'receivables.messages.payersBlockedBox';
            vm.blockedPayersListMsg = vm.blockedPayersList.join(", ") + ")";
            refreshTable();
        }

        function closeBlockedPayersAlert() {
            $rootScope.blockedPayersAlertClosed = true;
            vm.blockedPayersMsg = null;
            refreshTable();
        }

        function getDebtContacts() {
            ReceivablesService.getDebtContacts(Principal.getProperty('userId'))
                .then(function(response) {
                    if (response.data != null) {
                        for (var clientNumber in response.data) {
                            vm.debtContacts.push({clientNumber: clientNumber, email: response.data[clientNumber]});
                        }
                    }
                });
        }

        function switchHidePaid() {
            vm.hidePaid = !vm.hidePaid;
            vm.filter.hidePaid = vm.hidePaid;
            if(vm.selectedIndex !== null) {
                vm.invoices[vm.selectedIndex].selected = false;
                vm.selectedIndex = null;
            }
            list(vm.filter);
        }
        
        function checkAllPaid() {
            for (var i = 0; i < vm.invoices.length; i++) {
                if(vm.invoices[i].left !== 0.0) {
                    vm.allPaid = false;
                    return;
                }
            }
            vm.allPaid = true;
        }

        
        function markLate(receivables, currentDate) {
            angular.forEach(receivables, function(receivable) {
                var datePayment = new Date(receivable.datePayment);
                if(receivable.left !== 0 && datePayment < currentDate) {
                    receivable.late = true;
                } else {
                    receivable.late = false;
                }
            });
            return receivables;
        }
        
        function list(filter) {
            vm.selectedIndex = null; //reset selected document (checkbox column)
            closeDuplicateAlert();
            closeComplaintAlert();

            var listFilter = angular.copy(filter);
            listFilter.sortBy = String(vm.sortType);
            listFilter.reverse = vm.sortReverse;
            // listFilter.columnsFromJson = null;
            ReceivablesService.list(listFilter)
                .then(function(response) {
                    if (response.data._embedded != null && response.data._embedded.dhlReceivables != null) {
                        vm.invoices = markLate(response.data._embedded.dhlReceivables, new Date());
                        vm.noDocumentsFound = false;
                    } else {
                        vm.invoices = [];
                        vm.noDocumentsFound = true;
                    }
                    checkAllPaid();
                    getReceivablesStatusDate();
                })
                .catch(function(response) {
                    vm.invoices = [];
                    vm.noDocumentsFound = true;
                    vm.receivablesStatusDate = null;
                    AlertService.error('receivables.search.error');
                });
        }

        function getReceivablesStatusDate() {
            ReceivablesService.getReceivablesStatusDate()
                .then(function(response) {
                    if (response.data != null) {
                        vm.receivablesStatusDate = response.data.date;
                    } else {
                        vm.receivablesStatusDate = "No data";
                    }
                })
                .catch(function(response) {
                    vm.receivablesStatusDate = "No data";
                })
                .finally(function() {
                    refreshTable();
                });
        }

        function sortBy(column, reverse){
            vm.sortType = column;
            vm.sortReverse = reverse;
            vm.list(vm.filter);
        }

        function getXlsxURL() {
            var listFilter = angular.copy(vm.filter);
            listFilter.sortBy = String(vm.sortType);
            listFilter.reverse = vm.sortReverse;
            listFilter.columnsFromJson = vm.columns;
            return ReceivablesService.getXlsxURL(listFilter);
        }

        function init() {
            list(vm.filter);
            if(!Principal.hasAdminReceivablesAccess()) {
                payersBlockedAlert();
            }
            if(Principal.hasUserReceivablesAccess()) {
                getDebtContacts();
                vm.showDebtContacts = true;
            }
            ReceivablesService.logReceivablesViewed();
        }

        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('RejectionController', RejectionController);

    RejectionController.$inject = ['$uibModalInstance'];

    function RejectionController($uibModalInstance) {
        var vm = this;

        vm.reason = null;

        vm.modal = {
            go: function(reason) {
                var tmp = {
                    'action': true,
                    'text': reason
                };
                $uibModalInstance.close(tmp);
            },
            cancel: function() {
                var tmp = {
                    'action': false,
                    'text': null
                };
                $uibModalInstance.close(tmp);
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('pending-cases', {
            parent: 'application',
            url: '/pending-cases',
            data: {
                pageTitle: 'global.menu.pending-cases'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/pending-cases/pending-cases.html',
                    controller: 'PendingCasesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pending-cases');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('PendingCasesController', PendingCasesController);

    PendingCasesController.$inject = ['PendingCasesService', 'AlertService', '$uibModal', 'UtilService', 'DocumentsService', '$translate'];

    function PendingCasesController(PendingCasesService, AlertService, $uibModal, UtilService, DocumentsService, $translate) {
        var vm = this;

        //Declare variables
        vm.usersToBeUpdated = [];
        vm.documentsToBeUpdated = [];
        vm.correctionsToBeUpdated = [];
        vm.users = [];
        vm.corrections = [];
        vm.documents = [];
        vm.checkAllUsersButton = true;
        vm.checkAllCorrectionsButton = true;
        vm.checkAllDocumentsButton = true;

        //Declare functions
        vm.init = init;
        vm.checkAllCorrections = checkAllCorrections;
        vm.checkAllDocuments = checkAllDocuments;
        vm.checkAllUsers = checkAllUsers;
        vm.denyCorrections = denyCorrections;
        vm.acceptCorrections = acceptCorrections;
        vm.denyDocuments = denyDocuments;
        vm.acceptDocuments = acceptDocuments;
        vm.denyUsers = denyUsers;
        vm.acceptUsers = acceptUsers;
        vm.usersCheckboxClick = usersCheckboxClick;
        vm.correctionsCheckboxClick = correctionsCheckboxClick;
        vm.documentsCheckboxClick = documentsCheckboxClick;
        vm.checkOrUncheckText = checkOrUncheckText;
        vm.getNameBySapNumber = getNameBySapNumber;
        vm.downloadPDF = downloadPDF;

        function checkOrUncheckText(condition) {
            return condition ? "pendingCases.pendingCases.selectAll" : "pendingCases.pendingCases.clearAll";
        }

        // add or remove user form usersToBeUpdated
        function usersCheckboxClick(event, index) {
            event.stopPropagation();
            if (event.target.checked) {
                vm.usersToBeUpdated.push(index);
            } else {
                var i;
                for (i = 0; i < vm.usersToBeUpdated.length; ++i) {
                    if (vm.usersToBeUpdated[i] === index) {
                        vm.usersToBeUpdated.splice(i, 1);
                    }
                }
            }
        }

        // add or remove correction form correctionsToBeUpdated
        function correctionsCheckboxClick(event, index) {
            event.stopPropagation();
            if (event.target.checked) {
                vm.correctionsToBeUpdated.push(vm.corrections[index].transactionId);
            } else {
                var i;
                for (i = 0; i < vm.correctionsToBeUpdated.length; ++i) {
                    if (vm.correctionsToBeUpdated[i] === vm.corrections[index].transactionId) {
                        vm.correctionsToBeUpdated.splice(i, 1);
                    }
                }
            }
        }

        // add or remove document form documentsToBeUpdated
        function documentsCheckboxClick(event, index) {
            event.stopPropagation();
            if (event.target.checked) {
                vm.documentsToBeUpdated.push(vm.documents[index].transactionId);
            } else {
                var i;
                for (i = 0; i < vm.documentsToBeUpdated.length; ++i) {
                    if (vm.documentsToBeUpdated[i] === vm.documents[index].transactionId) {
                        vm.documentsToBeUpdated.splice(i, 1);
                    }
                }
            }
        }

        function acceptUsers() {
            if (vm.usersToBeUpdated.length !== 0) { //if there is at least one selected user
                var usersList = [];

                var proceed = true;
                angular.forEach(vm.usersToBeUpdated, function(index) { //vm.users array indexes stored in vm.usersToBeUpdated
                    var user = vm.users[index];
                    if (!UtilService.isFilled(user.clientName) || !UtilService.isFilled(user.sapNumber)) {
                        AlertService.error("pendingCases.pendingCases.someInputEmpty");
                        proceed = false; //do not proceed with accepting, client data input is missing
                    } else {
                        usersList.push({
                            'userId': user.userId,
                            'ipAddress': user.ipAddress,
                            'email': user.email,
                            'nip': user.nip,
                            'invoiceNumber': user.invoiceNumber,
                            'invoiceValue': user.invoiceValue,
                            'sapNumber': user.sapNumber,
                            'clientName': user.clientName,
                            'payerNumber': user.payerNumber
                        });
                    }
                });

                if(proceed) {
                    PendingCasesService.usersAccepted(usersList)
                        .then(function(response) {
                            if (response.data.failed != null && Object.keys(response.data.failed).length > 0) {
                                var existingUsers = "";
                                var otherMsg = "";
                                for (var key in response.data.failed) {
                                    if (response.data.failed.hasOwnProperty(key)) {
                                        var message = response.data.failed[key].message;
                                        if (message == "pending.user.exist") {
                                            existingUsers += " " + response.data.failed[key].atrList[0];
                                        } else {
                                            otherMsg += "\n" + message;
                                        }
                                    }
                                }
                                var errors = "";
                                if (existingUsers !== "") {
                                    /*todo refactor to use dynamic translate (without $translate.instant)*/
                                    errors = $translate.instant("pendingCases.pendingCases.userExists") + existingUsers;
                                }
                                if (otherMsg !== "") {
                                    errors += otherMsg;
                                }

                                if (errors !== "") {
                                    /*todo msg function*/ AlertService.error(errors);
                                } else {
                                    AlertService.error("pendingCases.pendingCases.failedAcceptSomeUsers");
                                }
                            } else {
                                AlertService.success("pendingCases.pendingCases.successAcceptMarkedUsers");
                            }
                        })
                        .catch(function(response) {
                            AlertService.error("pendingCases.pendingCases.failedAcceptMarkedUsers");
                        })
                        .finally(function(response) {
                            getUsers();
                        });
                }
            }
        }

        function denyUsers(size) {
            if (vm.usersToBeUpdated.length !== 0) { //if there is at least one selected user
                var modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'app/views/pending-cases/rejection-modal/rejection.modal.html',
                    controller: 'RejectionController',
                    controllerAs: 'vm',
                    size: size
                });

                modalInstance.result.then(function(go) {
                    if (!go.text || /^\s*$/.test(go.text)) {
                        AlertService.error("pendingCases.pendingCases.noRejectionReason");
                        return; //do not proceed with denial if no rejection reason was provided
                    }

                    if (go.action) {
                        var usersList = [];

                        angular.forEach(vm.usersToBeUpdated, function(index) { //vm.users array indexes stored in vm.usersToBeUpdated
                            usersList.push({
                                'userId': vm.users[index].userId,
                                'rejectReason': go.text
                            });
                        });

                        PendingCasesService.usersDenied(usersList)
                            .then(function(response) {
                                if (response.data.failed == null || Object.keys(response.data.failed).length === 0) {
                                    AlertService.success("pendingCases.pendingCases.successDeniedMarkedUsers");
                                } else {
                                    AlertService.error("pendingCases.pendingCases.failedDenySomeUsers");
                                }
                            })
                            .catch(function(response) {
                                AlertService.error("pendingCases.pendingCases.failedDenyMarkedUsers");
                            })
                            .finally(function(response) {
                                getUsers();
                            });
                    }
                });
            }
        }

        function acceptCorrections() {
            if(vm.correctionsToBeUpdated.length !== 0) {
                PendingCasesService.correctionsAccepted(vm.correctionsToBeUpdated)
                    .then(function(response) {
                        if (response.data.failed == null || Object.keys(response.data.failed).length === 0) {
                            AlertService.success("pendingCases.pendingCases.acceptedCorrections");
                        } else {
                            AlertService.error("pendingCases.pendingCases.failedAcceptingSomeCorrections");
                        }
                    })
                    .catch(function(response) {
                        AlertService.error("pendingCases.pendingCases.failedAcceptingMarkedCorrections");
                    })
                    .finally(function(response) {
                        getCorrections();
                    });
            }
        }

        function denyCorrections() {
            if(vm.correctionsToBeUpdated.length !== 0) {
                PendingCasesService.correctionsDenied(vm.correctionsToBeUpdated)
                    .then(function(response) {
                        if (response.data.failed == null || Object.keys(response.data.failed).length === 0) {
                            AlertService.success("pendingCases.pendingCases.deniedCorrections");
                        } else {
                            AlertService.error("pendingCases.pendingCases.failedDenySomeCorrections");
                        }
                    })
                    .catch(function(response) {
                        AlertService.error("pendingCases.pendingCases.failedDenyCorrections");
                    })
                    .finally(function(response) {
                        getCorrections();
                    });
            }
        }

        function acceptDocuments() {
            if(vm.documentsToBeUpdated.length !== 0) {
                PendingCasesService.waitAccepted(vm.documentsToBeUpdated)
                    .then(function(response) {
                        if (response.data.failed != null && Object.keys(response.data.failed).length !== 0) {
                            var noClientDocs = "";
                            for (var key in response.data.failed) {
                                if (response.data.failed.hasOwnProperty(key)) {
                                    noClientDocs += " " + response.data.failed[key].message.split(" ").splice(-1);
                                } else {
                                    AlertService.error("pendingCases.pendingCases.failedAcceptMarkedInvoices");
                                }
                            }
                            if (noClientDocs !== "") {
                                AlertService.error('pendingCases.pendingCases.missingClients', { docs: noClientDocs } );
                            }
                        } else {
                            AlertService.success("pendingCases.pendingCases.acceptedInvoices");
                        }
                    })
                    .catch(function(response) {
                        AlertService.error("pendingCases.pendingCases.failedAcceptMarkedInvoices");
                    })
                    .finally(function(response) {
                        getClientDocuments();
                    });
            }
        }

        function denyDocuments() {
            if(vm.documentsToBeUpdated.length !== 0) {
                PendingCasesService.waitDenied(vm.documentsToBeUpdated)
                .then(function(response) {
                    if (response.data.failed == null || Object.keys(response.data.failed).length === 0) {
                        AlertService.success("pendingCases.pendingCases.successDenyMarkedInvoices");
                    } else {
                        AlertService.error("pendingCases.pendingCases.failedDenySomeInvoices");
                    }
                })
                .catch(function(response) {
                    AlertService.error("pendingCases.pendingCases.failedDenyMarkedInvoices");
                })
                .finally(function(response) {
                    getClientDocuments();
                });
            }
        }

        function checkAllUsers() {
            vm.usersToBeUpdated = []; //reset selection
            if(vm.checkAllUsersButton) { //select all
                setUserCheckboxes(true); 
                fillSelectedUsersArray();
            } else {
                setUserCheckboxes(false);
            }
            vm.checkAllUsersButton = !vm.checkAllUsersButton;
        }

        function setUserCheckboxes(checked){
            var i;
            for (i = 0; i < vm.users.length; ++i) {
                vm.users[i].selected = checked;
            }
        }
        
        function fillSelectedUsersArray(){
            var i;
            for (i = 0; i < vm.users.length; ++i) {
                vm.usersToBeUpdated.push(i);
            }
        }

        function checkAllCorrections() {
            vm.correctionsToBeUpdated = []; //reset selection
            if(vm.checkAllCorrectionsButton) { 
                selectAllDocs(vm.corrections, vm.correctionsToBeUpdated);
            } else {
                clearAllDocs(vm.corrections);
            }
            vm.checkAllCorrectionsButton = !vm.checkAllCorrectionsButton;
        }

        function checkAllDocuments() {
            vm.documentsToBeUpdated = []; //reset selection
            if(vm.checkAllDocumentsButton) {
                selectAllDocs(vm.documents, vm.documentsToBeUpdated);
            } else {
                clearAllDocs(vm.documents);
            }
            vm.checkAllDocumentsButton = !vm.checkAllDocumentsButton;
        }

        function selectAllDocs(sourceArray, selectedArray){
            angular.forEach(sourceArray, function(item) {
                item.selected = true;
                selectedArray.push(item.transactionId);
            });
        }

        function clearAllDocs(sourceArray){
            angular.forEach(sourceArray, function(item) {
                item.selected = false;
            });
        }

        function getNameBySapNumber(event, index, sapNumber) {
            if (sapNumber != null && sapNumber.length === 7) {
                PendingCasesService.getNameBySapNumber(sapNumber)
                    .then(function(response) {
                        if(response.data != null) {
                            vm.users[index].clientName = response.data.name;
                        }
                    })
                    .catch(function(response) {
                        AlertService.error("pendingCases.pendingCases.clientNotFound", { num: sapNumber } );
                    });
            }
        }

        function getCorrections() {
            PendingCasesService.getCorrections()
                .then(function(response) {
                    vm.corrections = response.data;
                })
                .catch(function(response) {
                    AlertService.error("pendingCases.pendingCases.getCorrectionsFail");
                }).finally(function(response) {
                    vm.correctionsToBeUpdated = []; //reset selection
                    vm.checkAllCorrectionsButton = true;
                });
        }

        function getClientDocuments() {
            PendingCasesService.getClientWaitDocuments()
                .then(function(response) {
                    vm.documents = response.data;
                })
                .catch(function(response) {
                    AlertService.error("pendingCases.pendingCases.getDocumentsFail");
                }).finally(function(response) {
                    vm.documentsToBeUpdated = []; //reset selection
                    vm.checkAllDocumentsButton = true;
                });
        }

        function getUsers() {
            PendingCasesService.getUsers()
                .then(function(response) {
                    vm.users = response.data;
                })
                .catch(function(response) {
                    AlertService.error("pendingCases.pendingCases.getUsersFail");
                }).finally(function(response) {
                    vm.usersToBeUpdated = []; //reset selection
                    vm.checkAllUsersButton = true;
                });
        }

        function downloadPDF(ediDocId) {
            //            PendingCasesService.getDocument(ediDocId)
            //                .then(function(response) {
            //                    var date = new Date();
            //                    FileSaver.saveAs(new Blob([response.data], { type: "application/pdf" }),
            //                        "Document_" + (date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()) + ".pdf");
            //                    if (Object.keys(response.data.failed).length != 0) {
            //                        AlertService.error('Nie udało się pobrać dokumentu.');
            //                    }
            //                })
            //                .catch(function(response) {
            //                    AlertService.error('Nie udało się pobrać dokumentu.');
            //                })
            //                .finally(function(response) {
            //                    getCorrections();
            //                });

            var url = DocumentsService.getPdfURL(ediDocId, null, null);
            window.open(url, '_blank');
        }

        function init() {
            getCorrections();
            getClientDocuments();
            getUsers();
        }

        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('pdfView', {
            parent: 'application',
            url: '/documents/:uuid/view',
            data: {
                pageTitle: 'global.menu.pdfView'

            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/pdfView/pdfView.html',
                    controller: 'PdfViewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pdfView');
                    return $translate.refresh();
                }],
                uuid: ['$stateParams', function($stateParams){
                    return $stateParams.uuid;
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('PdfViewController', PdfViewController);

    PdfViewController.$inject = ['$scope', '$state', '$stateParams', 'DocumentsService', 'Principal', "PdfViewService", 'tmhDynamicLocale', '$translate', '$http'];

    function PdfViewController($scope, $state, $stateParams, DocumentsService, Principal, PdfViewService, tmhDynamicLocale, $translate, $http) {
        var vm = this;

        vm.userOnePdfPage = null;
        vm.documentNumber = null;
        vm.tekst = $translate.instant("pdfView.downloadWhole");
        vm.translate = $translate.instant;
        vm.init = init;
        vm.getDownloadFullPdfURL = getDownloadFullPdfURL;
        vm.getDownloadXlsxURL = getDownloadXlsxURL;
        vm.downloadError = null;
//        vm.downloadXlsx = downloadXlsx;
        vm.pdfUrl = DocumentsService.getPdfURL($stateParams.uuid, false, false);
        vm.pdfViewer = './external/pdf-view/web/viewer.html?file=' + vm.pdfUrl + '#locale=' + tmhDynamicLocale.get();
        vm.isExcelAvailable = false;

        function init() {
            if ($stateParams.uuid == null) {
                $state.go('404');
            }


            if (Principal.isAuthenticated()) {
                PdfViewService.getInvoiceStylesheet($stateParams.uuid).then(function(response) {
                    vm.userOnePdfPage = response.data.stylesheet;
                    vm.documentNumber = response.data.number;
                }).catch(function(response) {
                    $state.go('404');
                });
            }

            //Check whether Excel file is ready for download
            DocumentsService.isAvailable($stateParams.uuid, "XLSX")
            .then(function(response){
                vm.isExcelAvailable = response.data;
            });
        }

        function getDownloadFullPdfURL(forceFullPDF) {
            return DocumentsService.getPdfURL($stateParams.uuid, true, forceFullPDF);
        }

        function getDownloadXlsxURL() {
            return DocumentsService.getInvoiceXlsxURL($stateParams.uuid);
        }

        //Init controller
        vm.init();

        /*
            The piece of code below shows AngularJS Loading Spinner until PDF document is not loaded. It's a workaround, beacause IFrame does not allow to capture its internal events outside.
            In order to show the spinner, we have to have at least one pending HTTP request - that's why empty object is inserted into the $http.pendingRequests array.
            When PDF document is loaded - the faked request is removed.
        */
        var loadingRequestPlaceholder = { notice: "Do not remove this object. It resides here to show AngularJS Loading Spinner. It will be removed automatically. Author: DD" };
        $http.pendingRequests.push(loadingRequestPlaceholder);

        var PDFWrapper = document.getElementById('PDFWrapper');
        PDFWrapper.onload = function() {
            $(this.contentDocument.getElementById('viewer')).one('DOMSubtreeModified', removeRequest);
        };
        $scope.$on("$destroy", function() {
            removeRequest();
        });

        function removeRequest(event) {
            var index = $http.pendingRequests.indexOf(loadingRequestPlaceholder);
            if (index !== -1) $http.pendingRequests.splice(index, 1);
            if (event)
                $scope.$apply();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password-reset-finish', {
            parent: 'application',
            url: '/user/:uuid/set-password/:link',
            data: {
                pageTitle: 'global.menu.settings'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/password-reset-finish/password-reset-finish.html',
                    controller: 'PasswordResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password-reset-finish');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                uuid: ['$stateParams', function($stateParams) {
                    return $stateParams.uuid;
                }],
                link: ['$stateParams', function($stateParams) {
                    return $stateParams.link;
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('PasswordResetFinishController', PasswordResetFinishController);

    PasswordResetFinishController.$inject = ['$sce', '$rootScope', '$state', 'Auth', 'UsersService', '$stateParams', '$translate'];

    function PasswordResetFinishController($sce, $rootScope, $state, Auth, UsersService, $stateParams, $translate) {
        var vm = this;
        vm.data = {
            password: null,
            repassword: null
        };
        vm.passwordChangeErrorText = null;
        vm.passwordChangeSuccessText = null;
        vm.safePassword = $sce.trustAsHtml($translate.instant('password-reset-finish.toolTips.safePassword'));

        vm.changeType = 1;

        //Declare functions
        vm.init = init;
        vm.resetPassword = resetPassword;
        vm.checkPasswordResetLink = checkPasswordResetLink;
        vm.translate = $translate.instant;
        vm.passwordTooltip = passwordTooltip;
        function passwordTooltip() {
                    return $sce.trustAsHtml($translate.instant('password-reset-finish.toolTips.safePassword'));
                };
        function checkPasswordResetLink() {
            UsersService.checkPasswordResetLink($stateParams.uuid, $stateParams.link).then(function(response) {
                vm.data.acceptReset = true;

                vm.changeType = response.data.message;

            }).catch(function(response) {
                $state.go('404');
            });
        }

        function resetPassword() {
            var pass = {
                password: vm.data.password,
                repassword: vm.data.repassword
            };
            UsersService.resetOwnPassword($stateParams.uuid, $stateParams.link, pass).then(function(response) {
                vm.passwordChangeErrorText = null;
                vm.passwordChangeSuccessText = $translate.instant('password-reset-finish.messages.passwordChangeSuccess');
            }).catch(function(response) {
                vm.passwordChangeSuccessText = null;
                switch (response.data.message) {
                    case 1:
                        vm.passwordChangeErrorText = $translate.instant('password-reset-finish.messages.noFieldsEmpty');
                        break;
                    case 2:
                        vm.passwordChangeErrorText = $translate.instant('global.messages.error.dontmatch');
                        break;
                    case 3:
                        vm.passwordChangeErrorText = $translate.instant('global.messages.validate.newpassword.minlength');
                        break;
                    case 4:
                        vm.passwordChangeErrorText = $translate.instant('password-reset-finish.messages.passwordValidationDescription');
                        break;
                        /*case 5:
                            vm.data.passwordResetErrort = "Hasło musi zawierać co najmninej 3 rodzaje znaków z następujących: małe litery,"+
                            " wielkie litery, cyfry, znaki specjalne";
                            break;*/
                        /*case 6:
                            vm.data.passwordResetError = "Hasło nie może powtarzać ostatnich 12 haseł.";
                            break;*/
                    case 7:
                        vm.passwordChangeErrorText = $translate.instant('password-reset-finish.messages.passwordNoRepeat');
                        break;
                    default:
                        vm.passwordChangeErrorText = $translate.instant('global.error.occurred');
                }
            });
        }

        //Init functions
        function init() {
            vm.checkPasswordResetLink();
        }

        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password-reset', {
            parent: 'site',
            url: '/password-reset',
            data: {
                pageTitle: 'password-reset.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/views/password-reset/password-reset.html',
                    controller: 'PasswordResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password-reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('PasswordResetController', PasswordResetController);

    PasswordResetController.$inject = ['$rootScope', '$state', '$translate', 'Auth', 'UsersService'];

    function PasswordResetController($rootScope, $state, $translate, Auth, UsersService) {
        var vm = this;
        vm.data = {
            email: null,
            passwordResetError: null,
            passwordResetSuccess: null
        };

        //Declare functions
        vm.init = init;
        vm.resetPassword = resetPassword;

        function resetPassword(){
            UsersService.requestResetOwnPassword(vm.data.email).then(function(response) {
                vm.data.passwordResetError = null;
                vm.data.passwordResetSuccess = $translate.instant('password-reset.after-reset');
            }).catch(function(response){
                vm.data.passwordResetError = $translate.instant('password-reset.error');
                vm.data.passwordResetSuccess = null;
            });
        }

        //Init functions
        function init() {
        }

        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password-expire', {
            parent: 'application',
            url: '/password-expire?days',
            data: {
                pageTitle: 'global.menu.password-expire'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/password-expire/password-expire.html',
                    controller: 'PasswordExpireController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('password-expire');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('PasswordExpireController', PasswordExpireController);

    PasswordExpireController.$inject = ['$scope', 'Principal', '$state', '$stateParams'];

    function PasswordExpireController ($scope, Principal, $state, $stateParams) {
        var vm = this;
        vm.passwordExpireDays = $stateParams.days;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('PasswordExpiredController', PasswordExpiredController);

    PasswordExpiredController.$inject = ['$uibModalInstance', 'param'];

    function PasswordExpiredController($uibModalInstance, param) {
        var vm = this;

        vm.data = {
            days: param
        };

        vm.modal = {
            ok: function() {
                $uibModalInstance.close();
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent: 'site',
            url: '/',
            data: {
                authorities: [],
                pageTitle: 'login.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/views/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('login');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', 'Auth', '$translate', 'AlertService', 'Principal'];

    function LoginController($rootScope, $state, Auth, $translate, AlertService, Principal) {
        var vm = this;

        //Declare functions
        vm.login = login;
        vm.loginreq = loginreq;
        vm.pwdreq = pwdreq;

		// Used to show warnings about maintanance periods
//		AlertService.success(function(){
//		    return $translate.instant()
//		});

        function loginreq() {
            return $translate.instant('login.loginreq');
        }

        function pwdreq() {
            return $translate.instant('login.pwdreq');
        }

        function login(event) {
            event.preventDefault();
            Auth.login({
                username: vm.username + '_DHL',
                password: vm.password
            }).then(function(response) {
                vm.authenticationError = false;
                $rootScope.$broadcast('authenticationSuccess');
                if (response.data.show == true) {
                    $state.go('password-expire', { days: response.data.days });
                } else {
                    logUser();
                }
            }).catch(function(response) {
                vm.authenticationError = true;
                switch (response.status) {
                    case 401:
                        Auth.isBlocked(vm.username)
                            .then(function(response) {
                                if (response.data.parameter1) {
                                    //account blocked due to too many failed logins
                                    AlertService.error('login.10times');
                                } else if (response.data.parameter2) {
                                    //password has expired
                                    AlertService.error('login.expired');
                                } else {
                                    //user does not exist
                                    AlertService.error('login.incorrect');
                                }
                            }).catch(function(response) {
                                AlertService.error('login.incorrect');
                            });
                        break;
                    case 403:
                        AlertService.error('login.auth');
                        break;
                    case 404:
                        AlertService.error('login.notfound');
                        break;
                    case 408:
                        AlertService.error('login.timeout');
                        break;
                    case 500:
                        AlertService.error('login.internal');
                        break;
                    default:
                        AlertService.error('login.failure');
                }
            });
        }

        function logUser() {
            if (angular.isDefined(Auth.getPreviousState())) {
                var previousState = Auth.getPreviousState();
                Auth.resetPreviousState();
                $state.go(previousState.name, previousState.params);
            } else {
                $state.go(Principal.hasInvoiceRead() ? 'documents' : (Principal.hasUserReceivablesAccess() || Principal.hasAdminReceivablesAccess() ? 'receivables' : 'settings'));
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('help', {
            parent: 'site',
            url: '/help',
            data: {
                pageTitle: 'global.menu.help'
            },
            views: {
                'content@': {
                    templateUrl: 'app/views/help/help.html',
                    controller: 'HelpController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('help');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('HelpController', HelpController);

    HelpController.$inject = ['$translate'];

    function HelpController($translate) {
        var vm = this;

        //Declare variables
        vm.filter = null;
        vm.data = null;
        vm.language = function() {
            return $translate.use();
        };

        //Declare functions
        vm.goToId = goToId;
        vm.goToTop = goToTop;

        function goToId(event) {
            event.preventDefault();
            // 150 below is fixed header's size
            $('html, body').animate({
                scrollTop: Math.min($(document).height() - $('body').offset().top - window.innerHeight, $(event.target.attributes.href ?
                    event.target.attributes.href.value : event.target.parentElement.attributes.href.value).offset().top - 150)
            }, 1000, 'swing');
        }

        function goToTop() {
            $('html, body').animate({
                scrollTop: Math.min($(document).height() - $('body').offset().top - window.innerHeight, $('#topid').offset().top - 150)
            }, 1000, 'swing');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'application',
                url: '/error',
                views: {
                    'content@application': {
                        templateUrl: 'app/views/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('401', {
                parent: 'error',
                url: '/401',
                data: {
                    authorities: [],
                    pageTitle: 'Nie zalogowano'
                },
                views: {
                    'error@error': {
                        templateUrl: 'app/views/error/401.html'
                    }
                }
            })
            .state('403', {
                parent: 'error',
                url: '/403',
                data: {
                    authorities: [],
                    pageTitle: 'Brak dostępu'
                },
                views: {
                    'error@error': {
                        templateUrl: 'app/views/error/403.html'
                    }
                }
            })
            .state('404', {
                parent: 'error',
                url: '/404',
                data: {
                    authorities: [],
                    pageTitle: 'Podana strona nie istnieje'
                },
                views: {
                    'error@error': {
                        templateUrl: 'app/views/error/404.html'
                    }
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('resendController', resendController);

    resendController.$inject = ['$uibModalInstance'];

    function resendController($uibModalInstance) {
        var vm = this;
        vm.resendSelect = 'same';
        vm.data = {
            email: null
        };
        vm.emailValidated = false;

        vm.validateEmail = validateEmail;

        vm.modal = {
            send: function() {
                vm.result = vm.resendSelect;
                $uibModalInstance.close(vm.data);
            },
            cancel: function() {
                $uibModalInstance.dismiss('cancel');
            }
        };
        function validateEmail(value){
            vm.emailValidated = true;
            var emailArray = value.split(";");
            emailArray.forEach(function(email) {
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if(!re.test(email)){
                    vm.emailValidated =false;
                }
            });

        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('downloadController', downloadController);

    downloadController.$inject = ['$uibModalInstance', 'ediDocIds', 'language', 'DocumentsService'];

    function downloadController($uibModalInstance, ediDocIds, language, DocumentsService) {
        var vm = this;

        vm.data = {
            downloadPDF : true,
            downloadWaybill : false,
            ediDocIds : ediDocIds
        };

        vm.getPdfsURL = getPdfsURL;

        vm.modal = {
            download: function() {
                $uibModalInstance.close();
            },
            cancel: function() {
                $uibModalInstance.dismiss('cancel');
            }
        };

        function getPdfsURL(ediDocIds, downloadPDF, downloadWaybill){
            if(isZip(ediDocIds, downloadPDF, downloadWaybill)){
                return DocumentsService.getPdfsURL(ediDocIds, downloadPDF, downloadWaybill, language);
            }else{
                return DocumentsService.getPdfURL(ediDocIds, true, null);
            }
        }

        function isZip(ediDocIds, downloadPDF, downloadWaybill){
            if (downloadPDF == true && downloadWaybill == false && ediDocIds.length === 1) {
                return false;
            }else{
                return true;
            }
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('documents', {
            parent: 'application',
            url: '/documents',
            data: {
                pageTitle: 'global.menu.documents'

            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/documents/documents.html',
                    controller: 'DocumentsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documents');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('DocumentsController', DocumentsController);

    DocumentsController.$inject = ['$scope', '$state', '$uibModal', 'DocumentsService', 'Principal', 'AlertService', '$filter', '$translate', '$timeout'];

    function DocumentsController($scope, $state, $uibModal, DocumentsService, Principal, AlertService, $filter, $translate, $timeout) {
        var vm = this;

        vm.Principal = Principal;

        //Declare variables
        vm.tempIssueDateFrom = null;
        vm.tempIssueDateTo = null;
        vm.tempDueDate = null;
        vm.translate = $translate.instant;

        vm.window = $(window);
        vm.table = $("#fixtable[fix-table]");
        vm.topSpacer = $('#topSpacer').find("td");
        vm.bottomSpacer = $('#bottomSpacer').find("td");
        vm.topIndex = 0;
        vm.height = 31;
        vm.limit = Math.max(Math.ceil(vm.window.height() / vm.height) + 10, 50);

        vm.window.resize(function() {
            vm.height = vm.table.find("td").eq(2).outerHeight();
            vm.limit = Math.ceil(vm.window.height() / vm.height) + 10;
            vm.window.trigger("scroll");
        });

        var windowScrollTimeout;
        vm.window.scroll(function() {
            $timeout.cancel(windowScrollTimeout);

            windowScrollTimeout = $timeout(function() {
                var numberOfRows = Math.floor((vm.window.scrollTop() - vm.table.offset().top) / vm.height);
                vm.topIndex = Math.max(0, numberOfRows % 2 !== 0 ? numberOfRows + 1 : numberOfRows);
            }, 20);
        });

        $scope.$watchGroup(["vm.topIndex", "vm.height"], resizePlaceholders);

        $scope.$watchCollection("vm.invoices", resizePlaceholders);

        function resizePlaceholders() {
            vm.topSpacer.height(vm.topIndex * vm.height);
            vm.bottomSpacer.height(vm.invoices.length < vm.limit ? 0 : (vm.invoices.length - vm.limit - vm.topIndex) * vm.height);
        }

        vm.columnHeaders = [{
            name: "clientNumber",
            enabled: true,
            label: "documents.document.customer"
        }, {
            name: "payerNumber",
            enabled: true,
            label: "documents.document.payer"
        }, {
            name: "dateOpen",
            enabled: Principal.hasUserRead(),
            label: "documents.document.open"
        }, {
            name: "documentType",
            enabled: true,
            label: "documents.document.docType"
        }, {
            name: "documentNumber",
            enabled: true,
            label: "documents.document.docNumber"
        }, {
            name: "dateIssue",
            enabled: true,
            label: "documents.document.issueDate"
        }, {
            name: "dateSent",
            enabled: true,
            label: "documents.document.shippingDate"
        }, {
            name: "dueDate",
            enabled: true,
            label: "documents.document.dateOfPayment"
        }, {
            name: "totalNetto",
            enabled: true,
            label: "documents.document.netAmount"
        }, {
            name: "totalVat",
            enabled: true,
            label: "documents.document.vatAmount"
        }, {
            name: "totalGross",
            enabled: true,
            label: "documents.document.grossAmount"
        }];

        vm.selectedColumns = [];

        $scope.onClose = function() {
            var footerSum = 1;
            var totalVisible = 1;
            vm.columnHeaders.forEach(function(element, index) {
                if (vm.selectedColumns.indexOf(element) !== -1) {
                    vm.columns[element.name] = true;
                    totalVisible++;
                    if (element.name.indexOf("total") === -1)
                        footerSum++;
                } else vm.columns[element.name] = false;
            });
            vm.columns.footerSum = footerSum;
            vm.columns.totalVisible = totalVisible;
            vm.columns.footer = totalVisible - footerSum > 0;

            DocumentsService.setUserColumnConf(Principal.getProperty('userId'), vm.columns);
        };

        vm.filter = {
            clientNo: null,
            payerNo: null,
            clientName: null,
            documentNoFrom: null,
            documentNoTo: null,
            waybillNo: null,
            issueDateFrom: null,
            issueDateTo: null,
            documentType: null,
            amountBruttoFrom: null,
            amountBruttoTo: null,
            dueDate: null,
            limit: 1000
        };

        vm.columns = {
            clientNumber: true,
            payerNumber: true,
            dateOpen: Principal.hasUserRead(),
            documentType: true,
            documentNumber: true,
            dateIssue: true,
            dateSent: true,
            dueDate: true,
            totalNetto: true,
            totalVat: true,
            totalGross: true,
            footer: true,
            footerSum: Principal.hasUserRead() ? 9 : 8,
            totalVisible: Principal.hasUserRead() ? 12 : 11
        };

        vm.ediDocIds = [];
        vm.invoices = [];
        vm.resultParameters = {};
        vm.sortType = 'dateIssue';
        vm.sortReverse = false;
        vm.sort = '';
        vm.sortBy = sortBy;
        vm.sumTotalNetto = 0;
        vm.sumTotalBrutto = 0;
        vm.sumTotalVat = 0;
        vm.allChecked = false;
        vm.showCarretOnOpenColumn = false;

        //Declare functions
        vm.init = init;
        vm.list = list;
        vm.checkboxClick = checkboxClick;
        vm.goToPDF = goToPDF;
        vm.getPDFs = getPDFs;
        vm.resend = resend;
        vm.resetAndList = resetAndList;
        //        vm.getXlsx = getXlsx;
        vm.showAlertAfterDocumentSend = showAlertAfterDocumentSend;
        vm.getAllDocumentNumbersAsString = getAllDocumentNumbersAsString;
        vm.getDocumentNumber = getDocumentNumber;
        vm.calculateSums = calculateSums;
        vm.checkAllDocs = checkAllDocs;
        vm.resetSearch = resetSearch;
        vm.parseClientPayerNumberToInt = parseClientPayerNumberToInt;
        vm.getUserColumnConf = getUserColumnConf;
        vm.filterInvoiceType = filterInvoiceType;
        vm.filterDateOpen = filterDateOpen;
        vm.reformatDate = reformatDate;
        vm.comparator = comparator;
        vm.checkShowColumnOpen = checkShowColumnOpen;
        vm.reformatDates = reformatDates;
        vm.getXlsxURL = getXlsxURL;

        function goToPDF(ediDoc) {
            var url = $state.href('pdfView', { uuid: ediDoc });
            window.open(url, '_blank');
        }

        function resetSearch() {
            vm.filter.clientNo = null;
            vm.filter.payerNo = null;
            vm.filter.clientName = null;
            vm.filter.documentNoFrom = null;
            vm.filter.documentNoTo = null;
            vm.filter.waybillNo = null;
            vm.filter.issueDateFrom = null;
            vm.filter.issueDateTo = null;
            vm.filter.documentType = null;
            vm.filter.amountBruttoFrom = null;
            vm.filter.amountBruttoTo = null;
            vm.filter.dueDate = null;
            vm.tempIssueDateFrom = null;
            vm.tempIssueDateTo = null;
            vm.tempDueDate = null;
        }

        function checkShowColumnOpen() {
            vm.showCarretOnOpenColumn = angular.equals(['openStatus', 'dateOpen'], vm.sortType);
        }

        function comparator(value1, value2) {
            if (value1.value == value2.value)
                return 0;
            else {
                return value1.value < value2.value ? 1 : -1;
            }
        }

        function resend() {

            AlertService.clear();

            var newUserModal = $uibModal.open({
                templateUrl: 'app/views/documents/resend.html',
                controller: 'resendController',
                controllerAs: 'vm',
                size: 'md'
            });

            newUserModal.result.then(function( /*result*/ response) {
                if (response.email == null /*'same'*/ ) {
                    delete response.result;
                    DocumentsService.resendEmailForAllDocuments(vm.ediDocIds)
                        .then(function(response) {
                            showAlertAfterDocumentSend(response);
                            list(vm.filter);
                        }).catch(function(response) {
                            AlertService.error("documents.messages.notificationFail");
                        });
                } else {
                    delete response.result;
                    var emailArray = response.email.split(";");

                    DocumentsService.resendEmailOnNewAdresses(vm.ediDocIds, emailArray)
                        .then(function(response) {
                            showAlertAfterDocumentSend(response);
                            list(vm.filter);
                        }).catch(function(response) {
                            AlertService.error("documents.messages.notificationFail");
                        });
                }
            });
        }

        function showAlertAfterDocumentSend(response) {
            if (response.data != null) {
                if (response.data.failed !== null && Object.keys(response.data.failed).length > 0) {
                    for (var key in response.data.failed) {
                        if (response.data.failed.hasOwnProperty(key)) {
                            var message = response.data.failed[key].message;
                            if (message == "document.client.not.found") {
                                AlertService.error("documents.messages.clientNotFound", { client: response.data.failed[key].atrList[0], docNum: response.data.failed[key].atrList[1] });
                            } else {
                                AlertService.error(message);
                            }
                        } else {
                            AlertService.error("documents.message.notificationFail");
                        }
                    }
                }

                if (response.data.success !== null && response.data.success.length > 0 && response.data.failed !== null && Object.keys(response.data.failed).length > 0) {
                    AlertService.success('documents.messages.notificationsSentFor', {count: response.data.success.length, docs: getAllDocumentNumbersAsString(response.data.success)} );
                } else if (response.data.success !== null && response.data.success.length > 0) {
                    AlertService.success('documents.messages.notificationsSent');
                } else if ((response.data.failed == null || Object.keys(response.data.failed).length === 0) && (response.data.success == null || Object.keys(response.data.success).length === 0)) {
                    AlertService.error('documents.messages.notificationFail');
                }
            }
        }

        function getAllDocumentNumbersAsString(ids) {
            var msg = '';
            var tmp;
            for (var id in ids) {
                msg += ((tmp = getDocumentNumber(ids[id])) !== null ? (tmp + '; ') : '');
            }
            return msg;
        }

        function getDocumentNumber(ediDocId) {
            for (var invoice in vm.invoices) {
                if (ediDocId == vm.invoices[invoice].ediDocId) {
                    return vm.invoices[invoice].documentNumber;
                }
            }
            return null;
        }

        function checkboxClick(event, index, ediDocId) {
            event.stopPropagation();
            if (event.target.checked) {
                vm.ediDocIds.push(ediDocId);
            } else {
                var i;
                for (i = 0; i < vm.ediDocIds.length; ++i) {
                    if (vm.ediDocIds[i] == ediDocId)
                        vm.ediDocIds.splice(i, 1);
                }
            }
        }

        function checkAllDocs(event) {
            event.stopPropagation();
            if (vm.allChecked) {
                vm.ediDocIds = [];
                angular.forEach(vm.invoices, function(item) {
                    item.selected = false;
                });
                vm.allChecked = false;
            } else {
                vm.ediDocIds = [];
                angular.forEach(vm.invoices, function(item) {
                    item.selected = true;
                    vm.ediDocIds.push(item.ediDocId);
                });
                vm.allChecked = true;
            }
        }

        function getPDFs() {
            var language = angular.element('#lang').controller().getLanguage();

            $uibModal.open({
                templateUrl: 'app/views/documents/download.html',
                controller: 'downloadController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    ediDocIds: function() {
                        return vm.ediDocIds;
                    },
                    language: function() {
                        return language;
                    }
                }
            });
        }

        function getXlsxURL() {
            var listFilter = angular.copy(vm.filter);
            listFilter.sortBy = String(vm.sortType);
            listFilter.reverse = vm.sortReverse;
            listFilter.columnsFromJson = vm.columns;
            reformatDates();
            return DocumentsService.getXlsxURL(listFilter);
        }

        function init() {
            if(!vm.Principal.hasAllDocumentsAccess())
                list(vm.filter);

            getUserColumnConf();
            calculateSums();
        }

        function list(filter) {
            reformatDates();
            vm.ediDocIds = [];
            var listFilter = angular.copy(filter);
            listFilter.sortBy = String(vm.sortType);
            listFilter.reverse = vm.sortReverse;
            listFilter.columnsFromJson = null;
            DocumentsService.list(listFilter)
                //If successful
                .then(function(response) {
                    //Set data to controller data
                    if (response.data._embedded != null && response.data._embedded.dhlInvoices != null) {
                        vm.invoices = response.data._embedded.dhlInvoices;
                        vm.resultParameters = response.headers();

                        if(vm.resultParameters.upper_date_bound)
                            vm.tempIssueDateTo = new Date(parseInt(vm.resultParameters.upper_date_bound));
                        if(vm.resultParameters.lower_date_bound)
                            vm.tempIssueDateFrom = new Date(parseInt(vm.resultParameters.lower_date_bound));

                    } else {
                        AlertService.error('documents.search.notFound');
                        vm.invoices = [];
                    }
                })
                .finally(function(response) {
                    calculateSums();
                    parseClientPayerNumberToInt();
                });
        }

        function calculateSums() {
            vm.sumTotalNetto = 0.00;
            vm.sumTotalBrutto = 0.00;
            vm.sumTotalVat = 0.00;
            angular.forEach(vm.invoices, function(invoice) {
                if (invoice.totalNetto != null) {
                    vm.sumTotalNetto += parseFloat(invoice.totalNetto);
                }
                if (invoice.totalGross != null) {
                    vm.sumTotalBrutto += parseFloat(invoice.totalGross);
                }
                if (invoice.totalVat != null) {
                    vm.sumTotalVat += parseFloat(invoice.totalVat);
                }
            });
            vm.sumTotalNetto = vm.sumTotalNetto.toFixed(2);
            vm.sumTotalBrutto = vm.sumTotalBrutto.toFixed(2);
            vm.sumTotalVat = vm.sumTotalVat.toFixed(2);
        }

        function parseClientPayerNumberToInt() {
            angular.forEach(vm.invoices, function(invoice) {
                invoice.clientNumber = parseInt(invoice.clientNumber);
                invoice.payerNumber = parseInt(invoice.payerNumber);
            });
        }

        function getUserColumnConf() {
            DocumentsService.getUserColumnConf(Principal.getProperty('userId'))
                //If successful
                .then(function(response) {
                    for (var property in response.data)
                        vm.columns[property] = JSON.parse(response.data[property]);

                    if (!vm.columns.footerSum)
                        vm.columns.footerSum = Principal.hasUserRead() ? 9 : 8;
                    if (!vm.columns.totalVisible)
                        vm.columns.totalVisible = Principal.hasUserRead() ? 12 : 11;

                    vm.columns.dateOpen = Principal.hasUserRead() ? vm.columns.dateOpen : false;

                    for (var column in vm.columns)
                        if (vm.columns[column] === true)
                            for (var columnHeader in vm.columnHeaders)
                                if (vm.columnHeaders[columnHeader].name === column)
                                    vm.selectedColumns.push(vm.columnHeaders[columnHeader]);
                });
        }

        function reformatDates() {
            if (vm.tempIssueDateFrom != null)
                vm.filter.issueDateFrom = reformatDate(vm.tempIssueDateFrom);
            if (vm.tempIssueDateTo != null)
                vm.filter.issueDateTo = reformatDate(vm.tempIssueDateTo);
            if (vm.tempDueDate != null)
                vm.filter.dueDate = reformatDate(vm.tempDueDate);
        }

        function reformatDate(date) {
            var result = '';


            result += date.getYear() + 1900;
            result += '-';

            result += date.getMonth() + 1;
            result += '-';
            result += date.getDate();
            return result;
        }

        function filterInvoiceType(type) {
            switch ($filter('uppercase')(type)) {
                case 'INVOICE':
                    return $translate.instant('documents.document.invoice');
                case 'CORRECTION':
                    return $translate.instant('documents.document.correctingInvoice');
                case 'NOTE':
                    return $translate.instant('documents.document.accountingNote');
                case 'ANNEX':
                    return $translate.instant('documents.document.annex');
                default:
                    return type;
            }
        }

        function filterDateOpen(status, date) {
            if (date == null) {
                if (status != null) {
                    return status;
                } else {
                    return $translate.instant('documents.document.notOpened');
                }
            } else {
                return date.substring(0, date.indexOf('T'));
            }
        }

        function sortBy(column, reverse){
            vm.sortType = column;
            vm.sortReverse = reverse;
            vm.checkShowColumnOpen();
            vm.list(vm.filter);
        }

        function resetAndList(){
            AlertService.clear();
            vm.list(vm.filter);
        }

        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('contact', {
            parent: 'site',
            url: '/contact',
            data: {
                pageTitle: 'global.menu.contact'
            },
            views: {
                'content@': {
                    templateUrl: 'app/views/contact/contact.html',
                    controller: 'ContactController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contact');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('ContactController', ContactController);

    ContactController.$inject = ['$translate'];

    function ContactController($translate) {
        var vm = this;

        vm.filter = null;
        vm.data = null;
        vm.language = function() {
            return $translate.use();
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('NewClientController', NewClientController);

    NewClientController.$inject = ['$uibModalInstance', '$scope', 'UsersService', 'uuid4', 'ClientsService', '$translate'];

    function NewClientController($uibModalInstance, $scope, UsersService, UUID, ClientsService, $translate) {
        var vm = this;
        vm.linkXlsx = $translate.instant("clients.newClient.linkXlsx");
        vm.pdfXlsx = $translate.instant("clients.newClient.pdfXlsx");
        vm.data = {
            ediClientId: UUID.generate(),
            clientNumber: "",
            payerNumber: "",
            clientName: "",
            users: [],
            clients: "",
            eInvoiceAgreement: "true",
            portalLang: "PL",
            docSending: "LINK",
            noteSending: "LINK",
            correctingDocSending: "LINK",
            nip: "",
            contactPerson: "",
            phoneNumber: "",
            notes: "",
            duplicateEmailError: null
        };

        vm.user = {
            getByEmail: function(email) {
                return UsersService.getEmailsLike({ email: email })
                    .then(function(response) {
                        return response.data._embedded.dhlUsers.map(function(user) {
                            return user.email;
                        });
                    });
            },
            add: function() {
                if (vm.data.users.map(function(user) {
                    return user.email;
                }).indexOf(vm.data.user) === -1) {
                    if (angular.isDefined(vm.data.user) && vm.data.user != "" && vm.data.user != null) {
                        vm.data.users.push({ email: vm.data.user });
                        vm.data.user = "";
                    }
                } else {
                    vm.data.duplicateEmailError = $translate.instant("clients.client.duplicateEmail");
                }
            },
            delete: function() {
                var index = vm.data.users.map(function(user) {
                    return user.email;
                }).indexOf(vm.data.user);

                if (index !== -1) {
                    vm.data.users.splice(index, 1);
                    vm.data.user = "";
                }
            }
        };

        $scope.$watch('vm.data.nip', function() {
            vm.data.nip = vm.data.nip.replace(/\D/g, '');
        });

        $scope.$watch('vm.data.payerNumber', function() {
            vm.data.payerNumber = vm.data.payerNumber.replace(/\D/g, '');
        });

        $scope.$watch('vm.data.clientNumber', function() {
            vm.data.clientNumber = vm.data.clientNumber.replace(/\D/g, '');
        });

        //Define a watch for user list select
        $scope.$watch('vm.selection', function(newValue) {
            if (newValue != null)
                vm.data.user = newValue[0].email;
        });

        vm.modal = {
            clientCheck: function() {
                if ((vm.data.clientNumber + '').length === 7) {
                    ClientsService.findByClientNumber(vm.data.clientNumber).then(function(response) {
                        if (response.data != null) {
                            vm.data.clients = vm.data.clientNumber;
                        } else {
                            vm.data.clients = '';
                        }

                    }).catch(function(response) {
                        vm.data.clients = '';
                    });
                } else {
                    vm.data.clients = '';
                }
            },
            add: function() {
                $uibModalInstance.close(vm.data);
            },
            cancel: function() {
                $uibModalInstance.dismiss('cancel');
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('ClientsController', ClientsController);

    ClientsController.$inject = ['$scope', '$state', '$stateParams', 'ClientsService', 'UtilService', 'Upload', 'API_URL', '$uibModal', 'AlertService'];

    function ClientsController($scope, $state, $stateParams, ClientsService, UtilService, Upload, API_URL, $uibModal, AlertService) {
        var vm = this;

        /*Declare variables*/
        vm.filter = {
            data: {
                size: 10,
                page: 0,
                email: "",
                clientNumber: "",
                clientName: ""
            },
            clear: function() {
                vm.filter.data.email = "";
                vm.filter.data.clientNumber = "";
                vm.filter.data.clientName = "";
            },
            save: function() {
                if (vm.data && vm.data.page)
                    vm.filter.data.page = vm.data.page.number;
                $state.transitionTo($state.current, vm.filter.data, {
                    location: true,
                    inherit: true,
                    notify: false
                });
            },
            read: function() {
                angular.copy($stateParams, vm.filter.data);
            }
        };
        vm.data = null;
        vm.actions = [];
        
        //Controller init
        vm.init = function() {
            vm.filter.read();
            if (UtilService.isFilled(vm.filter.data))
                vm.client.current();
        };

        //Navigating
        vm.nav = {
            client: function(client) {
                $state.go('client', client);
            }
        };

        //Getting clients
        vm.client = {
            //List clients
            current: function() {
                vm.filter.data.page = 0;

                ClientsService.listWithParams(vm.filter.data)
                    .then(vm.client.then);
            },
            //Go to the first page
            first: function() {
                UtilService.get(vm.data, 'first', null, null)
                    .then(vm.client.then);
            },
            //Go to the previous page
            previous: function() {
                UtilService.get(vm.data, 'prev', null, null)
                    .then(vm.client.then);
            },
            //Go to the next page
            next: function() {
                UtilService.get(vm.data, 'next', null, null)
                    .then(vm.client.then);
            },
            //Go to the last page
            last: function() {
                UtilService.get(vm.data, 'last', null, null)
                    .then(vm.client.then);
            },
            then: function(response) {
                //Set data to controller data
                vm.data = response.data;
                if (response.data._embedded == null) {
                    AlertService.error("clients.clients.clientNotFound");
                } else {
                    AlertService.clear();
                }
                //Write state to URL
                vm.filter.save();
            },
            new: function() {
                var newClientModal = $uibModal.open({
                    templateUrl: 'app/views/clients/newClient/newClient.html',
                    controller: 'NewClientController',
                    controllerAs: 'vm',
                    size: 'lg'
                });

                newClientModal.result.then(function(newClient) {
                    ClientsService.create(newClient).then(function(response) {
                        vm.client.current();
                        AlertService.success("clients.clients.clientCreated");
                    }).catch(function(response) {
                        AlertService.error("clients.clients.errorAdding");
                    });
                });
            }
        };

        vm.management = {
            file: null,
            progress: 0,
            status: '',
            message: '',
            errors: [],
            done: false,
            parse: function() {
                if (vm.management.file) {
                    vm.management.progress = 1;
                    vm.management.status = 'info';
                    vm.management.message = "clients.clients.sending";
                    vm.management.errors = [];
                    vm.management.done = false;
                    vm.actions = [];
                    Upload.http({
                        url: API_URL + 'api/dhlClients/manage/parse',
                        data: vm.management.file,
                        headers: {
                            "Content-Type": "application/octet-stream"
                        }
                    }).then(function(response) {
                        vm.management.done = true;
                        vm.management.status = 'success';
                        vm.management.message = "clients.clients.finished";
                        response.data.forEach(function(action) {
                            vm.actions.push(action);
                        });
                    }, function(response) {
                        vm.management.done = true;
                        vm.management.status = 'danger';
                        vm.management.message = "clients.clients.errorInFile";
                        vm.management.errors = response.data;
                    },
                    function(event) {
                        vm.management.progress = Math.min(100, parseInt(100.0 *
                            event.loaded / event.total));
                        if (vm.management.progress == 100) {
                            vm.management.status = null;
                            vm.management.message = "clients.clients.processing";
                        }
                    });
                }
            },
            cancel: function() {
                vm.management.progress = 0;
                vm.management.status = '';
                vm.management.message = '';
                vm.management.done = false;
                vm.actions = [];
            },
            succeed: function() {
                vm.management.cancel();
                vm.management.status = 'succeeded';
            },
            fail: function() {
                vm.management.cancel();
                vm.management.status = 'failed';
            },
            manage: function() {
                ClientsService.manage(vm.actions)
                    .then(function(response) {
                        if (response.data == null || response.data.length === 0) {
                            vm.management.succeed();
                        } else {
                            vm.actions = [];
                            vm.management.status = 'danger';
                            vm.management.message = "clients.clients.notSaved";
                            AlertService.error("clients.clients.notCreatedInfo");
                            response.data.forEach(function(action) {
                                vm.actions.push(action);
                            });
                        }
                    })
                    .catch(function(response) {
                        vm.management.fail();
                    });
            }
        };

        //Define a watch for file upload
        $scope.$watch('vm.management.file', function() {
            vm.management.parse();
        });

        //Init controller
        vm.init();

        //Position fix-table
        var fixed = $('#fixed'),
            underFixed = $('#under-fixed');
        $scope.$watch(
            function() {
                return fixed.outerHeight();
            },
            function(newValue) {
                underFixed.css('padding-top', newValue);
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('clientsPanel', {
                parent: 'application',
                url: '/clientsPanel',
                views: {
                    'content@application': {
                        templateUrl: 'app/views/clients/clientsPanel.html'
                    }
                },
                redirectTo: 'clients'
            })
            .state('clients', {
                parent: 'clientsPanel',
                url: '/clients?size&page&email&clientNumber&clientName',
                params: {
                    size: '25',
                    page: '0',
                    email: null,
                    clientNumber: null,
                    clientName: null
                },
                data: {
                    pageTitle: 'global.menu.clients'
                },
                views: {
                    'innerContent@clientsPanel': {
                        templateUrl: 'app/views/clients/clients/clients.html',
                        controller: 'ClientsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('clients');
                        return $translate.refresh();
                    }]
                }
            }).state('client', {
                parent: 'clientsPanel',
                url: '/client?clientNumber',
                params: {
                    clientNumber: null
                },
                data: {
                    pageTitle: 'global.menu.client'
                },
                views: {
                    'innerContent@clientsPanel': {
                        templateUrl: 'app/views/clients/client/client.html',
                        controller: 'ClientController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('clients');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('ClientController', ClientController);

    ClientController.$inject = ['$scope', '$state', '$stateParams', 'UsersService', 'ClientsService', 'UtilService', 'MailTemplatesService', 'filterFilter', 'Principal', 'AlertService', '$translate'];

    function ClientController($scope, $state, $stateParams, UsersService, ClientsService, UtilService, MailTemplatesService, filterFilter, Principal, AlertService, $translate) {
        var vm = this;

        vm.$onInit = function() {
            vm.filter.read();
            if (UtilService.isFilled(vm.filter.data))
                vm.client.get();
            else
                $state.go('clients');
        };

        vm.getAllEmailTemplates = getAllEmailTemplates;
        vm.getUserTemplatesId = getUserTemplatesId;
        vm.sendNewUserTemplates = sendNewUserTemplates;
        vm.getCommonElementFromLists = getCommonElementFromLists;

        vm.filter = {
            data: {
                clientNumber: ""
            },
            clear: function() {
                vm.filter.data.clientNumber = "";
            },
            save: function() {
                $state.transitionTo($state.current, vm.filter.data, {
                    location: true,
                    inherit: true,
                    notify: false
                });
            },
            read: function() {
                angular.copy($stateParams, vm.filter.data);
            }
        };

        vm.ActivityTypes = [{
            name: 'ACCOUNT_OPENED',
            text: function() {
                return $translate.instant("clients.client.accountOpen");
            }
        }, {
            name: 'EMAIL_ADDED',
            text: function() {
                return $translate.instant("clients.client.emailAdded");
            }
        }, {
            name: 'REGISTRATION_FAIL',
            text: function() {
                return $translate.instant("clients.client.registrationFail");
            }
        }, {
            name: 'PASSWORD_CHANGE',
            text: function() {
                return $translate.instant("clients.client.passwordChange");
            }
        }, {
            name: 'PAPER_INVOICE',
            text: function() {
                return $translate.instant("clients.client.paperInvoice");
            }
        }, {
            name: 'INVOICE_WITH_LINK',
            text: function() {
                return $translate.instant("clients.client.invoiceWithLink");
            }
        }, {
            name: 'INVOICE_WITH_PDF',
            text: function() {
                return $translate.instant("clients.client.invoiceWithPdf");
            }
        }, {
            name: 'INVOICE_WITH_LINK_AND_XLSX',
            text: function() {
                return $translate.instant("clients.client.invoiceWithLinkXlsx");
            }
        }, {
            name: 'INVOICE_WITH_PDF_AND_XLSX',
            text: function() {
                return $translate.instant("clients.client.invoiceWithPdfXlsx");
            }
        }, {
            name: 'CORRECTION_INVOICE',
            text: function() {
                return $translate.instant("clients.client.correctionsInvoice");
            }
        }, {
            name: 'INVOICE_TOO_LARGE',
            text: function() {
                return $translate.instant("clients.client.invoiceTooLarge");
            }
        }];

        vm.clientTemplates = {
            templates: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null
                },
                PAPER_INVOICE: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                CORRECTION_INVOICE: {
                    name: null,
                    template_id: null
                },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null
                }
            },
            titles: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null
                },
                PAPER_INVOICE: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                CORRECTION_INVOICE: {
                    name: null,
                    template_id: null
                },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null
                }
            },
            templatesEN: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null
                },
                PAPER_INVOICE: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                CORRECTION_INVOICE: {
                    name: null,
                    template_id: null
                },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null
                }
            },
            titlesEN: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null
                },
                PAPER_INVOICE: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                CORRECTION_INVOICE: {
                    name: null,
                    template_id: null
                },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null
                }
            }
        };

        vm.dhlEmailTempaltes = null;
        vm.dhlEmailTempaltesIds = null;
        vm.templatesToSend = [];

        vm.data = {
            client: null,
            user: null
        };

        //Managing client
        vm.client = {
            get: function() {
                ClientsService.findByClientNumber(vm.filter.data.clientNumber)
                    //If successful
                    .then(vm.client.then)
                    //If there were errors
                    .catch(function(response) {})
                    .finally(function(response) {});
            },
            then: function(response) {
                //Set data to controller data
                vm.data.client = response.data;

                //Get his users
                vm.client.getUsers();

                //Write state to URL
                vm.filter.save();

                //Get his templates
                vm.getAllEmailTemplates();
            },
            getUsers: function() {
                vm.data.client.users = [];
                vm.data.client.receivablesUsers = [];
                UtilService.get /*his users*/ (vm.data.client, 'dhlUsers', null, null)
                    .then(function(response) {
                        //Set users to client
                        if(response.data._embedded != null && response.data._embedded.dhlUsers != null) {
                            angular.forEach(response.data._embedded.dhlUsers, function(item) {
                                item.email = item.email.toLowerCase();  //all emails uniformly in lowercase
                                if (item.receivablesUser)
                                    vm.data.client.receivablesUsers.push(item);
                                if (item.documentsUser)
                                    vm.data.client.users.push(item);
                            });
                        }
                    });
            },
            cancel: function() {
                vm.client.get();
            },
            update: function() {
                var clientDataCopy = formatClientData(vm.data.client); //backend sends and expects both rec & doc users in one list
                ClientsService.update(clientDataCopy)
                    .then(function(response) {
                        AlertService.success("clients.client.changesSaved");
                    }).catch(function(response) {
                        AlertService.error("clients.client.saveFailed");
                    });
            }
        };

        function formatClientData(clientDataSource) {
            var clientData = JSON.parse(JSON.stringify(clientDataSource)); //create deep copy

            var allUsers = [];
            angular.forEach(clientData.receivablesUsers, function(user) {
                allUsers.push({ email: user.email, receivablesUser: true, documentsUser: false });
            });
            angular.forEach(clientData.users, function(docUser) {
                var idx = allUsers.map(
                        function(user) {
                            return user.email;
                        })
                    .indexOf(docUser.email);
                if(idx === -1)
                    allUsers.push({ email: docUser.email, receivablesUser: false, documentsUser: true });
                else
                    allUsers[idx].documentsUser = true;
            });

            delete clientData.receivablesUsers;
            clientData.users = allUsers;
            return clientData;
        }

        vm.user = {
            getByEmail: function(email) {
                if(Principal.hasUserRead()){
                    return UsersService.getEmailsLike({ email: email.toLowerCase() })
                        .then(function(response) {
                            if (!response.data._embedded) {
                                return "";
                            }
                            return response.data._embedded.dhlUsers.map(function(user) {
                                return user.email.toLowerCase();
                            });
                        });
                }
            },
            add: function() {
                if (angular.isDefined(vm.data.userEmail) && vm.data.userEmail != "" && vm.data.userEmail != null) { //if user email input provided
                    if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(vm.data.userEmail)) { //if valid email format
                        if (vm.data.client.users.map(
                                function(user) {
                                    return user.email;
                                }).indexOf(vm.data.userEmail.toLowerCase()) === -1) { //if user is not already assigned
                            vm.data.client.users.push({ email: vm.data.userEmail.toLowerCase() }); //add user
                            vm.data.userEmail = "";
                        } else {
                            AlertService.error("clients.client.duplicateEmail");
                        }
                    } else {
                        AlertService.error("clients.client.invalidEmail");
                    }
                }
            },
            
            delete: function() {
                var index = vm.data.client.users.map(function(user) {
                    return user.email;
                }).indexOf(vm.data.userEmail.toLowerCase());

                if (index !== -1) {
                    vm.data.client.users.splice(index, 1);
                    vm.data.userEmail = "";
                }
            }
        };

        //Define a watch for user list select
        $scope.$watch('vm.selection', function(newValue) {
            if (newValue != null && newValue.length !== 0) {
                vm.data.userEmail = newValue[0].email.toLowerCase();
            }
        });

        $scope.$watch('vm.data.client.nip', function() {
            if (vm.data.client && UtilService.isFilled(vm.data.client.nip))
                vm.data.client.nip = vm.data.client.nip.replace(/\D/g, '');
        });

        //Navigating
        vm.nav = {
            clients: function() {
                $state.go('clients');
            },
            user: function(user) {
                $state.go('user', user);
            }
        };

        function getAllEmailTemplates() {
            if (Principal.hasTemplateAccess()) {
                MailTemplatesService.getAllTemplates().then(function(response) {
                    if (response.data._embedded != null) {
                        vm.dhlEmailTempaltes = response.data._embedded.dhlTemplates;
                        vm.getUserTemplatesId();
                    } else {
                        vm.clientErrorText = $translate.instant('clients.client.templatesDownloadFailed');
                        vm.clientSuccessText = null;
                    }
                }).catch(function(response) {
                    vm.clientErrorText = $translate.instant("clients.client.templatesDownloadFailed");
                    vm.clientSuccessText = null;
                });
            }
        }

        function getUserTemplatesId() {
            if (Principal.hasTemplateAccess()) {
                ClientsService.getClientTemplates(vm.data.client.ediClientId).then(function(response) {
                    vm.dhlEmailTempaltesIds = response.data;

                    var id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'ACCOUNT_OPENED', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titles.ACCOUNT_OPENED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'EMAIL_ADDED', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titles.EMAIL_ADDED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'REGISTRATION_FAIL', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titles.REGISTRATION_FAIL = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'PASSWORD_CHANGE', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titles.PASSWORD_CHANGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'PAPER_INVOICE', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titles.PAPER_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_LINK', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titles.INVOICE_WITH_LINK = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titles.INVOICE_WITH_PDF = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_LINK_AND_XLSX', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titles.INVOICE_WITH_LINK_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF_AND_XLSX', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titles.INVOICE_WITH_PDF_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'CORRECTION_INVOICE', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titles.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_TOO_LARGE', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titles.INVOICE_TOO_LARGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];




                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'ACCOUNT_OPENED', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templates.ACCOUNT_OPENED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'EMAIL_ADDED', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templates.EMAIL_ADDED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'REGISTRATION_FAIL', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templates.REGISTRATION_FAIL = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'PASSWORD_CHANGE', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templates.PASSWORD_CHANGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'PAPER_INVOICE', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templates.PAPER_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_LINK', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templates.INVOICE_WITH_LINK = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templates.INVOICE_WITH_PDF = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_LINK_AND_XLSX', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templates.INVOICE_WITH_LINK_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF_AND_XLSX', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templates.INVOICE_WITH_PDF_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'CORRECTION_INVOICE', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templates.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_TOO_LARGE', language: 'pl' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templates.INVOICE_TOO_LARGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];




                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'ACCOUNT_OPENED', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.ACCOUNT_OPENED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'EMAIL_ADDED', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.EMAIL_ADDED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'REGISTRATION_FAIL', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.REGISTRATION_FAIL = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'PASSWORD_CHANGE', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.PASSWORD_CHANGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'PAPER_INVOICE', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.PAPER_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_LINK', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.INVOICE_WITH_LINK = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.INVOICE_WITH_PDF = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_LINK_AND_XLSX', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.INVOICE_WITH_LINK_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF_AND_XLSX', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.INVOICE_WITH_PDF_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'CORRECTION_INVOICE', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_TOO_LARGE', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.INVOICE_TOO_LARGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];




                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'ACCOUNT_OPENED', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.ACCOUNT_OPENED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'EMAIL_ADDED', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.EMAIL_ADDED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'REGISTRATION_FAIL', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.REGISTRATION_FAIL = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'PASSWORD_CHANGE', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.PASSWORD_CHANGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'PAPER_INVOICE', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.PAPER_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_LINK', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.INVOICE_WITH_LINK = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.INVOICE_WITH_PDF = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_LINK_AND_XLSX', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.INVOICE_WITH_LINK_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF_AND_XLSX', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.INVOICE_WITH_PDF_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'CORRECTION_INVOICE', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_TOO_LARGE', language: 'en' }, true), vm.dhlEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.INVOICE_TOO_LARGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                }).catch(function(response) {
                    vm.clientErrorText = $translate.instant("clients.client.templatesDownloadFailed");
                    vm.clientSuccessText = null;
                });
            }
        }

        function getCommonElementFromLists(list1, list2) {
            var id;
            angular.forEach(list1, function(value, key) {
                if (list2.indexOf(value.ediTemplateId) > -1) {
                    id = value.ediTemplateId;
                }
            });
            return id;
        }

        //client + listofid
        function sendNewUserTemplates() {
            if (Principal.hasTemplateAccess()) {
                vm.templatesToSend = [];

                vm.templatesToSend.push(vm.clientTemplates.titles.ACCOUNT_OPENED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titles.EMAIL_ADDED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titles.REGISTRATION_FAIL.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titles.PASSWORD_CHANGE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titles.PAPER_INVOICE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titles.INVOICE_WITH_LINK.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titles.INVOICE_WITH_PDF.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titles.INVOICE_WITH_LINK_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titles.INVOICE_WITH_PDF_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titles.CORRECTION_INVOICE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titles.INVOICE_TOO_LARGE.ediTemplateId);

                vm.templatesToSend.push(vm.clientTemplates.templates.ACCOUNT_OPENED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templates.EMAIL_ADDED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templates.REGISTRATION_FAIL.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templates.PASSWORD_CHANGE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templates.PAPER_INVOICE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templates.INVOICE_WITH_LINK.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templates.INVOICE_WITH_PDF.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templates.INVOICE_WITH_LINK_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templates.INVOICE_WITH_PDF_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templates.CORRECTION_INVOICE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templates.INVOICE_TOO_LARGE.ediTemplateId);

                vm.templatesToSend.push(vm.clientTemplates.titlesEN.ACCOUNT_OPENED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.EMAIL_ADDED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.REGISTRATION_FAIL.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.PASSWORD_CHANGE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.PAPER_INVOICE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.INVOICE_WITH_LINK.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.INVOICE_WITH_PDF.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.INVOICE_WITH_LINK_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.INVOICE_WITH_PDF_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.CORRECTION_INVOICE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.INVOICE_TOO_LARGE.ediTemplateId);

                vm.templatesToSend.push(vm.clientTemplates.templatesEN.ACCOUNT_OPENED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.EMAIL_ADDED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.REGISTRATION_FAIL.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.PASSWORD_CHANGE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.PAPER_INVOICE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.INVOICE_WITH_LINK.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.INVOICE_WITH_PDF.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.INVOICE_WITH_LINK_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.INVOICE_WITH_PDF_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.CORRECTION_INVOICE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.INVOICE_TOO_LARGE.ediTemplateId);


                ClientsService.postClientTemplates(vm.data.client.ediClientId, vm.templatesToSend).then(function(response) {
                    vm.clientErrorText = null;
                    vm.clientSuccessText = $translate.instant("clients.client.templatesEditSuccess");
                }).catch(function(response) {
                    vm.clientErrorText = $translate.instant("clients.client.templatesEditFail");
                    vm.clientSuccessText = null;
                });
            }
        }
    }
})();
;
(function () {
  'use strict';

  angular
    .module('edistradadhluiApp')
    .factory('VersionCheck', VersionCheck);

  VersionCheck.$inject = ['$http', '$window', '$q', 'VERSION'];

  function VersionCheck($http, $window, $q, VERSION) {

    var reloadedKey = 'version_reloaded_from_' + VERSION;
    var LAST_CHECK_TS_KEY = 'version_last_check_ts';
    var MIN_INTERVAL_MS = 30 * 1000;

    function shouldSkipCheck() {
      try {
        var last = parseInt($window.sessionStorage.getItem(LAST_CHECK_TS_KEY) || '0', 10);
        return (Date.now() - last) < MIN_INTERVAL_MS;
      } catch (e) {
        return false;
      }
    }

    function markCheckedNow() {
      try {
        $window.sessionStorage.setItem(LAST_CHECK_TS_KEY, String(Date.now()));
      } catch (e) {}
    }

    function safeReloadOnce() {
      try {
        if ($window.sessionStorage.getItem(reloadedKey) === '1') return;
        $window.sessionStorage.setItem(reloadedKey, '1');
      } catch (e) {}
      $window.location.reload(true);
    }

    function checkAndReloadIfNeeded() {
      if (shouldSkipCheck()) {
        return $q.resolve();
      }
      markCheckedNow();

      return $http.get('version.json', {
        cache: false,
        params: { t: Date.now() }
      }).then(function (resp) {
        var serverVersion = resp && resp.data && resp.data.version ? String(resp.data.version) : null;
        if (!serverVersion) return;

        if (serverVersion !== String(VERSION)) {
          safeReloadOnce();
        }
      }).catch(function () {
      });
    }

    return {
      checkAndReloadIfNeeded: checkAndReloadIfNeeded
    };
  }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('UtilService', UtilService);

    UtilService.$inject = ['$http'];

    function UtilService($http) {
        var Srvc = {
            get: get,
            isFilled: isFilled,
            nullsToEmptyStrings: nullsToEmptyStrings,
            emptyStringsToNulls: emptyStringsToNulls,
            starsToPercents: starsToPercents
        };

        return Srvc;

        function get(from, what, filter, data) {
            return $http({
                method: 'GET',
                url: removeCacheBuster(from._links[what].href),
                params: filter,
                data: data
            });
        }

        function removeCacheBuster(url) {
            var tempUrl = url.replace(new RegExp('&amp;', 'g'), '&');
            var cacheBusterIndex = tempUrl.indexOf("cacheBuster");
            if (cacheBusterIndex !== -1) {
                var nextAmpersandIndex = tempUrl.indexOf("&", cacheBusterIndex);

                if (nextAmpersandIndex !== -1)
                    tempUrl = tempUrl.substr(0, cacheBusterIndex) + tempUrl.substr(nextAmpersandIndex, tempUrl.length);
                else
                    tempUrl = tempUrl.substr(0, cacheBusterIndex);
            }
            return tempUrl;
        }

        function isFilled(object) {
            if (object != null && object !== '' && object === object)
                return true;
            if (typeof object === 'object') {
                for (var param in object) {
                    if (isFilled(object[param]))
                        return true;
                }
            }
            return false;
        }

        function nullsToEmptyStrings(filter) {
            var requestFilter = angular.copy(filter);

            for (var fieldIndex in requestFilter) {
                if (requestFilter[fieldIndex] == null) {
                    requestFilter[fieldIndex] = "";
                }
            }
            return requestFilter;
        }

        function emptyStringsToNulls(filter) {
            var requestFilter = angular.copy(filter);

            for (var fieldIndex in requestFilter) {
                if (requestFilter[fieldIndex] == "") {
                    requestFilter[fieldIndex] = null;
                }
            }
            return requestFilter;
        }



        function starsToPercents(filter) {
            var requestFilter = angular.copy(filter);

            for (var fieldIndex in requestFilter) {
                if (typeof requestFilter[fieldIndex] == "string")
                    requestFilter[fieldIndex] = requestFilter[fieldIndex].replace(/\*/g, '%');
                else if (requestFilter[fieldIndex] instanceof Array)
                    for (var element in requestFilter[fieldIndex])
                        requestFilter[fieldIndex][element] = requestFilter[fieldIndex][element].replace(/\*/g, '%');
            }
            return requestFilter;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$q', '$http'];

    function ProfileService($q, $http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerDisabled = result.data.activeProfiles.indexOf("no-swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('UsersService', UsersService);

    UsersService.$inject = ['API_URL', '$http', 'UtilService', 'GenerateURL'];

    function UsersService(API_URL, $http, UtilService, GenerateURL) {
        var usersService = {
            activate: activate,
            activityReport: activityReport,
            addClient: addClient,
            changeRoles: changeRoles,
            checkNewUsersPasswordValid: checkNewUsersPasswordValid,
            checkPasswordExpireDays: checkPasswordExpireDays,
            checkPasswordResetLink: checkPasswordResetLink,
            create: create,
            createNewUser: createNewUser,
            deactivate: deactivate,
            delete: deleteUser,
            hasReceivablesClients: hasReceivablesClients,
            findByEmail: findByEmail,
            get: get,
            getDetails: getDetails,
            getEmailsLike: getEmailsLike,
            getUserDates: getUserDates,
            getFirstActivationDate: getFirstActivationDate,
            getLastActivityDate: getLastActivityDate,
            getLastFailedLoginDate: getLastFailedLoginDate,
            getLastFailLoginDate: getLastFailLoginDate,
            getLastSuccessfulLoginDate: getLastSuccessfulLoginDate,
            getOnePagePdfConfiguration: getOnePagePdfConfiguration,
            isEmailUnique: isEmailUnique,
            list: list,
            listWithParams: listWithParams,
            isLocked: isLocked,
            postChanges: postChanges,
            getLanguage: getLanguage,
            removeAllClients: removeAllClients,
            removeClient: removeClient,
            requestResetOwnPassword: requestResetOwnPassword,
            resetOwnPassword: resetOwnPassword,
            resetPassword: resetPassword,
            setOnePagePdf: setOnePagePdf,
            hasDocumentsAccess: hasDocumentsAccess,
            unlockDocuments: unlockDocuments,
            lockDocuments: lockDocuments,
            unlock: unlock,
            lock: lock,
            usersReport: usersReport,
            getActivityReportURL: getActivityReportURL,
            getUsersReportURL: getUsersReportURL
        };

        return usersService;

        function get(email) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/search/getByEmailContainingIgnoreCase',
                params: { email: email.toLowerCase() }
            });
        }

        function list(filter) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers',
                params: UtilService.nullsToEmptyStrings(filter)
            });
        }

        function listWithParams(filter) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/findDhlUsers',
                params: UtilService.starsToPercents(UtilService.nullsToEmptyStrings(filter))
            });
        }

        function getEmailsLike(email) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/search/findByEmailContainingIgnoreCase',
                params: UtilService.starsToPercents(UtilService.nullsToEmptyStrings(email))
            });
        }

        function create(user) {
            return $http({
                method: 'PUT',
                url: API_URL + 'api/dhlUsers/create',
                data: user
            });
        }

        function deleteUser(UUID) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + UUID + '/delete'
            });
        }

        function hasReceivablesClients(UUID) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + UUID + '/hasReceivablesClients'
            });
        }

        function hasDocumentsAccess(id) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + id + '/hasDocumentsAccess'
            });
        }

        function unlockDocuments(id) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + id + '/unlockDocuments'
            });
        }

        function lockDocuments(id) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + id + '/lockDocuments'
            });
        }

        function unlock(id) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + id + '/unlock'
            });
        }

        function lock(id) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + id + '/lock'
            });
        }

        function resetPassword(id) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + id + '/resetPassword'
            });
        }

        function activate(id) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + id + '/activate'
            });
        }

        function deactivate(id) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + id + '/deactivate'
            });
        }

        function changeRoles(id, roles) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + id + '/roles/change',
                data: { 'roleNames': roles }
            });
        }

        function usersReport(filter) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/reports/users',
                params: UtilService.starsToPercents(UtilService.nullsToEmptyStrings(filter)),
                responseType: 'arraybuffer'
            });
        }

        function activityReport(filter) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/reports/activity',
                params: UtilService.starsToPercents(UtilService.nullsToEmptyStrings(filter)),
                responseType: 'arraybuffer'
            });
        }

        function addClient(userId, email, clientNumber) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + userId + '/clients/add',
                params: { email: email, clientNumber: clientNumber }
            });
        }

        function removeClient(userId, email, clientNumber) {
            return $http({
                method: 'DELETE',
                url: API_URL + 'api/dhlUsers/' + userId + '/clients/remove',
                params: { email: email, clientNumber: clientNumber }
            });
        }

        function removeAllClients(userId, email) {
            return $http({
                method: 'DELETE',
                url: API_URL + 'api/dhlUsers/' + userId + '/clients/removeAll',
                params: { email: email }
            });
        }

        function findByEmail(email) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/byEmail/' + email.toLowerCase()
            });
        }

        function postChanges(userId, language) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + userId + '/editLanguage',
                params: { language: language }
            });
        }

        function getLanguage(userId) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + userId + '/language'
            });
        }

        function getLastFailLoginDate(name) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/ediPartyUsersByName/' + name
            });
        }

        function setOnePagePdf(userId, onePagePdf) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + userId + '/PdfPagesShow/edit',
                params: { onePagePdf: onePagePdf }
            });
        }

        function getOnePagePdfConfiguration(userId) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + userId + '/getUserOnePagePdfConfiguration'
            });
        }

        function createNewUser(registerData) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/registerRequest',
                data: registerData
            });
        }

        function isEmailUnique(email) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/isUniqueEmail',
                params: { email: email.toLowerCase() }
            });
        }

        function getDetails(uuid) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + uuid + '/getFullDetails'
            });
        }

        function getUserDates(uuid) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + uuid + '/dates'
            });
        }

        function getFirstActivationDate(uuid) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + uuid + '/firstActivationDate'
            });
        }

        function getLastActivityDate(uuid) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + uuid + '/lastActivityDate'
            });
        }

        function getLastFailedLoginDate(uuid) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + uuid + '/lastFailedLoginDate'
            });
        }

        function getLastSuccessfulLoginDate(uuid) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + uuid + '/lastSuccessfulLoginDate',
                params: { id: uuid }
            });
        }

        function requestResetOwnPassword(email) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/requestResetOwnPasswordRequest',
                params: { email: email.toLowerCase() }
            });
        }

        function checkPasswordExpireDays(uuid) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + uuid + '/checkPasswordExpireDays'
            });
        }

        function checkNewUsersPasswordValid(password) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/isPasswordValid',
                data: password
            });
        }

        function checkPasswordResetLink(uuid, link) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + uuid + '/setPassword/' + link
            });
        }

        function resetOwnPassword(uuid, link, password) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + uuid + '/setPassword/' + link,
                data: password
            });
        }

        function isLocked(uuid) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + uuid + '/lock'
            });
        }

        function getUsersReportURL(filter) {
            var params = UtilService.starsToPercents(UtilService.nullsToEmptyStrings(filter));
            var baseURL = API_URL + 'api/dhlUsers/reports/users';

            return GenerateURL.generate(baseURL, params);
        }

        function getActivityReportURL(filter) {
            var params = UtilService.starsToPercents(UtilService.nullsToEmptyStrings(filter));
            var baseURL =  API_URL + 'api/dhlUsers/reports/activity';

            return GenerateURL.generate(baseURL, params);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('RolesService', RolesService);

    RolesService.$inject = ['API_URL', '$http'];

    function RolesService(API_URL, $http) {
        var service = {
            list: list,
            getRoles: getRoles,
            getPermissions: getPermissions,
            getPermissionsByRoleId: getPermissionsByRoleId,
            createRole: createRole,
            updateRole: updateRole,
            deleteRole: deleteRole
        };

        return service;

        function list() {
            return $http({
                method: 'GET',
                url: API_URL + 'api/ediRoles'
            });
        }

        function getRoles() {
            return $http({
                method: 'GET',
                url: API_URL + 'api/ediRoles?size=2147483647'
            });
        }

        function getPermissions() {
            return $http({
                method: 'GET',
                url: API_URL + 'api/ediPermissions'
            });
        }

        function getPermissionsByRoleId(roleId) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/ediRoles/'+roleId+'/permissions'
            });
        }

        function createRole(role) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/ediRoles',
                data: role
            });
        }

        function updateRole(roleId, role) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/ediRoles/' + roleId + '/update',
                data: role
            });
        }

        function deleteRole(roleId) {
            return $http({
                method: 'DELETE',
                url: API_URL + 'api/ediRoles/' + roleId
            });
        }
    }
})();
;
(function() {    
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('ReceivablesService', ReceivablesService);

    ReceivablesService.$inject = ['API_URL', '$http', 'UtilService', 'GenerateURL'];

    function ReceivablesService(API_URL, $http, UtilService, GenerateURL) {
        var service = {
            list: list,
            getXlsxURL: getXlsxURL,
            getBlockedPayers: getBlockedPayers,
            getDebtContacts: getDebtContacts,
            getReceivablesStatusDate: getReceivablesStatusDate,
            logReceivablesViewed: logReceivablesViewed
        };

        return service;

        function list(filter) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlReceivables/getLimited',
                data: UtilService.starsToPercents(filter)
            });
        }

        // function getXlsx(filter) {
        //     return $http({
        //         method: 'POST',
        //         url: API_URL + 'api/dhlReceivables/getAsExcelByCustomCriteria',
        //         data: UtilService.starsToPercents(filter),
        //         responseType: 'arraybuffer'
        //     });
        // }

        function logReceivablesViewed() {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlReceivables/logViewed'
            });
        }

        function getXlsxURL(filter) {
            var params = UtilService.starsToPercents(filter);
            var baseURL = API_URL + 'api/dhlReceivables/getAsExcelByCustomCriteria';
            return GenerateURL.generate(baseURL, params);
        }

        function getBlockedPayers(userId) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlClients/blocked',
                params: { userId: userId }
            });
        }

        function getDebtContacts(userId) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlClients/debtCollectors',
                params: { userId: userId }
            });
        }

        function getReceivablesStatusDate() {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlReceivables/getReceivableLastDate'
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('PendingCasesService', PendingCasesService);

    PendingCasesService.$inject = ['API_URL', '$http'];

    function PendingCasesService (API_URL, $http) {
        var service = {
//            getDocument : getDocument,
            getCorrections : getCorrections,
            getClientWaitDocuments: getClientWaitDocuments,
            getNameBySapNumber : getNameBySapNumber,
            getUsers : getUsers,
            usersAccepted : usersAccepted,
            usersDenied : usersDenied,
            correctionsAccepted : correctionsAccepted,
            correctionsDenied : correctionsDenied,
            waitAccepted : waitAccepted,
            waitDenied : waitDenied
        };

        return service;
        function getNameBySapNumber(SapNumber){
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlClients/getName',
                params : {'clientNumber': SapNumber}
            });
        }
        function getCorrections(){
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlInvoices/pendingInvoices'
            });
        }
        function getClientWaitDocuments(){
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlInvoices/clientWaitInvoices'
            });
        }
        function getUsers(){
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/notActive'
            });
        }
        function usersAccepted(UIDs){
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/acceptAll',
                data : UIDs //byc moze nie zalapie nazwy
            });
        }
        function usersDenied(UIDs){
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/rejectAll',
                data : UIDs
            });
        }
        function correctionsAccepted(ediDocIds){
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlInvoices/approveAll',
                data: ediDocIds
            });
        }
        function correctionsDenied(ediDocIds){
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlInvoices/rejectAll',
                data : ediDocIds
            });
        }
        function waitAccepted(ediDocIds){
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlInvoices/approveWait',
                data: ediDocIds
            });
        }
        function waitDenied(ediDocIds){
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlInvoices/rejectWait',
                data : ediDocIds
            });
        }
//        function getDocument(ediDocId){
//            return $http({
//                method: 'GET',
//                url: API_URL + 'api/dhlInvoices/' + ediDocId + '/getPdf',
//                responseType: 'arraybuffer'
//            });
//        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('PdfViewService', PdfViewService);

    PdfViewService.$inject = ['API_URL', '$http', 'GenerateURL'];

    function PdfViewService(API_URL, $http, GenerateURL) {
        var service = {
            getFirstPagePdf: getFirstPagePdf,
            getInvoiceStylesheet: getInvoiceStylesheet
        };

        return service;





        function getInvoiceStylesheet(EdiDocId) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlInvoices/' + EdiDocId + '/getInvoiceStylesheet'
            });
        }

        function getFirstPagePdf(EdiDocId) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlInvoices/' + EdiDocId + '/getFirstPagePdf',
                responseType: 'arraybuffer'
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('MailTemplatesService', MailTemplatesService);

    MailTemplatesService.$inject = ['API_URL', '$http'];

    function MailTemplatesService(API_URL, $http) {
        var service = {
            checkUnique: checkUnique,
            getTemplatesByType: getTemplatesByType,
            download: download,
            addTemplateTitle: addTemplateTitle,
            getAllTemplates: getAllTemplates
        };

        return service;

        function checkUnique(name, actionType, language, type) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlTemplates/isTemplateUnique',
                params: { 'name': name, 'actionType': actionType, 'language': language, 'type': type }
            });
        }

        function getTemplatesByType(type) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlTemplates/search/findByType',
                params: { 'type': type, 'size': 10 }
            });
        }

        function download(name, actionType, language) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlTemplates/download',
                params: { 'name': name, 'actionType': actionType, 'language': language },
                responseType: 'arraybuffer'
            });
        }

        function addTemplateTitle(name, actionType, text, language) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlTemplates/add',
                params: { 'name': name, 'actionType': actionType, 'text': text, 'language': language, 'type': 'EMAIL_TITLE' }
            });
        }

        function getAllTemplates() {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlTemplates/search/findAllBy'
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('DocumentsService', DocumentsService);

    DocumentsService.$inject = ['API_URL', '$http', '$httpParamSerializer', 'UtilService', 'GenerateURL'];

    function DocumentsService(API_URL, $http, $httpParamSerializer, UtilService, GenerateURL) {
        var service = {
            list: list,
            getUserColumnConf: getUserColumnConf,
            setUserColumnConf: setUserColumnConf,
            getPdf: getPdf,
            getXlsx: getXlsx,
            getPdfs: getPdfs,
            resendEmailForAllDocuments: resendEmailForAllDocuments,
            resendEmailOnNewAdresses: resendEmailOnNewAdresses,
            getPdfURL: getPdfURL,
            getInvoiceXlsxURL: getInvoiceXlsxURL,
            getPdfsURL: getPdfsURL,
            getXlsxURL: getXlsxURL,
            isAvailable: isAvailable
        };

        return service;

        function list(filter) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlInvoices/getLimited',
                data: UtilService.starsToPercents(filter)
            });
        }

        function getUserColumnConf(UID) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlUsers/' + UID + '/userConf',

            });
        }

        function setUserColumnConf(UID, columnConf) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + UID + '/userConf',
                data: columnConf
            });
        }

        function getPdf(EdiDocId) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlInvoices/' + EdiDocId + '/pdf',
                responseType: 'arraybuffer'
            });
        }

        function getXlsx(filter) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlInvoices/getAsExcelByCustomCriteria',
                data: UtilService.starsToPercents(filter), //filter,
                responseType: 'arraybuffer'
            });
        }

        function getPdfs(EdiDocIds, includePdf, includeScan, language) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlInvoices/getPdfs',
                params: {
                    ids: EdiDocIds,
                    includePdf: includePdf,
                    includeScan: includeScan,
                    language: language
                },
                responseType: 'arraybuffer'
            });
        }

        function getPdfsURL(EdiDocIds, includePdf, includeScan, language) {
            var params = {
                ids: EdiDocIds,
                includePdf: includePdf,
                includeScan: includeScan,
                language: language
            };
            var serializedParams = $httpParamSerializer(params);
            var baseURL = API_URL + 'api/dhlInvoices/downloadPdfs';
            if (serializedParams.length > 0) {
                baseURL += ((baseURL.indexOf('?') === -1) ? '?' : '&') + serializedParams;
            }

            return baseURL;
        }

        function resendEmailForAllDocuments(EdiDocIds) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlInvoices/resendEmails',
                data: EdiDocIds
            });
        }

        function resendEmailOnNewAdresses(EdiDocIds, Emails) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlInvoices/sendNewEmails',
                data: {
                    docIds: EdiDocIds,
                    emails: Emails
                }
            });
        }


        function getPdfURL(EdiDocId, download, forceFullDocument) {
            var params = { "download": download, "forceFullDocument": forceFullDocument };
            var baseURL = API_URL + 'api/dhlInvoices/' + EdiDocId + '/pdf';

            return GenerateURL.generate(baseURL, params);
        }


        function getInvoiceXlsxURL(EdiDocId) {
            var params = {};
            var baseURL = API_URL + 'api/dhlInvoices/' + EdiDocId + '/xlsx';

            return GenerateURL.generate(baseURL, params);
        }

        function getXlsxURL(filter) {
            var params = UtilService.starsToPercents(filter);
            var baseURL = API_URL + 'api/dhlInvoices/getAsExcelByCustomCriteria';
            return GenerateURL.generate(baseURL, params);
        }

        function isAvailable(uuid, type) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlInvoices/isAvailable',
                params: {
                    documentId: uuid,
                    documentType: type
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('ConstantsService', ConstantsService);

    ConstantsService.$inject = ['API_URL', '$http'];

    function ConstantsService(API_URL, $http) {
        var service = {
            set: set,
            get: get
        };

        return service;

        function set(interval) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlConstants/set',
                data: interval
            });
        }

        function get(constantName) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlConstants/search/findByName',
                params: { name: constantName }
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('ClientsService', ClientsService);

    ClientsService.$inject = ['API_URL', '$http', 'UtilService'];

    function ClientsService(API_URL, $http, UtilService) {
        var service = {
            create: create,
            findByClientNumber: findByClientNumber,
            getClientTemplates: getClientTemplates,
            list: list,
            listByUserEmail: listByUserEmail,
            listWithParams: listWithParams,
            manage: manage,
            parseManagementFile: parseManagementFile,
            postClientTemplates: postClientTemplates,
            update: update,
            getVersion: getVersion
        };

        return service;

        function list(filter) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlClients',
                params: filter
            });
        }

        function getVersion() {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlInvoices/version'
            });
        }

        function listWithParams(filter) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlClients/findDhlClients',
                params: UtilService.starsToPercents(UtilService.nullsToEmptyStrings(filter))
            });
        }

        function create(client) {
            return $http({
                method: 'PUT',
                url: API_URL + 'api/dhlClients/create',
                data: UtilService.emptyStringsToNulls(client)
            });
        }

        function update(client) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlClients/update',
                data: client
            });
        }

        function listByUserEmail(filter) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlClients/search/findAllWithClientsByEmail',
                params: filter
            });
        }

        function findByClientNumber(clientNumber) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlClients/search/findByClientNumber',
                params: { 'clientNumber': clientNumber }
            });
        }

        function parseManagementFile(file) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlClients/manage/parse',
                data: file
            });
        }

        function manage(actions) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlClients/manage',
                data: actions
            });
        }

        function getClientTemplates(client) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/dhlClients/' + client + '/getTemplatesId'
            });
        }

        function postClientTemplates(client, templates) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlClients/' + client + '/postTemplates',
                data: templates
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', 'API_URL', '$http'];

    function Principal($q, Account, API_URL, $http) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            getProperty: getProperty,
            hasInvoiceRead: hasInvoiceRead,
            hasClientRead: hasClientRead,
            hasUserRead: hasUserRead,
            hasInvoiceWrite: hasInvoiceWrite,
            hasClientWrite: hasClientWrite,
            hasUserWrite: hasUserWrite,
            hasPortalAccess: hasPortalAccess,
            hasAllDocumentsAccess: hasAllDocumentsAccess,
            hasSystemAccess: hasSystemAccess,
            hasTemplateAccess: hasTemplateAccess,
            updateLanguage: updateLanguage,
            hasUserReceivablesAccess: hasUserReceivablesAccess,
            hasAdminReceivablesAccess: hasAdminReceivablesAccess
        };

        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority(authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority(authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function() {
                return false;
            });
        }

        function identity(force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }

        function getProperty(property) {
            if (!property) {
                return null;
            }

            if (angular.isDefined(_identity) && _identity != null) {
                return _identity[property];
            }

            return null;
        }

        function getAuthorities() {
            var authorities = getProperty('authorities');
            if (authorities == null) {
                authorities = [];
            }
            return authorities;
        }

        function hasInvoiceRead() {
            return getAuthorities().indexOf('ROLE_INVOICE_READ@DHL') >= 0;
        }

        function hasClientRead() {
            return getAuthorities().indexOf('ROLE_CLIENT_READ@DHL') >= 0;
        }

        function hasUserRead() {
            return getAuthorities().indexOf('ROLE_USER_READ@DHL') >= 0;
        }

        function hasInvoiceWrite() {
            return getAuthorities().indexOf('ROLE_INVOICE_WRITE@DHL') >= 0;
        }

        function hasClientWrite() {
            return getAuthorities().indexOf('ROLE_CLIENT_WRITE@DHL') >= 0;
        }

        function hasUserWrite() {
            return getAuthorities().indexOf('ROLE_USER_WRITE@DHL') >= 0;
        }

        function hasPortalAccess() {
            return getAuthorities().indexOf('ROLE_PORTAL_ACCESS@DHL') >= 0;
        }

        function hasAllDocumentsAccess() {
            return getAuthorities().indexOf('ROLE_ALL_DOCUMENTS_ACCESS@DHL') >= 0;
        }

        function hasSystemAccess() {
            return getAuthorities().indexOf('ROLE_SYSTEM_ACCESS@DHL') >= 0;
        }

        function hasTemplateAccess() {
            return getAuthorities().indexOf('ROLE_TEMPLATE_ACCESS@DHL') >= 0;
        }

        function hasUserReceivablesAccess() {
            return getAuthorities().indexOf('ROLE_RECEIVABLES_USER@DHL') >= 0;
        }

        function hasAdminReceivablesAccess() {
            return getAuthorities().indexOf('ROLE_RECEIVABLES_ADMIN@DHL') >= 0;
        }

        function updateLanguage(language) {
            return $http({
                method: 'POST',
                url: API_URL + 'api/language',
                data: language
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['API_URL', '$http'];

    function PasswordResetInit(API_URL, $http) {
        var service = {
            resetPassword: resetPassword
        }

        return service;

        function resetPassword(id, user){
            return $http({
                method: 'POST',
                url: API_URL + 'api/dhlUsers/' + id + '/changePassword',
                data: user
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['API_URL','$http', '$localStorage', 'Base64' ];

    function AuthServerProvider (API_URL, $http, $localStorage, Base64) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout,
            isBlocked: isBlocked
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var base64EncodedString = Base64.encode(credentials.username +':' + credentials.password);
            var authorizationHeader = undefined;
            if(base64EncodedString==null || base64EncodedString == ''){
                authorizationHeader = 'Basic';
            }else{
                authorizationHeader = 'Basic ' + base64EncodedString;
            }
            return $http.post(API_URL + 'api/authenticate', '', {
                headers: {
                    'Authorization': authorizationHeader
                    // 'Content-Type': 'application/x-www-form-urlencoded'
                },
            });
        }

        function isBlocked (email) {
            return $http({
                method: 'GET',
                url: API_URL + 'api/isBlocked?email=' + email + '&gr=DHL'
            });
        }

        function logout () {
            // logout from the server
            $http.post(API_URL + 'api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                // $http.get(API_URL +'api/session');
                return response;
            });

        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$cookies', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $cookies, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount,
            isBlocked: isBlocked
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            $state.go('login');
                            // LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function isBlocked (email){
            return AuthServerProvider.isBlocked(email);
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account != null && account.langKey != null) {
                    	$cookies.putObject("NG_TRANSLATE_LANG_KEY", account.langKey);
                        $translate.use(account.langKey).then(function () {
                        	$translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('Account', Account);

    Account.$inject = ['API_URL', '$resource'];

    function Account(API_URL, $resource) {
        var service = $resource(API_URL + 'api/session', {}, {
            'get': {
                method: 'GET',
                params: {},
                isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('ShellService', ShellService);

	ShellService.$inject = ['API_URL','$http'];

    function ShellService (API_URL, $http) {

		return {
			'logout': function(){
				return $http({
				  method: 'POST',
				  url: API_URL + 'api/auth/logout'
				});
			}
		};
	}
})();
;
(function() {
	'use strict';

	angular.
		module('edistradadhluiApp')
		.controller('ShellController', ShellController);

	ShellController.$inject = [ '$rootScope', '$scope', '$state', 'Auth',
			'Principal', 'ClientsService' ];

	function ShellController($rootScope, $scope, $state, Auth, Principal, ClientsService) {
		var vm = this;
		var validNavigation = false;

		// Declare function
		vm.toggleSidebar = toggleSidebar;
		vm.showSidebar = showSidebar;
		vm.hideSidebar = hideSidebar;
		vm.logout = logout;
		vm.identity = Principal.identity();
		vm.setupTabCloseHandling = setupTabCloseHandling;
		vm.setVersion = setVersion;

        function setVersion() {
            var version_text = $('#version_text');
            var version = "256";
            console.log("setVersion2");
                ClientsService.getVersion().then(function(response) {
                    version = $rootScope.VERSION;
                    version += " | ";
                    version += response.data;
                    version_text.text(version);
                })
                .catch(function(response) {
                    version ="error";
                    version_text.text(version);
                });
        }

		function showSidebar() {
			var toggle = $('.navbar-toggle');
			setTimeout(function() {
				toggle.addClass('toggled');
			}, 430);

			var div = '<div id="bodyClick"></div>';
			$(div).appendTo("body").click(function() {
				hideSidebar();
				var $body = angular.element(document.body);
				var $rootScope = $body.injector().get('$rootScope');
				$rootScope.$apply(function() {
					$rootScope.sidebar = false;
				})
			});

			$('html').addClass('nav-open');
		}

		function hideSidebar() {
			var toggle = $('.navbar-toggle');
			$('html').removeClass('nav-open');
			$('#bodyClick').remove();
			setTimeout(function() {
				toggle.removeClass('toggled');
			}, 400);
		}

		function toggleSidebar() {
			var navbar = $('.navbar-collapse');
			if ($rootScope.sidebar == undefined) {
				$rootScope.sidebar = true;
				navbar.css('min-height', window.screen.height);
			} else {
				$rootScope.sidebar = !$rootScope.sidebar;
			}

			if ($rootScope.sidebar == false) {
				hideSidebar();
			} else {
				showSidebar();
			}
		}

		function logout() {
			// Logout through HTTP request
			Auth.logout();

			// Go to login view
			$state.go('login');
		}

		function setupTabCloseHandling() {
		    validNavigation = false;
		    // Unload is called when closing or refreshing tab
            $(window).unload(function() {
                if (validNavigation == false)
                {
                    logout();
                }
                validNavigation = false;
			});
			// F5 key
			$(document).keydown(function(e) {
				var key = e.which || e.keyCode;
				if (key == 116) validNavigation = true;
			});
			// Attach the event click for all links in the page
			$("a").bind("click", function() {
				validNavigation = true;
			});
			// Attach the event submit for all forms in the page
			$("form").bind("submit", function()
			{
				validNavigation = true;
			});
			// Attach the event click for all inputs in the page
			$("input[type=submit]").bind("click", function()
			{
				validNavigation = true;
			});
		}
	}
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }

            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();
;
(function(){
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();
;
(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('edistradadhluiApp')
        .component('jhiItemCount', jhiItemCount);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('iframeSetDimensionsOnload', [function() {

            return {
                restrict: 'A',
                link: function(scope, element, attrs){
                    element.on('load', function(){
                        /* Set the dimensions here,
                           I think that you were trying to do something like this: */
                           var iFrameHeight = element[0].contentWindow.document.body.scrollHeight + 'px';
                           var iFrameWidth = '100%';
                           element.css('width', iFrameWidth);
                           element.css('height', iFrameHeight);
                            var Window = $(window);
                            var Document = $(document);
                            element.css('height', Document.height());
                            element.css('height', element.height() - (Document.height() - Window.height()));

//                           $(window).resize(function(){
//                                var Window = $(window),
//                                Document = $(document),
//                                PDFWrapper = $('#PDFWrapper');
//                           });

                    })
                }
            }
        }]);
})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('GenerateURL', GenerateURL);

    GenerateURL.$inject = ['$httpParamSerializer'];

    function GenerateURL ($httpParamSerializer) {
        var service = {
            generate : generate
        };

        return service;

        function generate (baseURL, params) {
           var serializedParams = $httpParamSerializer(params);
           if (serializedParams.length > 0) {
                   baseURL += ((baseURL.indexOf('?') === -1) ? '?' : '&') + serializedParams;
           }

            return baseURL;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {

            if (typeof value === "undefined" || value === undefined || value === null) {
                return "";
            }
            input = input.toLowerCase();
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();
;
(function() {
    'use strict';

    /*Using this directive requires the table to be wrapped in a DIV element*/
    angular
        .module('edistradadhluiApp')
        .directive("callFunctionAfterNgRepeat", [function() {
            return {
                restrict: 'A',
                scope: false,
                link: function(scope, element, attrs) {
                    if (scope.$last){
                      window.alert("im the last!");
                    }
                }
            };
        }]);
})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('principalProperty', ['Principal', function(Principal) {

			return {
				restrict: "A",
				link: function(scope, element, attrs) {
					var property  = attrs.principalProperty;
					element.text(Principal.getProperty(property));
				}
			}
		}]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .filter('findKeyFromLanguage', findKeyFromLanguage);

    function findKeyFromLanguage() {
        return findKeyFromLanguageFilter;

        function findKeyFromLanguageFilter(lang) {
            return {
                'Català': 'ca',
                'Český': 'cs',
                'Dansk': 'da',
                'Deutsch': 'de',
                'Ελληνικά': 'el',
                'English': 'en',
                'Español': 'es',
                'Français': 'fr',
                'Galego': 'gl',
                'Magyar': 'hu',
                'हिंदी': 'hi',
                'Italiano': 'it',
                '日本語': 'ja',
                '한국어': 'ko',
                'मराठी': 'mr',
                'Nederlands': 'nl',
                'Polski': 'pl',
                'Português (Brasil)': 'pt-br',
                'Português': 'pt-pt',
                'Română': 'ro',
                'Русский': 'ru',
                'Slovenský': 'sk',
                'Svenska': 'sv',
                'தமிழ்': 'ta',
                'Türkçe': 'tr',
                '中文（简体）': 'zh-cn',
                '繁體中文': 'zh-tw'
            }[lang];
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;
         vm.getLanguage = getLanguage;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            document.documentElement.setAttribute("lang", languageKey);
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }

        function getLanguage(){
           return tmhDynamicLocale.get();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('edistradadhluiApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'pl',
            'en'
        ]
    );
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('smartFloat', function() {

            return {
                require: '?ngModel',
                link: function(scope, element, attrs, ngModelCtrl) {
                    if (!ngModelCtrl) {
                        return;
                    }

                    ngModelCtrl.$parsers.push(function(val) {
                        if (angular.isUndefined(val)) {
                            val = '';
                        } else {
                        	val = val.toString();
                        }
                        var clean = val.replace(/[^0-9,.-]+/g, '');
                        if (val !== clean) {
                            ngModelCtrl.$setViewValue(clean);
                            ngModelCtrl.$render();
                        }
                        return clean;
                    });

                    element.bind('keypress', function(event) {
                        if (event.keyCode === 32) {
                            event.preventDefault();
                        }
                    });
                }
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('pemail', [function() {

            return {
                require: 'ngModel',
                restrict: 'E',
                replace: 'true',
                template: "<input type='text' id='dhlEmail' name='dhlEmail' class='form-control register-input normal-form' "+
                "ng-model='vm.data.email' autocomplete='off' tooltip-placement='top' ng-class='registerEmail' "+
                "uib-tooltip={{dynamicTooltip}} tooltip-placement='top'/>",
                link: function(scope, element, attributes, control) {
                    // Required
                    control.$validators.required = jQuery.proxy(function(value) {
                        return (!control.$isEmpty(value));
                    }, element);

                    // Validate email
                    control.$validators.email = jQuery.proxy(function(value) {
                        return (control.$isEmpty(value) || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value));
                    }, element);
                }
            }
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('nip', ['UtilService', 'UsersService', '$q', '$translate', '$translatePartialLoader', function(UtilService, UsersService, $q, $translate, $translatePartialLoader) {

            return {
                require: 'ngModel',
                restrict: 'E',
                replace: 'true',
                template: "<input type='text' id='dhlNip' name='dhlNip' ng-pattern='/^[1-9][0-9]{9}$/' class='form-control register-input normal-form'ng-model='vm.data.nip' uib-tooltip={{nipTooltip()}} tooltip-placement='top' required='required' ng-class='registerNip' />",
                link: function(scope, element, attributes, control) {
                    $translatePartialLoader.addPart('register');
                    $translate.refresh();
                    //Required
                    control.$validators.required = jQuery.proxy(function(value) {
                        return (!control.$isEmpty(value));
                    }, element);
                    //Validate minimum
                    control.$validators.minimum = jQuery.proxy(function(value) {
                        var minimum = 10;
                        if (UtilService.isFilled($(this).attr('data-min')))
                            minimum = $(this).attr('data-min');
                        return (control.$isEmpty(value) || (value.length >= minimum));
                    }, element);
                    //Validate maximum
                    control.$validators.maximum = jQuery.proxy(function(value) {
                        var maximum = 10;
                        if (UtilService.isFilled($(this).attr('data-max')))
                            maximum = $(this).attr('data-max');
                        return (control.$isEmpty(value) || (value.length <= maximum));
                    }, element);
                    //Validate format
                    control.$validators.validDigits = jQuery.proxy(function(value) {
                        return (control.$isEmpty(value) || /^[1-9][0-9]{9}$/.test(value));
                    }, element);
                    control.$parsers.push(function(val) {
                        if (angular.isUndefined(val)) {
                            var val = '';
                        }
                        var clean = val.replace(/[^0-9]+/g, '');
                        if (val !== clean) {
                            control.$setViewValue(clean);
                            control.$render();
                        }
                        return clean;
                    });

                    $(element).bind('keypress', function(event) {
                        if (event.keyCode === 32) {
                            event.preventDefault();
                        }
                    });

                    scope.nipTooltip = function() {
                        var tooltipNip = '';
                        if (control.$error.maximum || control.$error.minimum || control.$error.validDigits)
                            tooltipNip = $translate.instant('directives.requiredNip');
                        else if (control.$error.required)
                            tooltipNip = $translate.instant('directives.requiredNip');

                        return tooltipNip;
                    }

                    $(element).on('keyup change', function(event) {
                        if ($("#dhlNip").hasClass("ng-invalid"))
                            $("#dhlNipLabel").addClass("red")
                        else
                            $("#dhlNipLabel").removeClass("red")
                    });
                }
            }
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('invoice', ['UtilService', 'UsersService', '$q', '$translate', '$translatePartialLoader', function(UtilService, UsersService, $q, $translate, $translatePartialLoader) {

            return {
                require: 'ngModel',
                restrict: 'E',
                replace: 'true',
                template: "<input type='text' name='dhlInvoice' class='form-control register-input normal-form' autocomplete='off' id='dhlInvoice' placeholder='' required='required' ng-model='vm.data.invoiceNr' ng-maxlength='256' ng-class='registerInvoice' uib-tooltip={{invoiceTooltip()}} tooltip-placement='top' />",
                link: function(scope, element, attributes, control) {
                    $translatePartialLoader.addPart('register');
                    $translate.refresh();
                    // Only numbers
                    control.$parsers.push(function(val) {
                        if (angular.isUndefined(val)) {
                            var val = '';
                        }
                        var clean = val.replace(/[^0-9]+/g, '');
                        if (val !== clean) {
                            control.$setViewValue(clean);
                            control.$render();
                        }
                        return clean;
                    });

                    $(element).bind('keypress', function(event) {
                        if (event.keyCode === 32) {
                            event.preventDefault();
                        }
                    });

                    // Required
                    control.$validators.required = jQuery.proxy(function(value) {
                        return (!control.$isEmpty(value));
                    }, element);

                    scope.invoiceTooltip = function() {
                        var tooltipInvoice = '';
                        if (control.$error.required)
                            tooltipInvoice = $translate.instant("directives.requiredInvoice");
                        return tooltipInvoice;
                    }

                    $(element).on('keyup change ', function(event) {
                        if ($("#dhlInvoice").hasClass("ng-invalid"))
                            $("#dhlInvoicedhlLabel").addClass("red")
                        else
                            $("#dhlInvoicedhlLabel").removeClass("red")
                    });
                }
            }
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('gross', ['UtilService', 'UsersService', '$q', '$translate', '$translatePartialLoader', function(UtilService, UsersService, $q, $translate, $translatePartialLoader) {
            return {
                require: 'ngModel',
                restrict: 'E',
                replace: 'true',
                template: "<input id='dhlGrossAmount' name='dhlGrossAmount' class='form-control register-input normal-form' required='required' ng-model='vm.data.totalAmount' type='text' ng-class='registerGrossAmount' smart-float ng-pattern='/^[+-]?[0-9]+([.,][0-9]{1,2})?$/' uib-tooltip='{{grossTooltip()}}'  tooltip-placement='top' />",
                link: function(scope, element, attributes, control) {
                    $translatePartialLoader.addPart('register');
                    $translate.refresh();
                    //Only numbers
                    control.$parsers.push(function(val) {
                        if (angular.isUndefined(val)) {
                            var val = '';
                        }
                        var clean = val.replace(/[^0-9,.-]+/g, '');
                        if (val !== clean) {
                            control.$setViewValue(clean);
                            control.$render();
                        }
                        return clean;
                    });

                    $(element).bind('keypress', function(event) {
                        if (event.keyCode === 32) {
                            event.preventDefault();
                        }
                    });
                    //Required
                    control.$validators.required = jQuery.proxy(function(value) {
                        return (!control.$isEmpty(value));
                    }, element);
                    // Begins
                    control.$validators.format = jQuery.proxy(function(value) {
                        return (control.$isEmpty(value) || /^[+-]?[0-9]+([.,][0-9]{1,2})?$/.test(value));
                    }, element);

                    scope.grossTooltip = function() {
                        var tooltipGross = '';
                        if (control.$error.required)
                            tooltipGross = $translate.instant("directives.giveValidTotal");
                        else if (control.$error.format)
                            tooltipGross = $translate.instant("directives.invalidTotal");
                        return tooltipGross;
                    }

                    $(element).on('keyup change ', function(event) {
                        if ($("#dhlGrossAmount").hasClass("ng-invalid"))
                            $("#dhlGrossAmountLabel").addClass("red")
                        else
                            $("#dhlGrossAmountLabel").removeClass("red")
                    });
                }
            }
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('email', ['UtilService', 'UsersService', '$q', '$translate', '$translatePartialLoader', function(UtilService, UsersService, $q, $translate, $translatePartialLoader) {

            return {
                require: 'ngModel',
                restrict: 'E',
                replace: 'true',
                template: "<input type='text' id='dhlEmail' name='dhlEmail' class='form-control register-input normal-form' " +
                    "ng-model='vm.data.email' autocomplete='off' tooltip-placement='top' ng-class='registerEmail' " +
                    "uib-tooltip={{emailTooltip()}} tooltip-placement='top'/>",
                link: function(scope, element, attributes, control) {
                    $translatePartialLoader.addPart('register');
                    $translate.refresh();
                    //Required
                    control.$validators.required = jQuery.proxy(function(value) {
                        return (!control.$isEmpty(value));
                    }, element);

                    //Validate maximum
                    control.$validators.max = jQuery.proxy(function(value) {
                        var maximum = 256;
                        if (UtilService.isFilled($(this).attr('data-max')))
                            maximum = $(this).attr('data-max');
                        return (control.$isEmpty(value) || (value.length <= maximum));
                    }, element);

                    //Validate email
                    control.$validators.email = jQuery.proxy(function(value) {
                        return (control.$isEmpty(value) || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value));
                    }, element);

                    scope.emailTooltip = function() {
                        var tooltip = '';
                        if (control.$error.max)
                            tooltip += $translate.instant("directives.maxEmail1") + ($(this).attr('data-max') || 256) + $translate.instant("directives.maxEmail2");
                        if (control.$error.email)
                            tooltip += $translate.instant("directives.requiredEmail");
                        else if (control.$error.required)
                            tooltip += $translate.instant("directives.giveValidEmail");

                        return tooltip;
                    }

                    $(element).on('keyup change ', function(event) {
                        if ($("#dhlEmail").hasClass("ng-invalid"))
                            $("#dhlEmailLabel").addClass("red")
                        else
                            $("#dhlEmailLabel").removeClass("red")
                    });
                }
            }
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('client', ['UtilService', 'UsersService', '$q', '$translate', '$translatePartialLoader', function(UtilService, UsersService, $q, $translate, $translatePartialLoader) {
            return {
                require: 'ngModel',
                restrict: 'E',
                replace: 'true',
                template: "<input type='text' ng-pattern='/^[0-9]+$/' smart-float class='form-control register-input normal-form' autocomplete='off' id='dhlClientCode' uib-tooltip='{{clientTooltip()}}'' tabindex=0 ng-model='vm.data.clientCode' ng-maxlength='128'></input>",
                link: function(scope, element, attributes, control) {
                    $translatePartialLoader.addPart('register');
                    $translate.refresh();
                    //Validate minimum
                    control.$validators.minimum = jQuery.proxy(function(value) {
                        var minimum = 7;
                        if (UtilService.isFilled($(this).attr('data-min')))
                            minimum = $(this).attr('data-min');
                        return (control.$isEmpty(value) || (value.length >= minimum));
                    }, element);
                    //Validate maximum
                    control.$validators.maximum = jQuery.proxy(function(value) {
                        var maximum = 7;
                        if (UtilService.isFilled($(this).attr('data-max')))
                            maximum = $(this).attr('data-max');
                        return (control.$isEmpty(value) || (value.length <= maximum));
                    }, element);

                    control.$parsers.push(function(val) {
                        if (angular.isUndefined(val)) {
                            var val = '';
                        }
                        var clean = val.replace(/[^0-9]+/g, '');
                        if (val !== clean) {
                            control.$setViewValue(clean);
                            control.$render();
                        }
                        return clean;
                    });

                    $(element).bind('keypress', function(event) {
                        if (event.keyCode === 32) {
                            event.preventDefault();
                        }
                    });

                    scope.clientTooltip = function() {
                        return scope.$conditionalTranslate(control.$error.minimum || control.$error.maximum, "directives.giveValidClientNumber");
                    }

                    // Live validation tooltip
                    $(element).on('keyup change ', function(event) {
                        if ($("#dhlClientCode").hasClass("ng-invalid"))
                            $("#dhlClientCodeLabel").addClass("red")
                        else
                            $("#dhlClientCodeLabel").removeClass("red")
                    });
                }
            }
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        scope.$watch(function() {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();
;
(function() {
    'use strict';

    /*Using this directive requires the table to be wrapped in a DIV element*/
    angular
        .module('edistradadhluiApp')
        .directive("fixTable", ['$compile', function($compile) {
            return {
                restrict: 'A',
                scope: false,
                link: function(scope, element, attrs) {
                    var table = $(element),
                        fixedHeader,
                        fixedFooter,
                        wrapper = table.closest('div');

                    fixedHeader = table.clone();
                    fixedHeader.find("tbody").remove().end() //Remove body
                        .find("tfoot").remove().end() //Remove footer
                        .addClass("alt-fixed") //Add class that fixes this element
                        .removeAttr('fix-table') //Remove this directive
                        .insertBefore(table); //Insert before table
                    $compile(fixedHeader)(scope); //Inject into AngularJS

                    fixedFooter = table.clone();
                    fixedFooter.find("tbody").remove().end() //Remove body
                        .find("thead").remove().end() //Remove footer
                        .addClass("alt-fixed") //Add class that fixes this element
                        .removeAttr('fix-table') //Remove this directive
                        .insertAfter(table); //Insert after table
                    fixedFooter.css('bottom', 0); //Fix footer at the bottom, instead of top
                    $compile(fixedFooter)(scope); //Inject into AngularJS

                    function resizeFixed() {
                        var tableOffsetLeft = table.offset().left,
                            tableCutLeft = wrapper.offset().left - tableOffsetLeft,
                            tableCutRight = table.width() - wrapper.width() - tableCutLeft,
                            tableInnerWidth = table.width() - tableCutRight;

                        resizeFixedColumns(fixedHeader, table);
                        resizeFixedColumns(fixedFooter, table);

                        function resizeFixedColumns(elementToResize, modelElement) {
                            elementToResize.css('left', tableOffsetLeft); //Move element to left, just as modelElement
                            elementToResize.css('clip', 'rect(0px ' + tableInnerWidth + 'px auto ' + tableCutLeft + 'px)'); //Clip element to not stick out of the wrapper
                            //Resize columns taking colspan attribute into consideration
                            var column = 0;
                            var elementSelector = "th";
                            elementToResize.find("th").each(resizeFixedColumn);
                            elementSelector = "tfoot td";
                            elementToResize.find("td").each(resizeFixedColumn);

                            function resizeFixedColumn(index, element) {
                                if (index == 0) column = 0;
                                var matchingColumn = modelElement.find(elementSelector).eq(column++);
                                if (!$(matchingColumn).hasClass('ng-hide')) {
                                    $(this).css("min-width", matchingColumn.outerWidth(true) + "px");
                                    $(this).css("max-width", matchingColumn.outerWidth(true) + "px");
                                } else {
                                    $(this).css("min-width", "0");
                                    $(this).css("max-width", "0");
                                }
                            }
                        }
                    }

                    function scrollFixed() {
                        try { //To avoid console errors before AngularJS initialization
                            var fixedPart = $('#fixed')[0] != undefined ? $('#fixed') : $('#shell'),
                                windowPart = $(window),
                                topPosition = fixedPart.offset().top - windowPart.scrollTop() + fixedPart.outerHeight(),
                                offsetTop = fixedPart.offset().top + fixedPart.outerHeight(),
                                offsetBottom = windowPart.scrollTop() + windowPart.outerHeight(),
                                tableOffsetTop = table.offset().top,
                                tableOffsetBottom = tableOffsetTop + table.outerHeight();

                            if ((offsetTop < tableOffsetTop || offsetTop > tableOffsetBottom) && !fixedHeader.is(":hidden")) {
                                fixedHeader.css('top', topPosition + "px");
                                fixedHeader.hide();
                            } else if (offsetTop >= tableOffsetTop && offsetTop <= tableOffsetBottom) {
                                var headerSpaceLeft = tableOffsetBottom - fixedHeader.outerHeight() - offsetTop;
                                fixedHeader.css('top', (headerSpaceLeft > 0 ? topPosition : topPosition + headerSpaceLeft) + "px");
                                fixedHeader.show();
                            }

                            if (offsetBottom < tableOffsetTop + fixedFooter.outerHeight() + fixedHeader.outerHeight() || offsetBottom > tableOffsetBottom) {
                                fixedFooter.hide();
                            } else if (offsetBottom >= tableOffsetTop && offsetBottom <= tableOffsetBottom && fixedFooter.is(":hidden")) {
                                fixedFooter.show();
                            }
                        } catch (e) {
                            if (!e instanceof TypeError)
                                throw e;
                        } finally {}
                    }

                    function adjustFixed() {
                        resizeFixed();
                        scrollFixed();
                    }

                    //This function shows changes made to footer and header
                    function move() {
                        $(window).scrollTop($(window).scrollTop() + 1);
                        $(window).scrollTop($(window).scrollTop() - 1);
                    }

                    //Timeout prevents huge lag due to massive amount of function calls
                    var handlerTimeout;
                    //React to window resize, window scroll, wrapper DIV scroll and table header DOM manipulation events
                    $(window).resize(ResizeAndScrollHandler);
                    $(window).scroll(ResizeAndScrollHandler);
                    $(table.closest('div')).scroll(ResizeAndScrollHandler);
                    $(table.find('thead')).bind("DOMSubtreeModified", DOMModificationHandler);
                    $(table).bind("DOMNodeInserted", DOMModificationHandler);

                    function ResizeAndScrollHandler() {
                        clearTimeout(handlerTimeout);
                        adjustFixed();
                    }

                    function DOMModificationHandler() {
                        clearTimeout(handlerTimeout);
                        handlerTimeout = setTimeout(function() {
                            adjustFixed();
                            move();
                        }, 100);
                    }

                    table.on('$destroy', function() {
                        $(window).unbind('resize', ResizeAndScrollHandler);
                        $(window).unbind('scroll', ResizeAndScrollHandler);
                    });
                }
            };
        }]);
})();
;
(function() {
    'use strict';

    /*Using this directive requires the table to be wrapped in a DIV element*/
    angular
        .module('edistradadhluiApp')
        .directive("dynamicHeight", ['$compile', function($compile) {
            return {
                restrict: 'A',
                scope: {
                    dhElementId: '@'
                },
                link: function(scope, element, attrs) {
                    scope.$watch(function(){ //watch any changes to our element
                        $(scope.dhElementId).css('padding-top', element[0].offsetHeight);
                    });

                    scope.$on('alert-service-event', function(evt, data) {
                        $(scope.dhElementId).css('padding-top', element[0].offsetHeight);
                    });
                }
            };
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive("confirm", ['$document', '$parse','$translate','$translatePartialLoader', function($document, $parse,$translate,$translatePartialLoader) {
            return {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    var buttonId, html, message, nope, title, yep;
                    $translatePartialLoader.addPart('global');
                    $translate.refresh();
                    buttonId = Math.floor(Math.random() * 10000000000);

                    attrs.buttonId = buttonId;

                    message = attrs.confirmMessage || $translate.instant("confirm.areYouSure");
                    yep = attrs.yes || $translate.instant("confirm.yes");
                    nope = attrs.no || $translate.instant("confirm.no");
                    title = attrs.title || $translate.instant("confirm.confirm");

                    attrs.$observe('confirmMessage', function(value) {
                        message = attrs.confirmMessage || $translate.instant("confirm.areYouSure");
                        html = "<div id=\"button-" + buttonId + "\" class=\"confirm\" style=\"text-align: center\"><span class=\"confirmbutton-msg\">" + message + "</span><br><div class=\"confirmbutton-yes btn btn-primary btn-fill btn-round\" style=\"min-width: 40px\">" + yep + "</div><div class=\"confirmbutton-no btn btn-primary btn-round\" style=\"min-width: 40px\">" + nope + "</div></div>";
                    });

                    return element.bind('click', function(e) {
                        var dontBubble, pop;
                        dontBubble = true;

                        e.stopPropagation();

                        html = "<div id=\"button-" + buttonId + "\" class=\"confirm\" style=\"text-align: center\"><span class=\"confirmbutton-msg\">" + message + "</span><br><div class=\"confirmbutton-yes btn btn-primary btn-fill btn-round\" style=\"min-width: 40px\">" + yep + "</div><div class=\"confirmbutton-no btn btn-primary btn-round\" style=\"min-width: 40px\">" + nope + "</div></div>";

                        element.popover({
                            content: html,
                            html: true,
                            trigger: "manual",
                            title: title,
                            container: 'body', 
                            placement: 'top auto'
                        });

                        element.popover('show');

                        pop = $("#button-" + buttonId);

                        pop.closest(".popover").click(function(e) {
                            if (dontBubble) {
                                e.stopPropagation();
                            }
                        });

                        pop.find('.confirmbutton-yes').click(function(e) {
                            dontBubble = false;

                            var func = $parse(attrs.confirm);
                            func(scope);
                        });

                        pop.find('.confirmbutton-no').click(function(e) {
                            dontBubble = false;

                            $document.off('click.confirmbutton.' + buttonId);

                            element.popover('hide');
                        });

                        $document.on('click.confirmbutton.' + buttonId, ":not(.popover, .popover *)", function() {
                            $document.off('click.confirmbutton.' + buttonId);
                            element.popover('hide');
                        });
                    });
                }
            };
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('clickToEdit', ['$timeout', '$compile', function($timeout, $compile) {
            return {
                require: 'ngModel',
                scope: {
                    model: '=ngModel',
                    type: '@type'
                },
                replace: true,
                transclude: false,
                // includes our template
                templateUrl: 'app/components/form/clickToEdit.html',
                link: function(scope, element, attrs, model) {
                    scope.editState = false;

                    // make a local ref so we can back out changes, this only happens once and persists
                    scope.element = element;

                    if (!String.prototype.startsWith) {
                        String.prototype.startsWith = function(searchString, position) {
                            position = position || 0;
                            return this.indexOf(searchString, position) === position;
                        };
                    }

                    scope.textLength = attrs.dataMaxlength || 255;

                    var input = element.find("input");
                    for (var attr in attrs.$attr) {
                        if (attrs.$attr[attr].startsWith("data-")) {
                            input.attr(attrs.$attr[attr].replace("data-", ""), element.attr(attrs.$attr[attr]));
                        }
                    }
                    input.append($compile(input)(scope));
                    if( attr === "textarea" ){
                        input.remove();
                    } else {
                        var textarea = element.find("textarea");
                        textarea.remove();
                    }

                    // apply the changes to the real model
                    scope.save = function($event) {
                        scope.toggle($event);
                    };

                    // don't apply changes
                    scope.cancel = function($event) {
                        scope.model = scope.localModel;
                        scope.toggle($event);
                    };

                    scope.edit = function($event) {
                        scope.localModel = scope.model;
                        scope.toggle($event);
                    };

                    /*
                     * toggles the editState of our field
                     */
                    scope.toggle = function($event) {
                        scope.editState = !scope.editState;

                        /*
                         * a little hackish - find the "type" by class query
                         *
                         */
                        var x1 = scope.element.find('input');


                        /*
                         * could not figure out how to focus on the text field, needed $timout
                         * http://stackoverflow.com/questions/14833326/how-to-set-focus-on-input-field-in-angularjs
                         */
                        $timeout(function($event) {
                            // focus if in edit, blur if not. some IE will leave cursor without the blur
                            if (scope.editState) {
                                x1.focus();
                                x1.select();
                            } else
                                x1.blur();
                        }, 0);
                    };
                }
            };
        }]).directive('ngEnter', function() {
            return function(scope, element, attrs) {
                element.unbind("keypress keydown");
                element.bind("keypress keydown", function(event) {
                    if (event.which === 13) {
                        scope.$apply(function() {
                            scope.$eval(attrs.ngEnter);
                        });
                        event.preventDefault();
                    } else if (event.which === 27) {
                        scope.$apply(function() {
                            scope.$eval(attrs.ngEscape);
                        });
                        event.preventDefault();
                    }
                });
            };
        });

})();
;
(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('edistradadhluiApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('edistradadhluiApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-edistradadhluiApp-error');
                var entityKey = httpResponse.headers('X-edistradadhluiApp-params');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('edistradadhluiApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .provider('AlertService', AlertService);

    function AlertService() {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService($timeout, $sce, $translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 0; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning: warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts.length = 0;
            }

            function get() {
                return alerts;
            }

            function success(msg, translateValues, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    translateValues: translateValues,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, translateValues, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    translateValues: translateValues,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, translateValues, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    translateValues: translateValues,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, translateValues, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    translateValues: translateValues,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: alertOptions.msg instanceof Function ? alertOptions.msg : $sce.trustAsHtml(alertOptions.msg),
                    translateValues: alertOptions.translateValues,
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function(alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if (!alert.scoped) {
                    // Faster than clear() and alerts.push
                    alerts[0] = alert;
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;

                if (!(alertOptions.msg instanceof Function) && alertOptions.params != null) {
                    return $translate(alertOptions.msg, alertOptions.params)
                        .then(function(response) {
                            alertOptions.msg = response;
                            return doRest();
                        });
                }

                return doRest();

                function doRest() {
                    var alert = that.factory(alertOptions);
                    if (alertOptions.timeout && alertOptions.timeout > 0) {
                        $timeout(function() {
                            that.closeAlert(alertOptions.alertId, extAlerts);
                        }, alertOptions.timeout);
                    }
                    return alert;
                }
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) {
                    return e.id;
                }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();
;
(function() {
    'use strict';

    var portalAlert = {
        template: '<span class="container container-fluid" style="padding:0;" ng-show="vm.alerts.length > 0" ng-cloak="">' +
            '<div ng-repeat="alert in vm.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
            '<uib-alert  type="{{alert.type}}" close="alert.close(vm.alerts); vm.onClose(alert)">' +
            '<span translate="{{vm.get(alert.msg)}}" translate-values="{{alert.translateValues}}"></span>' +
            '</uib-alert>' +
            '</div>' +
            '</span>',
        controller: portalAlertController,
        controllerAs: 'vm'
    };

    angular
        .module('edistradadhluiApp')
        .component('portalAlert', portalAlert);

    portalAlertController.$inject = ['$rootScope', '$scope', '$timeout', 'AlertService', '$sce'];

    function portalAlertController($rootScope, $scope, $timeout, AlertService, $sce) {
        var vm = this;

        vm.get = function(functionOrTranslatedString) {
            if (functionOrTranslatedString instanceof Function)
                return $sce.trustAsHtml(functionOrTranslatedString());
            else
                return functionOrTranslatedString;
        };

        vm.onClose = function(alert) {
            setTimeout(function() {
                $('#under-fixed').css('padding-top', $('#fixed').height());
                $(window).trigger('scroll');
            }, 100);

        };


        vm.alerts = AlertService.get();

        $scope.$watch('vm.alerts', function(newValue, oldValue) {
            $timeout(function() { $rootScope.$broadcast('alert-service-event'); }, 0);
        }, true);
        $scope.$on('$destroy', function() {
            vm.alerts = [];
            AlertService.clear();
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .service('HttpPendingRequestsService', HttpPendingRequestsService)
        .factory('serviceUnavailableInterceptor', serviceUnavailableInterceptor);

    serviceUnavailableInterceptor.$inject = ['$window', '$q', 'HttpPendingRequestsService'];

    function serviceUnavailableInterceptor ($window, $q, HttpPendingRequestsService) {
        var service = {
            request: handleRequest,
            responseError: handleResponseError
        };

        return service;

        function handleResponseError(response) {
            if (response.status === 404 && angular.isDefined(response.data) && response.data.rest_not_available === true) {
                HttpPendingRequestsService.cancelAll();
                $window.location.href = $window.location.origin + "/40x.htm";
                throw new Error("Backend is not available! Redirecting to mainenance page.");
            }

            if (response.config.timeout.isGloballyCancelled) {
                return $q.defer().promise;
            }
            return $q.reject(response);
        }

        function handleRequest(config) {
            config = config || {};
            if (config.timeout === undefined && !config.noCancelOnRouteChange) {
                config.timeout = HttpPendingRequestsService.newTimeout();
            }
            return config;
        }
    }

    HttpPendingRequestsService.$inject = ['$q'];

    function HttpPendingRequestsService($q) {
        var cancelPromises = [];

        function newTimeout() {
            var cancelPromise = $q.defer();
            cancelPromises.push(cancelPromise);
            return cancelPromise.promise;
        }

        function cancelAll() {
            angular.forEach(cancelPromises, function(cancelPromise) {
                cancelPromise.promise.isGloballyCancelled = true;
                cancelPromise.resolve();
            });
            cancelPromises.length = 0;
        }

        return {
            newTimeout: newTimeout,
            cancelAll: cancelAll
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-edistradadhluiApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-edistradadhluiApp-params')});
            }
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('edistradadhluiApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);


    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$document', 'API_URL'];

    function authExpiredInterceptor($rootScope, $q, $injector, $document, API_URL) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && response.config.url.indexOf('api/session') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied' && to.name !== 'login') {
                    Auth.storePreviousState(to.name, params);
                }
                var state = $injector.get('$state');
                state.go('login');
            } else if (response.status === 403 && response.config.method !== 'POST' && getCSRF() === '') {
                // If the CSRF token expired, then try to get a new CSRF token and retry the old request
                var $http = $injector.get('$http');
                return $http.post(API_URL + 'api/csrf').finally(function() {
                    return afterCSRFRenewed(response);
                });
            }
            return $q.reject(response);
        }

        function getCSRF() {
            var doc = $document[0];
            if (doc) {
                var name = '__Host-CSRF-TOKEN=';
                var ca = doc.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) === ' ') { c = c.substring(1); }

                    if (c.indexOf(name) !== -1) {
                        return c.substring(name.length, c.length);
                    }
                }
            }
            return '';
        }

        function afterCSRFRenewed(oldResponse) {
            if (getCSRF() !== '') {
                // retry the old request after the new CSRF-TOKEN is obtained
                var $http = $injector.get('$http');
                return $http(oldResponse.config);
            } else {
                // unlikely get here but reject with the old response any way and avoid infinite loop
                return $q.reject(oldResponse);
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate', 'Principal'];

    function translationHandler($rootScope, $window, $state, $translate, Principal) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function(event, change) {
                updateTitle();
                Principal.updateLanguage(change.language);
            });

            $rootScope.$on('$destroy', function() {
                if (angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null) {
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function(title) {
                $window.document.title = title;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'
    ];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;
            $rootScope.blockedPayersAlertClosed = false; //whether user has closed blocked payers alert in receivables tab

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function(event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (toState.redirectTo) {
                    event.preventDefault();
                    $state.go(toState.redirectTo, toStateParams);
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }


                // Update the language
                JhiLanguageService.getCurrent().then(function(language) {
                    document.documentElement.setAttribute("lang", language);
                    $translate.use(language);
                });

            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title';

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function() {
                if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
                    stateChangeStart();
                }
                if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
                    stateChangeSuccess();
                }
            });
        }
    }
})();
;
(function () {
  'use strict';

  angular
    .module('edistradadhluiApp')
    .run(versionCheckOnStateChange);

  versionCheckOnStateChange.$inject = ['$rootScope', 'VersionCheck'];

  function versionCheckOnStateChange($rootScope, VersionCheck) {
    $rootScope.$on('$stateChangeStart', function () {
      VersionCheck.checkAndReloadIfNeeded();
    });
  }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "pl"');
                $cookies.putObject(name, 'pl');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        //$translateProvider.preferredLanguage('pl');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(ngMaterialConfig);

    ngMaterialConfig.$inject = ['$mdThemingProvider', '$mdDateLocaleProvider'];

    function ngMaterialConfig($mdThemingProvider, $mdDateLocaleProvider) {
        $mdThemingProvider.theme('default')
            .primaryPalette('red')
            .accentPalette('red');

        $mdDateLocaleProvider.firstDayOfWeek = 1;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('dhl-portal-');
        $sessionStorageProvider.setKeyPrefix('dhl-portal-');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //enable CSRF
        $httpProvider.defaults.xsrfCookieName = '__Host-CSRF-TOKEN';
        $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-TOKEN';

        //Cache everything except REST API requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*i18n.*/,/.*api.*/], true);

        $urlRouterProvider.otherwise('/');

        // tmp solution no 'home page' currently
        $urlRouterProvider.when('', ['$state', '$match', 'Principal', function($state, $match, Principal) {
            Principal.identity().then(function(response) {
                if (response) {
                    $state.go(Principal.hasInvoiceRead() ? 'documents' : (Principal.hasUserReceivablesAccess() || Principal.hasAdminReceivablesAccess() ? 'receivables' : 'settings'));
                } else {
                    $state.go('login');
                }
            });

        }]);
        $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        $httpProvider.defaults.headers.common['X-Frame-Options'] = 'DENY';


        $httpProvider.interceptors.push('serviceUnavailableInterceptor');
        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');

        $urlMatcherFactoryProvider.type('boolean', {
            name: 'boolean',
            decode: function(val) {
                return val === true || val === 'true';
            },
            encode: function(val) {
                return val ? 1 : 0;
            },
            equals: function(a, b) {
                return this.is(a) && a === b;
            },
            is: function(val) {
                return [true, false, 0, 1].indexOf(val) >= 0;
            },
            pattern: /bool|true|0|1/
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(dateFormatConfig);

    dateFormatConfig.$inject = ['$mdDateLocaleProvider'];

    function dateFormatConfig($mdDateLocaleProvider) {
         $mdDateLocaleProvider.formatDate = function(date) {

            if (date!=null){
                  var day = date.getDate();
                  var monthIndex = date.getMonth();
                  var year = date.getFullYear();

                  return year + '-' + ((monthIndex + 1 < 10 ? '0':'') + (monthIndex + 1)) + '-' + ((day < 10 ? '0':'')+day)  ;
            } else {
                 return "";
            }
         };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('site', {
                abstract: true,
                views: {
                    'footer@': {
                        templateUrl: 'app/layouts/footer/footer.html'
                    },
                     'shell@': {
                         templateUrl: 'app/layouts/shell/shell.html',
                         controller: 'ShellController',
                         controllerAs: 'vm'
                     }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                    }]
                }

            })
            .state('application', {
                parent: 'site',
                abstract: true,
                url: '/app',
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/application/application.html'
                    }
                },
                resolve: {
                    authorize: ['Auth',
                        function (Auth) {
                            return Auth.authorize();
                        }
                    ]
                }
            });
    }
})();
;
/*
This file contains declarations for not-everywhere supported JavaScript functions.
*/

if (!String.prototype.endsWith) {
    String.prototype.endsWith = function(searchString, position) {
        var subjectString = this.toString();
        if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
            position = subjectString.length;
        }
        position -= searchString.length;
        var lastIndex = subjectString.lastIndexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    };
}

if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function(searchElement, fromIndex) {

        var k;

        // 1. Let o be the result of calling ToObject passing
        //    the this value as the argument.
        if (this == null) {
            throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        // 2. Let lenValue be the result of calling the Get
        //    internal method of o with the argument "length".
        // 3. Let len be ToUint32(lenValue).
        var len = o.length >>> 0;

        // 4. If len is 0, return -1.
        if (len === 0) {
            return -1;
        }

        // 5. If argument fromIndex was passed let n be
        //    ToInteger(fromIndex); else let n be 0.
        var n = +fromIndex || 0;

        if (Math.abs(n) === Infinity) {
            n = 0;
        }

        // 6. If n >= len, return -1.
        if (n >= len) {
            return -1;
        }

        // 7. If n >= 0, then Let k be n.
        // 8. Else, n<0, Let k be len - abs(n).
        //    If k is less than 0, then let k be 0.
        k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

        // 9. Repeat, while k < len
        while (k < len) {
            // a. Let Pk be ToString(k).
            //   This is implicit for LHS operands of the in operator
            // b. Let kPresent be the result of calling the
            //    HasProperty internal method of o with argument Pk.
            //   This step can be combined with c
            // c. If kPresent is true, then
            //    i.  Let elementK be the result of calling the Get
            //        internal method of o with the argument ToString(k).
            //   ii.  Let same be the result of applying the
            //        Strict Equality Comparison Algorithm to
            //        searchElement and elementK.
            //  iii.  If same is true, return k.
            if (k in o && o[k] === searchElement) {
                return k;
            }
            k++;
        }
        return -1;
    };
}
;
(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('edistradadhluiApp')
        .constant('VERSION', "16.0.0-5-g7b01eb59")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('API_URL', "https://efaktura.dhlecommerce.pl/edistrada2/")
;
})();
;(function(){angular.module('edistradadhluiApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/components/form/clickToEdit.html','<div class="templateRoot"> <div class="hover-edit-trigger"> <div class="hover-text-field" ng-show="!editState && $root.Principal.hasClientWrite()" ng-click="edit($event)" style="height: 30px">{{model}} <button class="btn" style="margin-left:15px"><i class="fa fa-pencil"></i></button> </div> <div class="hover-text-field" ng-show="!editState && !$root.Principal.hasClientWrite()">{{model}} </div> <div class="input-group" ng-show="editState && $root.Principal.hasClientWrite()"> <input class="form-control" type="text" ng-model="model" ng-enter="toggle($event)" ng-escape="cancel($event)"> <textarea class="form-control" rows="5" cols="30" ng-model="model" ng-enter="toggle($event)" ng-escape="cancel($event)" maxlength="textLength"></textarea> <div class="input-group-btn"> <button class="btn" ng-click="save($event)"><i class="fa fa-check"></i></button> <button class="btn" ng-click="cancel($event)"><i class="fa fa-times"></i></button> </div> </div> </div> </div> ');
$templateCache.put('app/layouts/application/application.html','<div ui-view="content"> <!-- Angular views --> </div> ');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak> <div class="row"> <div class="col-md-4"> <span class="hipster img-responsive img-rounded"></span> </div> <div class="col-md-8"> <h1 translate="error.title">Error Page!</h1> <div class="alert alert-danger" translate="error.403">You are not authorized to access the page. </div> </div> </div> </div> ');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak> <div class="row"> <div class="col-md-4"> <span class="hipster img-responsive img-rounded"></span> </div> <div class="col-md-8"> <h1 translate="error.title">Error page!</h1> <div ng-show="errorMessage"> <div class="alert alert-danger">{{errorMessage}} </div> </div> </div> </div> </div> ');
$templateCache.put('app/layouts/footer/footer.html','<footer> <div class="container container-fluid"> <div class="float-left"><a href="https://www.all-for-one.pl" target="_blank"><span class="copyrights">2024 All For One Poland Sp. z o.o. </span></a></div><div class="float-right tag" id="version_text" align="right"></div> </div> </footer> ');
$templateCache.put('app/layouts/shell/shell.html','<header> <!-- Request 853087 DHL: script prepared by DHL to use for each subpage --> <script type="text/javascript">!function(e,t,n,o,a){var c=e.Startquestion=e.Startquestion||{};c.invoked?e.console&&console.warn&&console.warn("Startquestion snippet included twice."):(c.invoked=!0,c.queue=[],c.call=function(){c.queue.push(Array.prototype.slice.call(arguments))},(e=t.createElement("script")).type="text/javascript",e.async=!0,e.src=n,(t=t.getElementsByTagName("script")[0]).parentNode.insertBefore(e,t),c.call({type:"load",config:{key:o,lang:a}}))}(window,document,\'https://library.startquestion.com/current/startquestion.js\',\'ecd0d11a-40ec-11ec-8d09-00505685cca8\',\'pl\');</script> <div class="top" ng-init="vm.setupTabCloseHandling()"> <div class="container container-fluid"> <a id="top-logo" href="/"><img id="logo-top" src="content/images/DHL_rgb.png" alt="DHL eCommerce"> <span id="title-top" class="b">DHL eCommerce</span></a> <div class="user-profile"> <p> <span ng-if="$root.Principal.isAuthenticated()" ng-init="vm.setVersion()" class="nicname">{{$root.Principal.getProperty(\'login\')}}</span> <a ng-if="$root.Principal.isAuthenticated()" href="#" ng-click="vm.logout()" class="btn btn-logout"><span translate="global.logout">Wyloguj</span> <i class="fa fa-sign-out"></i></a> </p><div id="lang" ui-sref-active="active" uib-dropdown class="langController dropdown pointer" ng-controller="JhiLanguageController as languageVm"> <a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"> <span> <span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" translate="global.menu.language">Language</span> <b class="caret"></b> </span> </a> <ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"> <li active-menu="{{language}}" ng-repeat="language in languageVm.languages"> <a href="" ng-click="languageVm.changeLanguage(language);"> <img ng-src="content/images/ignore/flags/{{language}}.png" class="flag"> {{language | findLanguageFromKey}}</a> </li> </ul> </div> </div> </div> </div> <div us-spinner="{color: \'#d40511\', radius:7, width:3, length: 5, opacity:0, trail:100, top:\'27%\'}"> </div> <nav class="navbar navbar-default navbar-dhl"> <div class="container-fluid"> <!-- Brand and toggle get grouped for better mobile display --> <div class="navbar-header"> <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false"> <span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span> </button> </div> <div class="collapse navbar-collapse" style="padding-left:0px"> <ul class="nav navbar-nav"> <li> <a translate="global.menu.documents" ng-if="$root.Principal.isAuthenticated() && ($root.Principal.hasInvoiceRead() || $root.Principal.hasAllDocumentsAccess())" ui-sref="documents" ui-sref-active="active">Faktury i noty</a> </li> <li> <a translate="global.menu.receivables" ng-if="$root.Principal.isAuthenticated() && ($root.Principal.hasUserReceivablesAccess() || $root.Principal.hasAdminReceivablesAccess())" ui-sref="receivables" ui-sref-active="active">Nale\u017Cno\u015Bci</a> </li> <li> <a translate="global.menu.users" ng-if="$root.Principal.isAuthenticated() && $root.Principal.hasUserRead() && ($root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess())" ui-sref="users" ui-sref-active="active">U\u017Cytkownicy</a> </li> <li> <a translate="global.menu.users" ng-if="$root.Principal.isAuthenticated() && $root.Principal.hasUserRead() && ! $root.Principal.hasSystemAccess() && ! $root.Principal.hasTemplateAccess()" ui-sref="users" ui-sref-active="active">U\u017Cytkownicy</a> </li> <li> <a translate="global.menu.settings" ng-if="$root.Principal.isAuthenticated()" ui-sref="settings" ui-sref-active="active">Ustawienia</a> </li> <li> <a translate="global.menu.clients" ng-if="$root.Principal.isAuthenticated()" ui-sref="clients" ui-sref-active="active">Klienci</a> </li> <li> <a translate="global.menu.roles" ng-if="$root.Principal.isAuthenticated() && $root.Principal.hasSystemAccess()" ui-sref="roles" ui-sref-active="active">Role</a> </li> <li> <a translate="global.menu.pending-cases" ng-if="$root.Principal.isAuthenticated() && ($root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess())" ui-sref="pending-cases" ui-sref-active="active">Sprawy oczekuj\u0105ce</a> </li> <li> <a translate="global.menu.system-settings" ng-if="$root.Principal.isAuthenticated() && ($root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess())" ui-sref="system-settings" ui-sref-active="active">Ustawienia systemu</a> </li> <li> <a translate="global.menu.contact" ui-sref="contact" ui-sref-active="active">Kontakty DHL</a> </li> <li> <a translate="global.menu.help" ui-sref="help" ui-sref-active="active">Pomoc</a> </li> </ul> </div> </div> </nav> </header> ');
$templateCache.put('app/views/clients/clientsPanel.html','<section class="container container-fluid" ui-view="innerContent"> </section> ');
$templateCache.put('app/views/documents/documents.html','<section class="container container-fluid"> <div id="fixed" class="container container-fluid embedded-page-padding" dynamic-height dh-element-id="#under-fixed"> <portal-alert></portal-alert> <form name="filterForm" class="form-inline" accept-charset="UTF-8" enctype="multipart/form-data"> <fieldset> <div class="form-group"> <label class="control-label"><span translate="documents.document.custNumber">Numer klienta</span>:</label> <input class="form-control margin-bottom input-sm" type="text" id="cli_number" name="client_number" ng-model="vm.filter.clientNo" nip> </div> <div class="form-group"> <label class="control-label"><span translate="documents.document.payerNumber">Numer p\u0142atnika</span>:</label> <input class="form-control margin-bottom input-sm" type="text" id="payer_number" name="payer_number" ng-model="vm.filter.payerNo" nip> </div> <div class="form-group"> <label class="control-label"><span translate="documents.document.custName">Nazwa klienta</span>:</label> <input class="form-control margin-bottom input-sm" type="text" id="clientName" name="clientName" ng-model="vm.filter.clientName"> </div> <div class="form-group"> <label class="control-label"><span translate="documents.document.docNumber">Numer dokumentu</span>:</label> <input class="form-control margin-bottom input-sm" type="number" step="1" min="0" id="document_number_start" name="document_number_start" ng-model="vm.filter.documentNoFrom" placeholder="{{ vm.translate(\'from\') }}" nip> </div> <div class="form-group"> <label class="control-label">&nbsp;</label> <input class="form-control margin-bottom input-sm" type="number" step="1" min="0" id="document_number_end" name="document_number_end" ng-model="vm.filter.documentNoTo" placeholder="{{ vm.translate(\'to\') }}" nip> </div> <div class="form-group"> <label class="control-label" for="waybill"><span translate="documents.document.waybillNumber">Numer listu przewozowego</span>:</label> <input class="form-control margin-bottom input-sm" type="text" id="waybill" name="waybill" ng-model="vm.filter.waybillNo" nip> </div> <div class="form-group"> <div class="form-group"> <label class="control-label"><span translate="documents.document.issueDate">Data wystawienia</span>:</label> <div class="form-control-am-picker margin-bottom"> <md-datepicker class="datepicker" id="date_start" ng-model="vm.tempIssueDateFrom" md-placeholder="{{ vm.translate(\'from\') }}"></md-datepicker> </div> </div> <div class="form-group"> <label class="control-label"><span></span></label> <div class="form-control-am-picker margin-bottom"> <md-datepicker class="datepicker" id="date_end" name="date_end" ng-model="vm.tempIssueDateTo" md-placeholder="{{ vm.translate(\'to\') }}"></md-datepicker> </div> </div> </div> <div class="form-group"> <label class="control-label"><span translate="documents.document.docType">Typ dokumentu</span>:</label> <select class="form-control margin-bottom input-sm" name="doc_type" id="doc_type" ng-model="vm.filter.documentType"> <option default value="">-- {{ vm.translate(\'documents.document.choose\') }} --</option> <option value="invoice">{{ vm.translate(\'documents.document.invoice\') }}</option> <option value="correction">{{ vm.translate(\'documents.document.correctingInvoice\') }}</option> <option value="note">{{ vm.translate(\'documents.document.accountingNote\') }}</option> <option value="annex">{{ vm.translate(\'documents.document.annex\') }}</option> </select> </div> <div class="form-group"> <div class="form-group"> <label class="control-label"><span translate="documents.document.grossAmount">Kwota brutto</span>:</label> <input class="form-control form-control-short margin-bottom input-sm" smart-float ng-pattern="/^[-]?[0-9]+([.,][0-9]{1,2})?$/" type="number" id="amount_from" name="amount_from" placeholder="{{ vm.translate(\'from\') }}" ng-model="vm.filter.amountBruttoFrom" step="0.01"> </div> <div class="form-group"> <label class="control-label">&nbsp;</label> <input class="form-control form-control-short margin-bottom input-sm" smart-float ng-pattern="/^[-]?[0-9]+([.,][0-9]{1,2})?$/" type="number" id="amount_to" name="amount_to" placeholder="{{ vm.translate(\'to\') }}" ng-model="vm.filter.amountBruttoTo" step="0.01"> </div> </div> <div class="form-group"> <label><span translate="documents.document.dateOfPayment">Termin p\u0142atno\u015Bci</span>:</label> <div class="form-control-am-picker margin-bottom"> <md-datepicker class="datepicker" md-placeholder="{{vm.translate(\'documents.document.choose\') }}" id="due_date" name="due_date" ng-model="vm.tempDueDate"></md-datepicker> </div> </div> <div class="form-group"> <label class="">&nbsp;</label> <div> <button type="submit" id="search" class="btn margin-bottom" ng-click="vm.resetAndList()"><span translate="documents.document.search">Szukaj</span> <i class="fa fa-search"></i> </button> </div> </div> <div class="form-group"> <label class="">&nbsp;</label> <div> <button type="reset" id="delete" class="btn margin-bottom" ng-click="vm.resetSearch()"><span translate="documents.document.clear">Czy\u015B\u0107</span> <i class="fa fa-eraser"></i></button> </div> </div> </fieldset> </form> <div class="actionButtons row"> <div class="col-xs-7"> <button class="btn" id="downloadButton" title="Download" type="button" ng-click="vm.getPDFs()" ng-disabled=" vm.ediDocIds.length == \'0\'"> <span translate="documents.document.download">Pobierz</span> <i class="fa fa-download"></i> </button> <!--                <button class="btn " id="excelButton" title="Download" type="button" ng-click="vm.getXlsx()">\n                    <span translate="documents.document.generateReport">Wygeneruj raport</span>\n                    <i class="fa fa-table"></i>\n                </button>--> <a target="_blank" class="btn" id="excelButton" title="Download" ng-href="{{vm.getXlsxURL()}}"> <span translate="documents.document.generateReport">Wygeneruj raport</span> <i class="fa fa-table"></i> </a> <button class="btn" ng-if="$root.Principal.hasTemplateAccess()" id="resendButton" title="Download" type="button" ng-click="vm.resend()" ng-disabled=" vm.ediDocIds.length == \'0\'"> <span translate="documents.document.sendAgain">Wy\u015Blij ponownie</span> <i class="fa fa-envelope"></i> </button> </div> <md-input-container class="col-xs-5"> <md-select class="btn pull-right md-no-underline" ng-model="vm.selectedColumns" ng-model-options="{trackBy: \'$value.name\'}" multiple="" md-on-close="onClose()" aria-label="Kolumny" md-selected-text="vm.translate(\'documents.document.chooseColumns\')" md-container-class="columnConfiguration"> <md-option ng-repeat="column in vm.columnHeaders" ng-value="column" ng-if="column.enabled"> <span translate="{{column.translate}}">{{column.label}}</span> </md-option> </md-select> </md-input-container> <div class="col-xs-12 text-center" ng-if="vm.resultParameters.limit" style="margin: 10px 0 5px 0"> <b translate="documents.search.last1000">Wy\u015Bwietlane jest 1000 ostatnich dokument\xF3w. W celu zobaczenia pozosta\u0142ych za\u0142\u0105cznik\xF3w do dokument\xF3w zaw\u0119\u017A filtry.</b> </div> <div class="col-xs-12 text-center" ng-if="vm.resultParameters.upper_date_bound || vm.resultParameters.lower_date_bound" style="margin: 10px 0 5px 0"> <b translate="documents.search.lastDate">Wy\u015Bwietlane s\u0105 dokumenty z ostatniego miesi\u0105ca spe\u0142niaj\u0105cego kryteria. W celu zobaczenia pozosta\u0142ych za\u0142\u0105cznik\xF3w do dokument\xF3w zaw\u0119\u017A filtry.</b> </div> </div> </div> <div id="under-fixed"> <div style="width: 100%; overflow-x : auto"> <table id="fixtable" class="tablesorter latest" fix-table ng-show="vm.invoices.length > 0"> <thead> <tr> <th ng-click="vm.checkAllDocs($event)" ng-model="vm.allChecked"> <input type="checkbox"> </th> <th ng-show="vm.columns.clientNumber"> <a href="#" ng-click="vm.sortBy(\'clientNumber\', !vm.sortReverse)"> <span translate="documents.document.customer">Klient</span> <span ng-show="vm.sortType == \'clientNumber\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'clientNumber\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.payerNumber"> <a href="#" ng-click="vm.sortBy(\'payerNumber\', !vm.sortReverse)"> <span translate="documents.document.payer">P\u0142atnik</span> <span ng-show="vm.sortType == \'payerNumber\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'payerNumber\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="$root.Principal.hasUserRead() && vm.columns.dateOpen"> <a href="#" ng-click="vm.sortBy([\'openStatus\',\'dateOpen\'], !vm.sortReverse)"> <span translate="documents.document.open">Otwarty</span> <span ng-show="vm.showCarretOnOpenColumn && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.showCarretOnOpenColumn && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.documentType"> <a href="#" ng-click="vm.sortBy(\'documentType\', !vm.sortReverse)"> <span translate="documents.document.docType">Typ dokumentu</span> <span ng-show="vm.sortType == \'documentType\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'documentType\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.documentNumber"> <a href="#" ng-click="vm.sortBy(\'documentNumber\', !vm.sortReverse)"> <span translate="documents.document.docNumber">Numer dokumentu</span> <span ng-show="vm.sortType == \'documentNumber\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'documentNumber\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.dateIssue"> <a href="#" ng-click="vm.sortBy(\'dateIssue\', !vm.sortReverse)"> <span translate="documents.document.issueDate">Data wystawienia</span> <span ng-show="vm.sortType == \'dateIssue\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'dateIssue\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.dateSent"> <a href="#" ng-click="vm.sortBy(\'dateSent\', !vm.sortReverse)"> <span translate="documents.document.shippingDate">Data wysy\u0142ki</span> <span ng-show="vm.sortType == \'dateSent\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'dateSent\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.dueDate"> <a href="#" ng-click="vm.sortBy(\'dueDate\', !vm.sortReverse)"> <span translate="documents.document.dateOfPayment">Termin p\u0142atno\u015Bci</span> <span ng-show="vm.sortType == \'dueDate\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'dueDate\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.totalNetto"> <a href="#" ng-click="vm.sortBy(\'totalNetto\', !vm.sortReverse)"> <span translate="documents.document.netAmount">Kwota netto</span> <span ng-show="vm.sortType == \'totalNetto\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'totalNetto\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.totalVat"> <a href="#" ng-click="vm.sortBy(\'totalVat\', !vm.sortReverse)"> <span translate="documents.document.vatAmount">Kwota VAT</span> <span ng-show="vm.sortType == \'totalVat\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'totalVat\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.totalGross"> <a href="#" ng-click="vm.sortBy(\'totalGross\', !vm.sortReverse)"> <span translate="documents.document.grossAmount">Kwota brutto</span> <span ng-show="vm.sortType == \'totalGross\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'totalGross\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> </tr> </thead> <tbody> <tr id="topSpacer"> <td colspan="{{vm.columns.totalVisible}}" style="padding: 0 !important; margin: 0 !important"> </td> </tr> <tr ng-repeat="invoice in vm.invoices | limitTo:vm.limit:vm.topIndex track by invoice.ediDocId" ng-click="vm.goToPDF(invoice.ediDocId)"> <td ng-click="vm.checkboxClick($event, $index, invoice.ediDocId)"> <input type="checkbox" ng-model="invoice.selected"> </td> <td ng-show="vm.columns.clientNumber">{{ ::invoice.clientNumber }}</td> <td ng-show="vm.columns.payerNumber">{{ ::invoice.payerNumber }}</td> <td ng-show="$root.Principal.hasUserRead() && vm.columns.dateOpen">{{ ::vm.filterDateOpen(invoice.openStatus,invoice.dateOpen) }}</td> <td ng-show="vm.columns.documentType">{{ vm.filterInvoiceType(invoice.documentType)}}</td> <td ng-show="vm.columns.documentNumber">{{ ::invoice.documentNumber}} </td> <td ng-show="vm.columns.dateIssue">{{ ::invoice.dateIssue | date:\'yyyy-MM-dd\' }} </td> <td ng-show="vm.columns.dateSent">{{ invoice.dateSent | date:\'yyyy-MM-dd\' }}</td> <td ng-show="vm.columns.dueDate">{{ ::invoice.datePayment | date:\'yyyy-MM-dd\' }} </td> <td ng-show="vm.columns.totalNetto">{{ ::invoice.totalNetto | number:2}}</td> <td ng-show="vm.columns.totalVat">{{ ::invoice.totalVat | number:2 }}</td> <td ng-show="vm.columns.totalGross">{{ ::invoice.totalGross | number:2}}</td> </tr> <tr id="bottomSpacer"> <td colspan="{{vm.columns.totalVisible}}" style="padding: 0 !important; margin: 0 !important"> </td> </tr> </tbody> <tfoot> <tr> <td>&nbsp;</td> <td colspan="{{vm.columns.footer ? vm.columns.footerSum-1 : vm.columns.totalVisible-1}}" ng-show="(vm.columns.footer && vm.columns.footerSum > 1) || (!vm.columns.footer && vm.columns.totalVisible > 1)"> <span translate="documents.document.sumOfDocs" ng-show="vm.columns.footer ">Suma dla dokument\xF3w prezentowanych powy\u017Cej:</span> </td> <td ng-show="vm.columns.totalNetto"> {{vm.sumTotalNetto | number:2}} </td> <td ng-show="vm.columns.totalVat"> {{vm.sumTotalVat | number:2}} </td> <td ng-show="vm.columns.totalGross"> {{vm.sumTotalBrutto | number:2}} </td> </tr> </tfoot> </table> </div> </div> </section> ');
$templateCache.put('app/views/documents/download.html','<div class="modal-header"> <h3 class="modal-title" translate="documents.download.title">Pobieranie</h3> </div> <form id="resend" class="inline inline-search" novalidate accept-charset="UTF-8"> <div class="modal-body"> <div class="container-fluid"> <div class="row"> <div style="padding:5px"><span translate="documents.download.download">Pobierz</span>:</div> <div style="padding:5px"> <input type="checkbox" ng-model="vm.data.downloadPDF"> <span translate="documents.download.downloadPdf"></span> </div> <div style="padding:5px"> <input type="checkbox" ng-model="vm.data.downloadWaybill"> <span translate="documents.download.downloadWaybill"></span> </div> </div> </div> </div> <div class="modal-footer"> <!--        <button class="btn" type="submit " ng-click="vm.modal.download()">\n            <span translate="documents.download.download">Pobierz</span>\n            <i class="fa fa-download"></i>\n        </button>--> <a target="_blank" ng-click="vm.modal.download()" ng-href="{{vm.getPdfsURL(vm.data.ediDocIds, vm.data.downloadPDF, vm.data.downloadWaybill)}}" class="btn"> <span translate="documents.download.download">Pobierz</span> <i class="fa fa-download"></i> </a> <button class="btn btn-warning" type="button" ng-click="vm.modal.cancel()"> <span translate="documents.download.cancel">Anuluj</span> <i class="fa fa-times"></i> </button> </div> </form> ');
$templateCache.put('app/views/documents/resend.html','<div class="modal-header"> <h3 class="modal-title"><span translate="documents.resend.title"> Ponowne wysy\u0142anie dokument\xF3w</span></h3> </div> <form id="resend" class="inline inline-search" novalidate accept-charset="UTF-8"> <div class="modal-body"> <div class="container-fluid"> <div class="row"> <div style="padding:5px"><span translate="documents.resend.sendTo">Wy\u015Blij ponownie na :</span></div> <div style="padding:5px"> <input type="radio" ng-model="vm.resendSelect" value="same"> <span translate="documents.resend.sameEmail"> Te same adresy email</span> </div> <div style="padding:5px"> <input type="radio" ng-model="vm.resendSelect" value="new"> <span translate="documents.resend.newEmail"> Nowe jednorazowe adresy e-mail (po \u015Bredniku, np. user@dhl.com;user2@dhl.com)</span> </div> <fieldset> <div style="padding:5px"> <label for="newEmail"><span translate="documents.resend.email">E-mail:</span></label> <input id="newEmail" ng-disabled="vm.resendSelect == \'same\'" type="text" ng-model="vm.data.email" ng-change="vm.validateEmail(vm.data.email)"> </div> </fieldset> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary" type="submit" ng-click="vm.modal.send()" ng-disabled="vm.resendSelect == \'new\' && vm.emailValidated ==false"> <span translate="documents.resend.send">Wy\u015Blij</span> <i class="fa fa-envelope"></i> </button> <button class="btn btn-warning" type="button" ng-click="vm.modal.cancel()"> <span translate="documents.resend.cancel">Anuluj</span> <i class="fa fa-times"></i> </button> </div> </form> ');
$templateCache.put('app/views/error/401.html','<div class="row embedded-page-padding"> <div class="col-md-12"> <h2 class="no-m-top"><span translate="error.401.title"> Nie jeste\u015B zalogowany</span></h2> </div> </div> <div class="row"> <div class="col-md-12"> <h7 class="no-m-top" style="text-align: left"> <span translate="error.401.info">Twoja sesja wygas\u0142a lub zosta\u0142e\u015B wylogowany.</span> <br><b> <span translate="error.401.info2">Zaloguj si\u0119 ponownie.</span> </b></h7> </div> </div> <div class="row error-footer border-dotted-top"> <a ui-sref="login" class="btn btn-primary btn-round btn-fill"> <span translate="error.401.login">Zaloguj</span> </a> </div> ');
$templateCache.put('app/views/error/403.html','<div class="row embedded-page-padding"> <div class="col-md-8"> <h2 class="no-m-top"><span translate="error.403.title">Nie masz dost\u0119pu do tego zasobu</span></h2> </div> </div> <div class="row"> <div class="col-md-8"> <h7 class="no-m-top" style="text-align: left"> <span translate="error.403.info">Nie masz uprawnie\u0144, \u017Ceby ogl\u0105da\u0107 ten zas\xF3b.</span> </h7> </div> </div> <div class="row error-footer border-dotted-top"> <a ui-sref="login" class="btn btn-primary btn-round btn-fill"> <span translate="error.403.back">Powr\xF3t</span> </a> </div> ');
$templateCache.put('app/views/error/404.html','<section class="container container-fluid embedded-page-padding"> <h1 class="title"><span translate="error.404.title">Podana strona nie istnieje</span></h1> <errors></errors> <statements></statements> <p> <span translate="error.404.info"> Prawdopodobnie wpisa\u0142e\u015B z\u0142y adres lub klikn\u0105\u0142e\u015B w niewa\u017Cny link. </span> </p> <br> <button class="btn" ui-sref="{{$root.Principal.isAuthenticated() ? ($root.Principal.hasInvoiceRead() ? \'documents\' : (Principal.hasUserReceivablesAccess() || Principal.hasAdminReceivablesAccess() ? \'receivables\' : \'settings\')) : \'login\'}}"> <span translate="error.404.back">Powr\xF3t</span></button> </section> ');
$templateCache.put('app/views/error/error.html','<div ui-view="error"></div> <!-- section --> ');
$templateCache.put('app/views/contact/contact.html','<section class="container container-fluid embedded-page-padding"> <div class="contactdhl" style="display: inline-block; text-align: left"> <h2 class="b black frutiger"><span translate="contact.howToContact">W jaki spos\xF3b mog\u0119 si\u0119 skontaktowa\u0107 z DHL eCommerce?</span></h2> <div> <p class="b"><span translate="contact.financialComplaintInfo">Reklamacj\u0119 finansow\u0105 zg\u0142o\u015B korzystaj\u0105c z </span> <a target="_blank" ng-href="{{vm.language() == \'pl\' ? \'https://ecom.dhl.com.pl/reklamacjefaktur/?lang=pl-pl\':\'https://ecom.dhl.com.pl/reklamacjefaktur/?lang=en-gb\'}}"> <span translate="contact.link">linka</span> </a> </p> <p class="small"><span translate="contact.financialComplaintExample">(np. nieprawid\u0142owe op\u0142aty, b\u0142\u0119dny p\u0142atnik)</span></p> <p class="b"><span translate="contact.qualityComplaintInfo">Reklamacj\u0119 jako\u015Bciow\u0105/szkodow\u0105 zg\u0142o\u015B korzystaj\u0105c z </span> <a target="_blank" ng-href="{{vm.language() == \'pl\' ? \'https://www.dhlecommerce.pl/pl/dla-ciebie/obsluga/kontakt/reklamacje.html\':\'https://www.dhlecommerce.pl/en/private-customers/customer-service/contact/claims.html\'}}"> <span translate="contact.link">linka</span> </a> </p> <p class="small"><span translate="contact.qualityComplaintExample">(np. uszkodzenie przesy\u0142ki, nieterminowe dor\u0119czenie)</span></p> <p class="b" style="padding-bottom: 1em"><span translate="contact.visitHomepage">Odwiedzaj\u0105c stron\u0119 internetow\u0105 </span><a target="_blank" ng-href="{{vm.language() == \'pl\' ? \'https://www.dhlecommerce.pl/pl/dla-ciebie.html\':\'https://www.dhlecommerce.pl/en/private-customers.html\'}}">DHL eCommerce</a></p> <p class="b"><span translate="contact.contactCustomerService">Kontaktuj\u0105c si\u0119 z Dzia\u0142em Obs\u0142ugi Klienta DHL eCommerce</span></p> <p class="small"><span translate="contact.domesticAndEconomic">Przesy\u0142ki krajowe i ekonomiczne przesy\u0142ki mi\u0119dzynarodowe</span> <br><span translate="contact.phone"> Telefon:</span> 42 6 345 345</p> <p class="small paragraph"><span translate="contact.fillForm">Skontaktuj si\u0119 z </span> <a target="_blank" ng-href="{{vm.language() == \'pl\' ? \'https://www.dhlecommerce.pl/pl/dla-ciebie/obsluga/kontakt.html\':\'https://www.dhlecommerce.pl/en/private-customers/customer-service/contact.html\'}}"> <span translate="contact.form">nami</span> </a> <span translate="contact.response"> a my odpowiemy:</span> <br><span translate="contact.responseTimeWeek"> w dni powszednie w godzinach 7.00 - 20.00</span> <br><span translate="contact.responseTimeWeekend"> w soboty w godzinach 8.00 - 16.00</span></p> <p class="b" style="padding-bottom: 1em"><span translate="contact.use">Skorzystaj z </span><a target="_blank" href="https://dhl24.com.pl/start/index.html">DHL24</a></p> </div> </div> </section> ');
$templateCache.put('app/views/help/help.html','<section id="topid" class="embedded-page-padding"> <section class="container-fluid"> <section class="help section-help col-md-6 col-sm-7"> <div> <div class="container-service"> <div class="title help-faq" translate="help.faq">Najcz\u0119\u015Bciej zadawane pytania</div> <table class="service"> <tbody> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip1"> <span translate="help.q1">q1</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip2"> <span translate="help.q2">q2?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip3"> <span translate="help.q3">q3</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip4"> <span translate="help.q4">q4</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip5"> <span translate="help.q5">q5</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip6"> <span translate="help.q6">q6</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tipAfter6"> <span translate="help.qAfter6">qAfter6</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip7"> <span translate="help.q7">q7</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip8"> <span translate="help.q8">q8</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip9"> <span translate="help.q9">q9</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip10"> <span translate="help.q10">q10</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip11"> <span translate="help.q11">q11</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip12"> <span translate="help.q12">q12</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip13"> <span translate="help.q13">q13</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip14"> <span translate="help.q14">Co to jest e-faktura?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip15"> <span translate="help.q15">Jaka jest r\xF3\u017Cnica pomi\u0119dzy e-faktur\u0105 a faktur\u0105 papierow\u0105?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip16"> <span translate="help.q16">Czy e-faktura jest bezpieczna?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip17"> <span translate="help.q17">Czy z e-faktur\u0105 wi\u0105\u017C\u0105 si\u0119 dodatkowe op\u0142aty?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip18"> <span translate="help.q18">Co nale\u017Cy zrobi\u0107, aby otrzymywa\u0107 e-faktury?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip19"> <span translate="help.q19">Jak si\u0119 dowiem, \u017Ce e-faktura zosta\u0142a aktywowana?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip20"> <span translate="help.q20">Jak b\u0119dzie dzia\u0142a\u0107 us\u0142uga e-faktury w DHL eCommerce?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip21"> <span translate="help.q21">Jakie funkcjonalno\u015Bci s\u0105 dost\u0119pne w aplikacji eFaktura DHL eCommerce?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip22"> <span translate="help.q22">Czy linki w e-mailach s\u0105 aktywne bezterminowo?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip23"> <span translate="help.q23">Czy informacja o nowej e-fakturze mo\u017Ce by\u0107 wysy\u0142ana tylko na jeden adres e-mail?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip24"> <span translate="help.q24">Jak d\u0142ugo e-faktury b\u0119d\u0105 dost\u0119pne w aplikacji eFaktura DHL eCommerce?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip25"> <span translate="help.q25">Nie mog\u0119 odszuka\u0107 e-faktury w aplikacji eFaktura DHL eCommerce. Co mam zrobi\u0107?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip26"> <span translate="help.q26">Jak potwierdzi\u0107, \u017Ce otrzymana e-faktura zosta\u0142a wystawiona przez DHL eCommerce?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip27"> <span translate="help.q27">Czy musz\u0119 instalowa\u0107 dodatkowe oprogramowanie, aby otrzyma\u0107 e-faktury?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip28"> <span translate="help.q28">W jakim formacie jest dost\u0119pna e-faktura?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip29"> <span translate="help.q29">Czy e-faktura b\u0119dzie zawiera\u0142a wykaz przesy\u0142ek?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip30"> <span translate="help.q30">Czy mog\u0119 dokona\u0107 p\u0142atno\u015Bci online za e-faktur\u0119?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip31"> <span translate="help.q31">Jak dokona\u0107 zmiany adresu e-mail, na kt\xF3ry wysy\u0142ane s\u0105 powiadomienia o e-fakturze?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip32"> <span translate="help.q32">Czy mog\u0119 zaktualizowa\u0107 dane mojej firmy online?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip33"> <span translate="help.q33">W jaki spos\xF3b mog\u0119 z\u0142o\u017Cy\u0107 reklamacj\u0119 do e-faktury?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip34"> <span translate="help.q34">Czy mo\u017Cliwe jest jednoczesne otrzymywanie faktur w formie elektronicznej i papierowej?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip35"> <span translate="help.q35"></span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip36"> <span translate="help.q36">W jaki spos\xF3b mog\u0119 zrezygnowa\u0107 z e-faktury?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> </tbody> </table> </div> <br> </div> </section> <section class="help col-md-6 col-sm-5"> <div class="outer_center"> <div class="contactbox"> <div class="help-more-info"> <h2 class="b" translate="help.more-info">Gdzie mog\u0119 uzyska\u0107 wi\u0119cej informacji?</h2> <div> <p class="b"> <b translate="help.website">Strona internetowa DHL eCommerce</b> </p> <p class="contact"> <a target="_blank" ng-href="{{vm.language() == \'pl\' ? \'https://www.dhlecommerce.pl/pl/dla-ciebie.html\':\'https://www.dhlecommerce.pl/en/private-customers.html\'}}"> www.dhlecommerce.pl </a> </p> </div> <div class="voffset2"> <p class="b"> <b translate="help.contact">Dzia\u0142 Obs\u0142ugi Klienta DHL eCommerce</b> </p> <p class="contact"> <span translate="help.shipments">Przesy\u0142ki krajowe i ekonomiczne przesy\u0142ki mi\u0119dzynarodowe</span> <br> <span translate="help.phone">Telefon</span>: 42 6 345 345 <br> <span translate="help.weekdays">Poniedzia\u0142ek - pi\u0105tek w godzinach: 7.00 - 20.00</span> <br> <span translate="help.saturdays">Sobota w godzinach: 8.00 - 16.00</span> <br> </p> </div> <div class="voffset2"> <p class="b"> <b translate="help.einvoice-team">Zesp\xF3\u0142 e-fakturowania DHL eCommerce</b> </p> <p class="contact"> <a href="mailto:epomoc.dhlecommerce@dhl.com">epomoc.dhlecommerce@dhl.com</a> <br> </p> </div> </div> </div> </div> </section> </section> <hr id="tip1"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q1">q1</span> </h2> <div> <p translate="help.a1">a1</p> </div> </section> <hr id="tip2"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q2">q2</span> </h2> <div> <ul> <li class="list"> <p translate="help.a2a">a2a</p> </li> <li class="list"> <p translate="help.a2b">a2b</p> </li> <li class="list"> <p translate="help.a2c">a2c</p> </li> <li class="list"> <p translate="help.a2d">a2d</p> </li> </ul> </div> </section> <hr id="tip3"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q3">q3</span> </h2> <div> <p translate="help.a3">a3</p> <ul> <li class="list"> <p translate="help.a3a">a3a</p> </li> <li class="list"> <p translate="help.a3b">a3b</p> </li> <li class="list"> <p translate="help.a3c">a3c</p> </li> <li class="list"> <p translate="help.a3d">a3d</p> </li> <li class="list"> <p translate="help.a3e">a3e</p> </li> <li class="list"> <p translate="help.a3f">a3f</p> </li> <li class="list"> <p translate="help.a3g">a3g</p> </li> <li class="list"> <p translate="help.a3h">a3h</p> </li> <li class="list"> <p translate="help.a3i">a3i</p> </li> <li class="list"> <p translate="help.a3j">a3j</p> </li> <li class="list"> <p translate="help.a3k">a3k</p> </li> <li class="list"> <p translate="help.a3l">a3l</p> </li> <li class="list"> <p translate="help.a3m">a3m</p> </li> </ul> </div> </section> <hr id="tip4"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q4">q4</span> </h2> <div> <p translate="help.a4">a4</p> </div> </section> <hr id="tip5"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q5">q5</span> </h2> <div> <ul> <li class="list"> <p translate="help.a5a">a5a</p> </li> <li class="list"> <p translate="help.a5b">a5b</p> </li> </ul> </div> </section> <hr id="tip6"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q6">q6</span> </h2> <div> <p translate="help.a6">a6</p> </div> </section> <hr id="tipAfter6"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.qAfter6">qAfter6</span> </h2> <div> <p translate="help.aAfter6">aAfter6</p> </div> </section> <hr id="tip7"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q7">q7</span> </h2> <div> <p translate="help.a7">a7</p> </div> </section> <hr id="tip8"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q8">q8</span> </h2> <div> <p translate="help.a8">a8</p> </div> </section> <hr id="tip9"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q9">q9</span> </h2> <div> <p translate="help.a9">a9</p> </div> </section> <hr id="tip10"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q10">q10</span> </h2> <div> <p translate="help.a10">a10</p> </div> </section> <hr id="tip11"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q11">q11</span> </h2> <div> <p translate="help.a11">a11</p> <ul> <li class="list"> <p translate="help.a11a">a11a</p> </li> <li class="list"> <p translate="help.a11b">a11b</p> </li> <li class="list"> <p translate="help.a11c">a11c</p> </li> </ul> </div> </section> <hr id="tip12"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q12">q12</span> </h2> <div> <p translate="help.a12">a12</p> </div> </section> <hr id="tip13"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q13">q13</span> </h2> <div> <p translate="help.a13">a13</p> <ul> <li class="list"> <p translate="help.a13a">a13a</p> </li> <li class="list"> <p translate="help.a13b">a13b</p> </li> <li class="list"> <p translate="help.a13c">a13c</p> </li> <li class="list"> <p translate="help.a13d">a13d</p> </li> <li class="list"> <p translate="help.a13e">a13e</p> </li> <li class="list"> <p translate="help.a13f">a13f</p> </li> </ul> </div> </section> <hr id="tip14"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q14">Co to jest e-faktura?</span> </h2> <div> <p translate="help.a14"> E-faktura jest odpowiednikiem faktury papierowej w wersji elektronicznej i ma tak\u0105 sam\u0105 moc prawn\u0105 jak zwyk\u0142a faktura. <br> <br> <u>Podstawa prawna:</u> <br> Ustawa o podatku od towar\xF3w i us\u0142ug z dnia 11 marca 2004 roku (Dz.U. Nr 54, poz. 535, z p\xF3\u017Aniejszymi zmianami). </p> </div> </section> <hr id="tip15"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q15">Jaka jest r\xF3\u017Cnica pomi\u0119dzy e-faktur\u0105 a faktur\u0105 papierow\u0105?</span> </h2> <div> <p translate="help.a15">R\xF3\u017Cnica pomi\u0119dzy e-faktur\u0105 a faktur\u0105 papierow\u0105 polega tylko na sposobie jej dostarczania do Klienta. E-faktura mo\u017Ce by\u0107 wydrukowana i przechowywana w wersji papierowej, ale mo\u017Ce by\u0107 r\xF3wnie\u017C zapisana np. na dysku komputera, p\u0142ycie CD czy innym no\u015Bniku s\u0142u\u017C\u0105cym do przechowywania plik\xF3w.</p> </div> </section> <hr id="tip16"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q16">Czy e-faktura jest bezpieczna?</span> </h2> <div> <p translate="help.a16a">Tak, e-faktura jest bezpieczna. Zosta\u0142a ona zabezpieczona podpisem elektronicznym i dodatkowo wykorzystuje zaawansowane technologie szyfrowania. To rozwi\u0105zanie gwarantuje jednocze\u015Bnie szybkie przes\u0142anie i udost\u0119pnienie dokumentu, o wiele prostsze ni\u017C tradycyjne metody wysy\u0142ania i odbierania dokument\xF3w ksi\u0119gowych.</p> <br> <p translate="help.a16b">W przypadku korzystania z e-faktury w formacie PDF, w celu weryfikacji podpisu elektronicznego, nale\u017Cy zainstalowa\u0107 program Adobe Acrobat Reader ze strony <a href="https://get.adobe.com/reader/" target="_blank">producenta</a>.</p> </div> </section> <hr id="tip17"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q17">Czy z e-faktur\u0105 wi\u0105\u017C\u0105 si\u0119 dodatkowe op\u0142aty?</span> </h2> <div> <p translate="help.a17">Nie, korzystanie z e-faktur jest ca\u0142kowicie bezp\u0142atne.</p> </div> </section> <hr id="tip18"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q18">Co nale\u017Cy zrobi\u0107, aby otrzymywa\u0107 e-faktury?</span> </h2> <div> <p translate="help.a18">Aby otrzymywa\u0107 e-faktury konieczne jest wyra\u017Cenie stosownej zgody przez odbiorc\u0119 faktury:</p> <ul> <li class="list"> <p translate="help.a18a"><a href="https://efaktura.dhlecommerce.pl/#/register" target="_blank">elektronicznie</a> (podczas rejestracji w aplikacji eFaktura DHL eCommerce)</p> </li> <li class="list"> <p translate="help.a18b"> lub mailowo na adres <a href="mailto:epomoc.dhlecommerce@dhl.com">epomoc.dhlecommerce@dhl.com</a>. W tre\u015Bci e-maila nale\u017Cy poda\u0107 NIP firmy (w celu poprawnej identyfikacji Klienta) oraz adres / adresy e-mail, na kt\xF3ry maj\u0105 by\u0107 wysy\u0142ane e-faktury. </p> </li> </ul> </div> </section> <hr id="tip19"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q19">Jak si\u0119 dowiem, \u017Ce e-faktura zosta\u0142a aktywowana?</span> </h2> <div> <p translate="help.a19a">Po zatwierdzeniu rejestracji elektronicznej lub po zarejestrowaniu pisemnej zgody otworzymy dla Ciebie konto / profil w aplikacji eFaktura DHL eCommerce.</p> <p translate="help.a19b"> Z adresu <a href="mailto:efaktura.dhlecommerce@dhl.com">efaktura.dhlecommerce@dhl.com</a> otrzymasz e-mail z linkiem aktywacyjnym. Link jest aktywny przez 15 dni. Aby w pe\u0142ni korzysta\u0107 z funkcjonalno\u015Bci naszego serwisu post\u0119puj zgodnie z instrukcj\u0105 z e-maila. </p> </div> </section> <hr id="tip20"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q20">Jak b\u0119dzie dzia\u0142a\u0107 us\u0142uga e-faktury w DHL eCommerce?</span> </h2> <div> <p translate="help.a20a">Po wystawieniu faktury przez DHL b\u0119dzie ona automatycznie widoczna w aplikacji eFaktura DHL eCommerce. Jednocze\u015Bnie informacja o nowej e-fakturze zostanie wys\u0142ana na podany/podane, przy rejestracji lub w formularzu, adres/adresy e-mail.</p> <p translate="help.a20b">E-mail b\u0119dzie zawiera\u0107 link do dokumentu. Po klikni\u0119ciu w ten link otworzy si\u0119 dokument w formacie PDF, kt\xF3ry b\u0119dzie mo\u017Cna wydrukowa\u0107 lub zapisa\u0107 w wybranym miejscu. Wy\u015Bwietlenie dokumentu oraz jego zapisanie/wydrukowanie nie wymaga logowania si\u0119 do aplikacji.</p> </div> </section> <hr id="tip21"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q21">Jakie funkcjonalno\u015Bci s\u0105 dost\u0119pne w aplikacji eFaktura DHL eCommerce?</span> </h2> <div> <ul> <li class="list"> <p translate="help.a21a">Dost\u0119p do w\u0142asnych dokument\xF3w przez Internet \u2013 o ka\u017Cdej porze i z ka\u017Cdego miejsca.</p> </li> <li class="list"> <p translate="help.a21b">Mo\u017Cliwo\u015B\u0107 generowania i zapisywania raport\xF3w (np. raport faktur).</p> </li> <li class="list"> <p translate="help.a21c">Mo\u017Cliwo\u015B\u0107 przegl\u0105dania i pobierania skan\xF3w list\xF3w przewozowych.</p> </li> <li class="list"> <p translate="help.a21d">Mo\u017Cliwo\u015B\u0107 zarz\u0105dzania swoim kontem \u2013 dodawanie / usuwanie adres\xF3w e-mail, na kt\xF3re maj\u0105 by\u0107 wysy\u0142ane dokumenty.</p> </li> <li class="list"> <p translate="help.a21e">Pobieranie dokument\xF3w w formacie XLSX.</p> </li> </ul> </div> </section> <hr id="tip22"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q22">Czy linki w e-mailach s\u0105 aktywne bezterminowo?</span> </h2> <div> <p translate="help.a22">Dla bezpiecze\u0144stwa linki przesy\u0142ane w e-mailach s\u0105 aktywne przez 15 dni. Po up\u0142ywie 15 dni pobranie e-faktury b\u0119dzie w dalszym ci\u0105gu mo\u017Cliwe po zalogowaniu si\u0119 do aplikacji.</p> </div> </section> <hr id="tip23"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q23">Czy informacja o nowej e-fakturze mo\u017Ce by\u0107 wysy\u0142ana tylko na jeden adres e-mail?</span> </h2> <div> <p translate="help.a23a">Informacja o e-fakturze mo\u017Ce by\u0107 wys\u0142ana na kilka adres\xF3w e-mail. Na formularzu nale\u017Cy poda\u0107 wszystkie adresy e-mail, na kt\xF3re maj\u0105 by\u0107 wysy\u0142ane informacje o nowej e-fakturze. Mo\u017Cesz r\xF3wnie\u017C dodawa\u0107 kolejne adresy e-mail korzystaj\u0105c z zak\u0142adki "Klienci".</p> <p translate="help.a23b">W tym celu kliknij dwa razy w konto, do kt\xF3rego chcesz doda\u0107 adres e-mail. W pole U\u017Cytkownicy wpisz nowy adres e-mail; kliknij w "+" i zatwierd\u017A zmian\u0119 u\u017Cywaj\u0105c przycisku "Zapisz" znajduj\u0105cego si\u0119 na dole strony.</p> </div> </section> <hr id="tip24"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q24">Jak d\u0142ugo e-faktury b\u0119d\u0105 dost\u0119pne w aplikacji eFaktura DHL eCommerce?</span> </h2> <div> <p translate="help.a24">Archiwum wystawionych e-faktur dost\u0119pne b\u0119dzie w wersji online zgodnie z obowi\u0105zuj\u0105cymi przepisami, czyli przez 7 lat / 84 miesi\u0105ce od daty ich wystawienia. Archiwum e-faktur nie zawiera dokument\xF3w wystawionych w wersji papierowej.</p> </div> </section> <hr id="tip25"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q25">Nie mog\u0119 odszuka\u0107 e-faktury w aplikacji eFaktura DHL eCommerce. Co mam zrobi\u0107?</span> </h2> <div> <p translate="help.a25"> Prosimy o sprawdzenie w aplikacji do <a target="_blank" href="https://ebilling.dhl.com/customer/be/">e-faktur mi\u0119dzynarodowych</a> lub o kontakt z <a href="mailto:epomoc.dhlecommerce@dhl.com">nami</a>. </p> </div> </section> <hr id="tip26"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q26">Jak potwierdzi\u0107, \u017Ce otrzymana e-faktura zosta\u0142a wystawiona przez DHL eCommerce?</span> </h2> <div> <p translate="help.a26" translate-compile> E-faktura w formacie PDF jest opatrzona <a ng-click="vm.goToId($event)" href="#tip16"> podpisem elektronicznym</a>, kt\xF3ry potwierdza autentyczno\u015B\u0107 jej pochodzenia. Dodatkowo e-mail z informacj\u0105 o wystawieniu nowej e-faktury b\u0119dzie wysy\u0142any z adresu <a href="mailto:efaktura.dhlecommerce@dhl.com">efaktura.dhlecommerce@dhl.com</a>. Upewnij si\u0119 jednak, \u017Ce Tw\xF3j filtr antyspamowy nie b\u0119dzie blokowa\u0142 wiadomo\u015Bci wysy\u0142anych z tego adresu. </p> </div> </section> <hr id="tip27"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q27">Czy musz\u0119 instalowa\u0107 dodatkowe oprogramowanie, aby otrzyma\u0107 e-faktury?</span> </h2> <div> <p translate="help.a27a">Nie, nie ma potrzeby instalowania dodatkowego oprogramowania (z jednym wyj\u0105tkiem opisanym na ko\u0144cu tego punktu). Korzystanie z e-faktury jest mo\u017Cliwe pod warunkiem spe\u0142nienia przez system teleinformatyczny U\u017Cytkownika nast\u0119puj\u0105cych, minimalnych, wymaga\u0144 technicznych:</p> <ul> <li class="list"> <p translate="help.a27b">zastosowania przegl\u0105darki internetowej Mozilla Firefox, Google Chrome, Opera, Safari lub Internet Explorer 11</p> </li> <li class="list"> <p translate="help.a27c">wykorzystanie rozdzielczo\u015Bci ekranu 1280 x 720 lub wy\u017Cszej.</p> </li> </ul> <br> <p translate="help.a27d">W przypadku korzystania z e-faktury w formacie PDF, w celu weryfikacji podpisu elektronicznego, nale\u017Cy zainstalowa\u0107 program Adobe Acrobat Reader ze strony <a href="https://get.adobe.com/reader/" target="_blank">producenta</a>.</p> </div> </section> <hr id="tip28"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q28">W jakim formacie jest dost\u0119pna e-faktura?</span> </h2> <div> <p translate="help.a28a">E-faktura dost\u0119pna jest w formacie pliku PDF. Dodatkowo po zalogowaniu si\u0119 do aplikacji b\u0119dzie j\u0105 mo\u017Cna pobra\u0107 w formacie pliku XLSX.</p> <p translate="help.a28b"> Jednocze\u015Bnie informujemy, \u017Ce nadal mo\u017Cesz korzysta\u0107 z przesy\u0142anych elektronicznych za\u0142\u0105cznik\xF3w do faktur. Je\u017Celi jeszcze z nich nie korzystasz, a jeste\u015B zainteresowany ich otrzymywaniem, wy\u015Blij zg\u0142oszenie na adres <a href="mailto:_zalacznik_elektroniczny@dhl.com">_zalacznik_elektroniczny@dhl.com</a>, podaj\u0105c nr Klienta oraz adres emailowy. </p> </div> </section> <hr id="tip29"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q29">Czy e-faktura b\u0119dzie zawiera\u0142a wykaz przesy\u0142ek?</span> </h2> <div> <p translate="help.a29a">Tak, na e-fakturze b\u0119dzie dost\u0119pny wykaz zafakturowanych przesy\u0142ek wraz ze szczeg\xF3\u0142owymi informacjami (np. nadawca, odbiorca, ilo\u015B\u0107, rodzaj us\u0142ugi).</p> <p translate="help.a29b">Dodatkowo przegl\u0105daj\u0105c e-faktur\u0119 w aplikacji eFaktura DHL eCommerce b\u0119dziesz mia\u0142 mo\u017Cliwo\u015B\u0107 wy\u015Bwietlenia i pobierania skan\xF3w zafakturowanych list\xF3w przewozowych.</p> </div> </section> <hr id="tip30"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q30">Czy mog\u0119 dokona\u0107 p\u0142atno\u015Bci online za e-faktur\u0119?</span> </h2> <div> <p translate="help.a30">Aktualnie taka opcja nie jest dost\u0119pna. P\u0142atno\u015Bci za e-faktur\u0119 nale\u017Cy dokona\u0107 tak samo jak do tej pory.</p> </div> </section> <hr id="tip31"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q31">Jak dokona\u0107 zmiany adresu e-mail, na kt\xF3ry wysy\u0142ane s\u0105 powiadomienia o e-fakturze?</span> </h2> <div> <p translate="help.a31a">Aktualny adres e-mail nale\u017Cy wprowadzi\u0107 w aplikacji eFaktura DHL eCommerce w zak\u0142adce \u201EKlienci". W tym celu kliknij dwa razy w konto, do kt\xF3rego chcesz doda\u0107 adres e-mail. W pole U\u017Cytkownicy wpisz nowy adres e-mail; kliknij w "+" i zatwierd\u017A zmian\u0119 u\u017Cywaj\u0105c przycisku "Zapisz" znajduj\u0105cego si\u0119 na dole strony.</p> <br> <p translate="help.a31b">Nieaktualny adres e-mail mo\u017Cesz usun\u0105\u0107 w zak\u0142adce \u201EKlienci". W tym celu kliknij dwa razy w konto, z kt\xF3rego chcesz usun\u0105\u0107 adres e-mail. W polu U\u017Cytkownicy wybierz (poprzez klikni\u0119cie) adres do usuni\u0119cia; kliknij w "-" i zatwierd\u017A zmian\u0119 u\u017Cywaj\u0105c przycisku "Zapisz" znajduj\u0105cego si\u0119 na dole strony.</p> </div> </section> <hr id="tip32"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q32">Czy mog\u0119 zaktualizowa\u0107 dane mojej firmy online?</span> </h2> <div> <p translate="help.a32">Zmiany dotycz\u0105ce danych Twojej firmy mo\u017Cesz zg\u0142osi\u0107 w naszym Contact Center tel.&nbsp;42&nbsp;6&nbsp;345&nbsp;345 lub u swojego Przedstawiciela Handlowego DHL eCommerce.</p> </div> </section> <hr id="tip33"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q33">W jaki spos\xF3b mog\u0119 z\u0142o\u017Cy\u0107 reklamacj\u0119 do e-faktury?</span> </h2> <div> <ul> <li class="list"> <p translate="help.a33a"> Reklamacje finansowe dotycz\u0105ce nieprawid\u0142owych op\u0142at czy p\u0142atnika nale\u017Cy zg\u0142osi\u0107 poprzez <a target="_blank" href="ecom.dhl.com.pl/reklamacjefaktur">formularz reklamacyjny</a> </p> </li> <li class="list"> <p> <span translate="help.a33b">Reklamacje dotycz\u0105ce jako\u015Bci us\u0142ug, np. uszkodzenie przesy\u0142ki, nieterminowe dor\u0119czenie, nale\u017Cy zg\u0142osi\u0107</span><a target="_blank" href="{{vm.language() == \'pl\' ? \'https://www.dhlecommerce.pl/pl/dla-ciebie/obsluga/kontakt/reklamacje.html\':\'https://www.dhlecommerce.pl/en/private-customers/customer-service/contact/claims.html\'}}" translate="help.a33c">tutaj</a> </p> </li> </ul> </div> </section> <hr id="tip34"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q34">Czy mo\u017Cliwe jest jednoczesne otrzymywanie faktur w formie elektronicznej i papierowej?</span> </h2> <div> <p translate="help.a34">Faktura mo\u017Ce wyst\u0119powa\u0107 tylko w jednej formie: elektronicznej lub papierowej.</p> </div> </section> <hr id="tip35"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q35"></span> </h2> <div> <p translate="help.a35"></p> </div> </section> <hr id="tip36"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q36">W jaki spos\xF3b mog\u0119 zrezygnowa\u0107 z e-faktury?</span> </h2> <div> <p translate="help.a36">Aby zrezygnowa\u0107 z e-faktury nale\u017Cy wys\u0142a\u0107 do nas stosowne zg\u0142oszenie:</p> <ul> <li class="list"> <p translate="help.a36a"> mailowo na adres <a href="mailto:epomoc.dhlecommerce@dhl.com">epomoc.dhlecommerce@dhl.com</a>. W tre\u015Bci e-maila nale\u017Cy poda\u0107 NIP firmy (w celu poprawnej identyfikacji Klienta) </p> </li> <li class="list"> <p translate="help.a36b"> lub pisemnie na adres DHL eCommerce (Poland) Sp. z o.o. Oddzia\u0142 G\u0142uchowo (Dzia\u0142 Fakturowania), ul. Komornicka 1, 62-052 Komorniki). </p> </li> </ul> </div> </section> <hr> <br> </section> ');
$templateCache.put('app/views/login/login.html','<div id="shell" ui-view="shell" ng-cloak></div> <div class="container container-logout login-panel-padding"> <portal-alert></portal-alert> <table class="login" style="padding-top: 150px"> <tbody> <tr> <td> <section> <h1> <strong translate="login.title">Zaloguj si\u0119 do Portalu DHL</strong> </h1> <form class="form login-form" novalidate id="loginForm" name="loginForm"> <div class="form-group"> <label class="control-label" for="login"><span translate="login.login">Login (e-mail)</span></label> <br> <input ng-model="vm.username" class="login-input form-control" value="" type="text" id="login" name="username" required uib-tooltip="{{ (loginForm.username.$error.required) ? vm.loginreq() : \'\' }}"> </div> <div class="form-group login-margin"> <label class="control-label" for="password"><span translate="login.password">Has\u0142o</span></label> <input ng-model="vm.password" class="login-input form-control" type="password" id="password" name="password" autocomplete="new-password" required uib-tooltip="{{ (loginForm.password.$error.required) ? vm.pwdreq() : \'\' }}"> </div> <p class="login-margin text-align-left"> <span translate="login.forgotten1">Nie pami\u0119tasz</span> <a href="" ui-sref="password-reset" translate="login.forgotten2">has\u0142a</a>? </p> <br> <br> <div class="text-align-left"> <button class="btn" type="submit" ng-click="loginForm.$valid ? vm.login($event) : null"> <span translate="login.login-btn">Zaloguj</span> <i class="fa fa-sign-in"></i> </button> </div> </form> </section> </td> <td></td> <td> <section> <h1> <strong translate="login.access1">Nie masz dost\u0119pu do portalu?</strong> </h1> <div> <a href="" ui-sref="register"><span translate="login.access2">Sprawd\u017A, jak uzyska\u0107 dost\u0119p.</span> <span class="has-icon">&#xe60A;</span></a> </div> </section> </td> </tr> </tbody> </table> </div> ');
$templateCache.put('app/views/password-reset/password-reset.html','<section class="container container-fluid"> <h1 class="title" translate="password-reset.title">Reset has\u0142a do portalu DHL</h1> <errors></errors> <statements></statements> <div ng-show="vm.data.passwordResetError!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.data.passwordResetError=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope" translate="password-reset.error">{{vm.data.passwordResetError}}</span> </div> </div> <div ng-show="vm.data.passwordResetSuccess!=null" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert" type="success" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.data.passwordResetSuccess=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope" translate="password-reset.after-reset">{{vm.data.passwordResetSuccess}}</span> </div> </div> <p translate="password-reset.desc">Aby zresetowa\u0107 has\u0142o, wpisz adres e-mail podany podczas rejestracji.</p> <br> <form id="resetForm" name="resetForm" class="form-horizontal"> <div class="form-group"> <label for="dhlEmail" class="col-md-2 control-label">E-mail</label> <div class="col-md-5"> <pemail></pemail> </div> </div> <div class="form-group"> <div class="col-md-5 col-md-offset-2 text-center"> <button type="button" class="btn" ui-sref="login" translate="password-reset.return">Powr\xF3t</button> <button type="submit" class="btn" ng-disabled="resetForm.$invalid || resetForm.$pending" ng-click="vm.resetPassword()" translate="password-reset.send">Wy\u015Blij</button> </div> </div> </form> </section> ');
$templateCache.put('app/views/password-expire/password-expire.html','<section> <section class="container container-fluid"> <h1 class="title" translate="global.menu.password-expire">Wyga\u015Bni\u0119cie has\u0142a</h1> </section> <hr id="toptip"> <section class="container-fluid"> <div> <p><span translate="password-expire.information.expire">Twoje has\u0142o wyga\u015Bnie za</span> {{vm.passwordExpireDays}} <span translate="password-expire.information.days">dni</span>. <br><span translate="password-expire.information.change">Has\u0142o mo\u017Cesz zmieni\u0107 w zak\u0142adce</span> <a ui-sref="settings"><span class="text-underline" translate="password-expire.information.settings">M\xF3j profil</span></a>.</p> </div> <div></div> <div> <a ui-sref="settings" class="btn voffset2" type="button"> <span translate="password-expire.buttons.back">Przejd\u017A do aplikacji</span> </a> </div> </section> </section> ');
$templateCache.put('app/views/password-reset-finish/password-reset-finish.html','<section class="container container-fluid" ng-show="vm.data.acceptReset"> <h1 class="title">{{(vm.changeType == 2) ? vm.translate(\'password-reset-finish.title.reset\') : vm.translate(\'password-reset-finish.title.activation\')}}</h1> <errors></errors> <statements></statements> <div ng-show="vm.passwordChangeErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.passwordChangeErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope">{{vm.passwordChangeErrorText}}</span> </div> </div> <div ng-show="vm.passwordChangeSuccessText!=null" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert" type="success" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.passwordChangeSuccessText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope">{{vm.passwordChangeSuccessText}}</span> </div> </div> <p>{{(vm.changeType == 2) ? vm.translate(\'password-reset-finish.password.new\') : vm.translate(\'password-reset-finish.password.set\')}}</p> <br> <form id="resetForm" name="resetForm" class="form-horizontal"> <div class="form-group"> <label for="dhlPassword" class="col-md-2 control-label" translate="password-reset-finish.labels.password">Has\u0142o</label> <div class="col-md-5 tooltip-left"> <input type="password" class="form-control" required="required" autocomplete="off" placeholder="" tabindex="0" tooltip-placement="right" uib-tooltip-template="\'passwordTooltipTemplate.html\'" ng-model="vm.data.password" ng-maxlength="128"> </div> </div> <div class="form-group"> <label for="dhlRePassword" class="col-md-2 control-label" translate="password-reset-finish.labels.repassword">Powt\xF3rz has\u0142o</label> <div class="col-md-5"> <input type="password" class="form-control" required="required" autocomplete="off" placeholder="" tabindex="0" ng-model="vm.data.repassword" ng-maxlength="128"> </div> </div> <div class="form-group"> <div class="col-md-5 col-md-offset-2 text-center"> <button type="button" class="btn" ui-sref="login" translate="password-reset-finish.buttons.back">Powr\xF3t do strony logowania</button> <button type="submit" class="btn" ng-disabled="resetForm.$invalid || resetForm.$pending" ng-click="vm.resetPassword()" translate="password-reset-finish.buttons.change">Zmie\u0144</button> </div> </div> </form> <script type="text/ng-template" id="passwordTooltipTemplate.html"> <span ng-bind-html="vm.passwordTooltip()"></span> </script> </section> ');
$templateCache.put('app/views/pdfView/pdfView.html','<portal-alert></portal-alert> <section class="container container-fluid"> <div ng-show="vm.downloadError!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.downloadError=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope">{{vm.downloadError}}</span></div> </div> <iframe id="PDFWrapper" iframe-set-dimensions-onload src="{{vm.pdfViewer}}"></iframe> <div class="actionButtons"> <!--        <button class="btn" id="downloadXlsxButton" type="button" ng-click="vm.downloadXlsx()">\n            <span translate="pdfView.downloadX">Pobierz XLSX</span>\n            <i class="fa fa-file-excel-o"></i>\n        </button>--> <a class="btn" target="_blank" ng-href="{{!vm.isExcelAvailable ? \'\' : vm.getDownloadXlsxURL()}}" ng-disabled="!vm.isExcelAvailable" tooltip-placement="top" uib-tooltip="{{!vm.isExcelAvailable ? vm.translate(\'pdfView.excelUnavailable\') : \'\' }}"> <span translate="pdfView.downloadX">Pobierz XLSX</span> <i class="fa fa-file-excel-o"></i> </a> <a target="_blank" ng-href="{{vm.getDownloadFullPdfURL(false)}}" class="btn btn-add btn-add-use"> <span translate="pdfView.downloadPrint">PDF - pobierz/wydrukuj</span> <i class="fa fa-file-pdf-o"></i> </a> <a target="_blank" ng-href="{{vm.getDownloadFullPdfURL(true)}}" class="btn btn-add btn-add-use" ng-if="vm.userOnePdfPage==\'B1\' || vm.userOnePdfPage==\'B2\' "> <span translate="pdfView.downloadPrintWhole">PDF - pobierz/wydrukuj ca\u0142y dokument</span> <i class="fa fa-file-pdf-o"></i> </a> </div> </section> ');
$templateCache.put('app/views/pending-cases/pending-cases.html','<section class="container container-fluid embedded-page-padding"> <portal-alert></portal-alert> <h1 class="title text-left ng-scope clear-margin-top"><span translate="pendingCases.pendingCases.registerUsers">Rejestracja u\u017Cytkownik\xF3w</span></h1> <p> </p><div class="actionButtons"> <button ng-disabled="vm.usersToBeUpdated.length === 0" class="btn align-right" id="DenyButton" title="Deny Users" type="button" ng-click="vm.denyUsers()"> <span translate="pendingCases.pendingCases.deny">Odrzu\u0107</span> <i class="fa fa-times"></i> </button> <button ng-disabled="vm.usersToBeUpdated.length === 0" class="btn align-right" id="AcceptButton" title="Download" type="button" ng-click="vm.acceptUsers()"> <span translate="pendingCases.pendingCases.accept">Zatwierd\u017A</span> <i class="fa fa-check"></i> </button> <button class="btn" title="Download" type="button" ng-click="vm.checkAllUsers()"> <span translate="{{vm.checkOrUncheckText(vm.checkAllUsersButton)}}"></span> <i class="fa fa-check-square"></i> </button> </div> <div> <div width="100%" style="overflow-y : auto"> <table id="fixtable" class="tablesorter latest" fix-table> <thead> <tr> <th></th> <th> <span translate="pendingCases.pendingCases.email">E-mail</span> </th> <th> <span translate="pendingCases.pendingCases.nip">NIP</span> </th> <th> <span translate="pendingCases.pendingCases.invoice">Faktura</span> </th> <th> <span translate="pendingCases.pendingCases.totalGross"> Kwota brutto</span> </th> <th> <span translate="pendingCases.pendingCases.sapNumber">Nr SAP</span> </th> <th> <span translate="pendingCases.pendingCases.payerSapNumber">Nr SAP p\u0142atnika</span> </th> <th> <span translate="pendingCases.pendingCases.name">Nazwa</span> </th> </tr> </thead> <tbody> <tr ng-repeat="user in vm.users"> <td> <input type="checkbox" ng-click="vm.usersCheckboxClick($event,$index)" ng-model="vm.users[$index].selected"> </td> <td>{{ user.email}}</td> <td>{{ user.nip}}</td> <td>{{ user.invoiceNumber}}</td> <td>{{ user.invoiceValue | number:2}}</td> <td> <input type="text" ng-model="user.sapNumber" ng-change="vm.getNameBySapNumber($event,$index,user.sapNumber)"> </td> <td> <input type="text" ng-model="user.payerNumber"> </td> <td> <input type="text" ng-model="user.clientName"> </td> </tr> </tbody> <tfoot> <tr> <td colspan="8"></td> </tr> </tfoot> </table> </div> </div> </section> <hr> <section class="container container-fluid"> <h1 class="title text-left ng-scope"><span translate="pendingCases.pendingCases.invoicesToAccept">Korekty do zatwierdzenia</span></h1> <div class="actionButtons"> <button ng-click="vm.denyCorrections()" ng-disabled="vm.correctionsToBeUpdated.length === 0" class="btn align-right" id="DenyButton2" title="Deny Users" type="button"> <span translate="pendingCases.pendingCases.deny">Odrzu\u0107</span> <i class="fa fa-times"></i> </button> <button ng-click="vm.acceptCorrections()" ng-disabled="vm.correctionsToBeUpdated.length === 0" class="btn align-right" id="AcceptButton2" title="Download" type="button"> <span translate="pendingCases.pendingCases.accept">Zatwierd\u017A</span> <i class="fa fa-check"></i> </button> <button class="btn" title="Download" type="button" ng-click="vm.checkAllCorrections()"> <span translate="{{vm.checkOrUncheckText(vm.checkAllCorrectionsButton)}}"></span> <i class="fa fa-check-square"></i> </button> </div> <div> <div width="100%" style="overflow-y : auto"> <table id="fixtable2" class="tablesorter latest" fix-table> <thead> <tr> <th></th> <th> <span translate="pendingCases.pendingCases.client">Klient</span> </th> <th> <span translate="pendingCases.pendingCases.payer">P\u0142atnik</span> </th> <th> <span translate="pendingCases.pendingCases.document">Dokument</span> </th> <th> <span translate="pendingCases.pendingCases.dateIssue">Data wystawienia</span> </th> <th> <span translate="pendingCases.pendingCases.datePayment">Termin p\u0142atno\u015Bci</span> </th> <th> <span translate="pendingCases.pendingCases.totalNetto">Kwota netto</span> </th> <th> <span translate="pendingCases.pendingCases.totalVat">Kwota VAT</span> </th> <th> <span translate="pendingCases.pendingCases.totalGross">Kwota brutto</span> </th> </tr> </thead> <tbody> <tr ng-repeat="correction in vm.corrections" ng-click="vm.downloadPDF(correction.ediDocId)"> <td ng-click="vm.correctionsCheckboxClick($event,$index)"> <input type="checkbox" ng-model="vm.corrections[$index].selected"> </td> <td>{{ correction.clientNumber}}</td> <td>{{ correction.payerNumber}}</td> <td>{{ correction.documentNumber}}</td> <td>{{ correction.dateIssue | date:\'yyyy-MM-dd\'}}</td> <td>{{ correction.datePayment | date:\'yyyy-MM-dd\'}} </td> <td>{{ correction.totalNetto | number:2}} </td> <td>{{ correction.totalVat | number:2}}</td> <td>{{ correction.totalGross | number:2}}</td> </tr> </tbody> <tfoot> <tr> <td colspan="9"></td> </tr> </tfoot> </table> </div> </div> </section> <hr> <section class="container container-fluid"> <h1 class="title text-left ng-scope"><span translate="pendingCases.pendingCases.documentsWithoutCient">Dokumenty bez klienta</span> </h1> <div class="actionButtons"> <button ng-disabled="vm.documentsToBeUpdated.length === 0" class="btn align-right" id="DenyButton3" title="Deny Users" type="button" ng-click="vm.denyDocuments()"> <span translate="pendingCases.pendingCases.deny">Odrzu\u0107</span> <i class="fa fa-times"></i> </button> <button ng-disabled="vm.documentsToBeUpdated.length === 0" class="btn align-right" id="AcceptButton3" title="Download" type="button" ng-click="vm.acceptDocuments()"> <span translate="pendingCases.pendingCases.accept">Zatwierd\u017A</span> <i class="fa fa-check"></i> </button> <button class="btn" title="Download" type="button" ng-click="vm.checkAllDocuments()"> <span translate="{{vm.checkOrUncheckText(vm.checkAllDocumentsButton)}}"></span> <i class="fa fa-check-square"></i> </button> </div> <div> <div width="100%" style="overflow-y : auto"> <table id="fixtable3" class="tablesorter latest" fix-table> <thead> <tr> <th></th> <th> <span translate="pendingCases.pendingCases.client">Klient</span> </th> <th> <span translate="pendingCases.pendingCases.payer">P\u0142atnik</span> </th> <th> <span translate="pendingCases.pendingCases.document"> Dokument</span> </th> <th> <span translate="pendingCases.pendingCases.dateIssue">Data wystawienia</span> </th> <th> <span translate="pendingCases.pendingCases.datePayment">Termin p\u0142atno\u015Bci</span> </th> <th> <span translate="pendingCases.pendingCases.totalNetto">Kwota netto</span> </th> <th> <span translate="pendingCases.pendingCases.totalVat">Kwota VAT</span> </th> <th> <span translate="pendingCases.pendingCases.totalGross">Kwota brutto</span> </th> </tr> </thead> <tbody> <tr ng-repeat="document in vm.documents" ng-click="vm.downloadPDF(document.ediDocId)"> <td ng-click="vm.documentsCheckboxClick($event,$index)"> <input type="checkbox" ng-model="vm.documents[$index].selected"> </td> <td>{{ document.clientNumber}}</td> <td>{{ document.payerNumber}}</td> <td>{{ document.documentNumber}}</td> <td>{{ document.dateIssue | date:\'yyyy-MM-dd\'}}</td> <td>{{ document.datePayment | date:\'yyyy-MM-dd\'}} </td> <td>{{ document.totalNetto | number:2}} </td> <td>{{ document.totalVat | number:2}}</td> <td>{{ document.totalGross | number:2}}</td> </tr> </tbody> <tfoot> <tr> <td colspan="9"></td> </tr> </tfoot> </table> </div> </div> </section> ');
$templateCache.put('app/views/receivables/receivables.html','<section class="container container-fluid"> <div id="fixed" class="container container-fluid embedded-page-padding" dynamic-height dh-element-id="#under-fixed"> <div class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <div style="text-align: center"> <span class="ng-binding ng-scope"><b>Szanowny Kliencie, w zwi\u0105zku z pracami modernizacyjnymi od 1.01.2026 a\u017C do odwo\u0142ania zak\u0142adka e-Nale\u017Cno\u015Bci nie jest aktualizowana.</b></span> <span class="ng-binding ng-scope" style="display: block;margin: 5px 0 5px 0">W sprawie aktualnego stanu nale\u017Cno\u015Bci prosimy o bezpo\u015Bredni kontakt z opiekunem windykacyjnym.</span> <span class="ng-binding ng-scope" style="display: block">Przepraszamy za niedogodno\u015Bci.</span> </div> </div> <div ng-if="vm.duplicateAlertMsg!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.closeDuplicateAlert()" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope" translate="{{vm.duplicateAlertMsg}}"></span> </div> </div> <div ng-if="vm.complaintAlertMsg!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.closeComplaintAlert()" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope" translate="{{vm.complaintAlertMsg}}"></span> </div> </div> <div ng-if="vm.blockedPayersMsg!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.closeBlockedPayersAlert()" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope" translate="{{vm.blockedPayersMsg}}"></span> <span class="ng-binding ng-scope">{{vm.blockedPayersListMsg}}</span> </div> </div> <portal-alert></portal-alert> <form name="filterForm" class="form-inline" accept-charset="UTF-8" enctype="multipart/form-data"> <fieldset> <div class="form-group"> <label class="control-label"><span translate="receivables.search.customerNumber">Numer klienta</span>:</label> <input class="form-control margin-bottom input-sm" type="text" id="cli_number" name="client_number" ng-model="vm.filter.clientNo" nip> </div> <div class="form-group"> <label class="">&nbsp;</label> <div> <button type="submit" id="search" class="btn margin-bottom" ng-click="vm.list(vm.filter)"><span translate="receivables.search.searchButton">Szukaj</span> <i class="fa fa-search"></i> </button> </div> </div> </fieldset> </form> <div ng-if="vm.noDocumentsFound" style="margin: 10px 0 5px 0; color: red" class="col-xs-12 text-center"> <b translate="receivables.search.notFound">Nie znaleziono dokument\xF3w.</b> </div> <div class="actionButtons row"> <div class="col-xs-7"> <!--                <button class="btn" id="hidePaidButton" type="button" ng-click="vm.switchHidePaid()">--> <!--                    <span ng-if="!(vm.hidePaid)" translate="receivables.buttons.hidePaid">Ukryj zap\u0142acone</span>--> <!--                    <span ng-if="vm.hidePaid" translate="receivables.buttons.showPaid">Poka\u017C zap\u0142acone</span>--> <!--                </button>--> <button class="btn" id="complaintButton" ng-if="$root.Principal.hasUserReceivablesAccess()" ng-click="vm.redirectComplaint()" ng-disabled="vm.selectedIndex === null" type="button"> <span translate="receivables.buttons.lodgeComplaint">Z\u0142\xF3\u017C reklamacj\u0119</span> </button> <button class="btn" id="duplicateButton" ng-if="$root.Principal.hasUserReceivablesAccess()" ng-click="vm.redirectDuplicate()" ng-disabled="vm.selectedIndex === null" type="button"> <span translate="receivables.buttons.orderDuplicate">Zam\xF3w duplikat</span> </button> <a target="_blank" class="btn" id="reportButton" ng-href="{{vm.getXlsxURL()}}"> <span translate="receivables.buttons.generateReport">Wygeneruj raport</span> <i class="fa fa-table"></i> </a> </div> <div ng-if="vm.allPaid" style="margin: 10px; color: green" class="col-xs-12 text-center"> <b translate="receivables.search.allPaid">Wszystkie nale\u017Cno\u015Bci uregulowane.</b> </div> <div ng-if="vm.receivablesStatusDate != null" class="col-xs-12 receivables-status-date"> <span translate="receivables.search.statusDate"></span> <span translate="{{vm.receivablesStatusDate === \'No data\' ? \'receivables.search.noLastDate\' : vm.receivablesStatusDate | date:\'yyyy-MM-dd\'}}"></span> </div> </div> </div> <div id="under-fixed"> <div style="width: 100%; overflow-x : auto"> <table id="fixtable" class="tablesorter latest" fix-table ng-show="vm.invoices.length > 0"> <thead> <tr> <th></th> <th ng-show="vm.columns.clientNumber"> <a ng-click="vm.sortBy(\'clientNumber\', !vm.sortReverse)"> <span translate="receivables.document.payerNumber">P\u0142atnik</span> <span ng-show="vm.sortType == \'clientNumber\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'clientNumber\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.clientName"> <span translate="receivables.document.clientName">Nazwa P\u0142atnika</span> </th> <th ng-show="vm.columns.documentNumber"> <span translate="receivables.document.documentNumber">Numer dokumentu</span> </th> <th ng-show="vm.columns.dateIssue"> <a ng-click="vm.sortBy(\'dateIssue\', !vm.sortReverse)"> <span translate="receivables.document.dateIssue">Data wystawienia</span> <span ng-show="vm.sortType == \'dateIssue\' && !vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'dateIssue\' && vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.dueDate"> <a ng-click="vm.sortBy(\'dueDate\', !vm.sortReverse)"> <span translate="receivables.document.datePayment">Termin p\u0142atno\u015Bci</span> <span ng-show="vm.sortType == \'dueDate\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'dueDate\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.totalGross"> <a ng-click="vm.sortBy(\'totalGross\', !vm.sortReverse)"> <span translate="receivables.document.totalGross">Kwota faktury</span> <span ng-show="vm.sortType == \'totalGross\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'totalGross\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.left"> <span translate="receivables.document.totalLeft">Pozosta\u0142o do zap\u0142aty</span> </th> <th ng-show="vm.columns.currency"> <span translate="receivables.document.documentCurrency">Waluta dokumentu</span> </th> <th ng-show="vm.columns.remarks"> <span translate="receivables.document.remarks">Uwagi</span> </th> <th ng-show="vm.columns.eInvoice"> <span translate="receivables.document.eInvoice">E-faktura</span> </th> </tr> </thead> <tbody> <tr id="topSpacer"> <td colspan="{{vm.columns.totalVisible}}" style="padding: 0 !important; margin: 0 !important"> </td> </tr> <tr class="receivables-row-height" ng-repeat="invoice in vm.invoices | limitTo:vm.limit:vm.topIndex track by invoice.docNumber"> <td> <input type="checkbox" ng-if="$root.Principal.hasUserReceivablesAccess()" ng-model="invoice.selected" ng-click="vm.checkboxClicked($event, invoice.entityId)"> </td> <td ng-show="vm.columns.clientNumber">{{ ::invoice.clientNumber }}</td> <td ng-show="vm.columns.clientName">{{ ::invoice.clientName }}</td> <td ng-show="vm.columns.documentNumber">{{ ::invoice.docNumber}}</td> <td ng-show="vm.columns.dateIssue">{{ ::invoice.dateIssue | date:\'yyyy-MM-dd\' }}</td> <td ng-show="vm.columns.dueDate">{{ ::invoice.datePayment | date:\'yyyy-MM-dd\' }}</td> <td ng-show="vm.columns.totalGross">{{ ::invoice.totalGross | number:2}}</td> <td ng-show="vm.columns.left" ng-class="{\'receivables-unpaid\': invoice.late}">{{ ::invoice.left | number:2}}</td> <td ng-show="vm.columns.currency">{{ ::invoice.currency }}</td> <td ng-show="vm.columns.remarks"> <span ng-if="::invoice.remarks.toUpperCase() === \'REKLAMACJA\'" translate="receivables.document.remarkComplaint"></span> </td> <td ng-show="vm.columns.eInvoice" class="receivables-einvoice-col"> <span ng-show="invoice.eInvoice === true">e</span> </td> </tr> <tr id="bottomSpacer"> <td colspan="{{vm.columns.totalVisible}}" style="padding: 0 !important; margin: 0 !important"> </td> </tr> </tbody> </table> </div> <div class="debt-container" ng-if="vm.showDebtContacts"> <p class="debt-collector-title" translate="receivables.debtContact.title">Kontakt z windykatorem</p> <div ng-repeat="debtContact in vm.debtContacts"> <p class="debt-collector-contact"> <span translate="receivables.debtContact.rowTitle">Dla klienta</span> {{ ::debtContact.clientNumber }}: <a href="mailto:{{::debtContact.email}}">{{ ::debtContact.email }}</a> </p> </div> </div> </div> </section> ');
$templateCache.put('app/views/register/register.html','<section class="container container-fluid"> <h1 class="title"><span translate="register.title2"> Rejestracja w aplikacji eFaktura DHL eCommerce</span></h1> </section> <hr id="toptip"> <section class="container container-fluid"> <div ng-show="vm.registerErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.registerErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope">{{vm.registerErrorText}}</span> </div> </div> </section> <section class="register container container-fluid"> <form id="step1Form" name="step1Form" novalidate class="form-horizontal step1Form"> <div> <div clas="col-md-10"> <label class="normal-form" style="padding-bottom: 1em"><span translate="register.fillForm">Wype\u0142nij formularz, aby otrzymywa\u0107 e-faktury:</span></label> </div> </div> <div class="form-group" style="display: flex; align-items: center"> <label id="dhlEmailLabel" class="col-md-2 control-label normal-form"><span translate="register.email">E-mail</span><strong class="red">*</strong></label> <div class="col-md-5"> <email></email> </div> <div class="col-md-5"></div> </div> <div class="form-group" style="display: flex; align-items: center"> <label id="dhlNipLabel" class="col-md-2 control-label normal-form"><span translate="register.nip">NIP</span><strong class="red">*</strong></label> <div class="col-md-5"> <nip></nip> </div> <div class="col-md-5"></div> </div> <div class="form-group" style="display: flex; align-items: center"> <label id="dhlInvoicedhlLabel" for="dhlInvoice" class="col-md-2 control-label normal-form"><span translate="register.invoiceNumber">Nr faktury</span><strong class="red">*</strong></label> <div class="col-md-5"> <invoice></invoice> </div> <div class="col-md-5 tooltip-wide"> <a class="form-help-link normal-form" style="line-height: 40px" tooltip-placement="top" uib-tooltip-html="invoiceNumberTooltip" tabindex="-1" tooltip><span translate="register.invoiceNumberLink">Gdzie znajd\u0119 nr faktury?</span></a> </div> </div> <div class="form-group" style="display: flex; align-items: center"> <label id="dhlGrossAmountLabel" for="dhlGrossAmount" class="col-md-2 control-label normal-form"><span translate="register.totalGross">Kwota brutto</span><strong class="red">*</strong></label> <div class="col-md-5"> <gross></gross> </div> <div class="col-md-5 tooltip-wide"> <a class="form-help-link normal-form" style="line-height: 40px" tooltip-placement="top" uib-tooltip="{{ vm.translate(\'register.tooltipTotalGross\') }}" tabindex="-1" tooltip><span translate="register.totalGrossLink">Jak wype\u0142ni\u0107 pole kwota brutto?</span></a> </div> </div> <div class="form-group" style="display: flex; align-items: center"> <label id="dhlClientCodeLabel" for="dhlClientCode" class="col-md-2 control-label normal-form"><span translate="register.clientNumber">Numer klienta</span></label> <div class="col-md-5"> <client></client> </div> <div class="col-md-5 tooltip-wide"> <a class="form-help-link normal-form" style="line-height: 40px" tooltip-placement="top" uib-tooltip="{{ vm.translate(\'register.tooltipClientNumber\') }}" tabindex="-1" tooltip><span translate="register.clientNumberLink">Gdzie znajd\u0119 numer klienta?</span></a> </div> </div> <div class="form-group" style="display: flex; align-items: center"> <div class="col-md-2 float-left"> <input name="agreement1" type="checkbox" id="agreement1" class="register-input pull-right normal-form registrationCheckbox" required="required" ng-model="vm.data.agreement1"> <label for="agreement1" class="pull-right" uib-tooltip="{{ step1Form.agreement1.$error.required ?\n\t\t\t\t\t\tvm.translate(\'register.acceptanceTooltip\') : \'\' }}" tooltip-placement="top-right"> </div> <label class="checkbox register-input col-md-7-5 normal-form" style="cursor: default"><span translate="register.invoiceAcceptanceBeforeLink" style="display: inline"> Wyra\u017Cam zgod\u0119 na przesy\u0142anie przez DHL Express (Poland) Sp. z o. o. faktur w formie elektronicznej zgodnie z aktualnie obowi\u0105zuj\u0105cymi przepisami ustawy o VAT oraz akceptuj\u0119 </span> <b> <a target="_blank" href="http://www.dhl.com.pl/pl/zasady_korzystania_ze_strony_internetowej.html"> <span translate="register.invoiceAcceptanceLink">zasady korzystania</span> </a> </b> <span translate="register.invoiceAcceptanceAfterLink"> ze strony internetowej DHL eCommerce.</span><strong class="red">*</strong> </label> </div> <div class="form-group" style="display: flex; align-items: center"> <div class="col-md-2 float-left"> <div></div> </div> <label class="checkbox register-input col-md-7-5 normal-form" style="cursor: default"> <span translate="register.rodoInfo" style="display: inline">Administratorem Twoich danych osobowych b\u0119dzie DHL eCommerce Polska sp. z o.o. z siedzib\u0105 w Warszawie przy ulicy Osma\u0144skiej 2 (02-823 Warszawa), dalej \u201EDHL\u201D. DHL b\u0119dzie korzysta\u0142 z Twoich danych w celu obs\u0142ugi i zapewnienia dzia\u0142ania Twojego konta na portalu efaktura.dhlecommerce.pl, prowadzenia kontakt\xF3w w zwi\u0105zku z wykonywaniem us\u0142ug, w szczeg\xF3lno\u015Bci przesy\u0142ania informacji finansowo-rozliczeniowych. Masz prawo dost\u0119pu do tre\u015Bci swoich danych oraz prawo ich sprostowania, usuni\u0119cia, ograniczenia przetwarzania, prawo do przenoszenia danych, prawo do wniesienia sprzeciwu oraz prawo wniesienia skargi do Prezesa Urz\u0119du Ochrony Danych Osobowych. \u017Beby dowiedzie\u0107 si\u0119 wi\u0119cej o tym jak korzystamy z Twoich danych kliknij </span> <a target="_blank" ng-href="{{ vm.translate(\'register.rodoLink\')}}"> <span translate="register.here"> tutaj.</span></a> </label> </div> <div> <div clas="col-md-10"> <br> <label class="normal-form" style="padding-bottom: 1em"><strong class="red">*</strong><span translate="register.required"> pole obowi\u0105zkowe</span></label> </div> </div> <div class="form-group"> <div class="col-md-10"> <button type="submit" class="btn float-right" ng-click="step1Form.dhlEmail.$submit;step1Form.$valid?vm.send(): vm.invalid()"><span translate="register.next">Dalej</span></button> </div> </div> </form> </section> ');
$templateCache.put('app/views/register/register_end.html',' <section class="container container-fluid"> <h1 class="title"><span translate="registerEnd.title"> Zako\u0144czenie rejestracji</span></h1> </section> <hr id="toptip"> <!-- <div class="text-primary steps">Krok 1/2</div> --> <section class="container container-fluid"> <p><span translate="registerEnd.dearClient">Szanowny Kliencie,</span></p><br> <p><span translate="registerEnd.thanks">Dzi\u0119kujemy za rejestracj\u0119 w aplikacji eFaktura DHL eCommerce.</span></p><br> <p><span translate="registerEnd.text1">Po weryfikacji i akceptacji Twojego zg\u0142oszenia na podany przy rejestracji adres otrzymasz e-mail z linkiem aktywacyjnym. E-mail zostanie wys\u0142any z adresu </span> <a href="mailto:efaktura.dhlecommerce@dhl.com"><span translate="registerEnd.address">efaktura.dhlecommerce@dhl.com</span></a> <span translate="registerEnd.text2">. Upewnij si\u0119 jednak, \u017Ce Tw\xF3j filtr antyspamowy nie b\u0119dzie blokowa\u0142 wiadomo\u015Bci wysy\u0142anych z tego adresu.</span></p><br> <p><b><span translate="registerEnd.link">Link b\u0119dzie aktywny przez 15 dni.</span></b></p><br> <p><span translate="registerEnd.text3">Aby w pe\u0142ni korzysta\u0107 z funkcjonalno\u015Bci naszego serwisu post\u0119puj zgodnie z instrukcj\u0105 z e-maila.</span></p><br> <p><span translate="registerEnd.regards">Pozdrawiamy,</span><br> <span translate="registerEnd.signature">Zesp\xF3\u0142 e-fakturowania DHL eCommerce</span></p> </section> ');
$templateCache.put('app/views/settings/settings.html','<div ng-if="$root.Principal.isAuthenticated()"> <section class="container container-fluid"> <div ng-show="vm.getUserErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.getUserErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope" translate="{{vm.getUserErrorText}}"></span></div> </div> </section> <section class="container container-fluid"> <h1 class="settings_header embedded-page-padding"> <span class="part-title" translate="settings.details.header">Dane u\u017Cytkownika</span><span class="info_header_normal"></span> </h1> <form class="block"> <fieldset> <div class="row"> <label class="col-md-6 form_inside" translate="settings.details.email">E-mail: </label> <label class="info_header_normal col-md-6 form_inside" ng-show="$root.Principal.isAuthenticated()">{{$root.Principal.getProperty(\'login\')}}</label> </div> <div class="row"> <label class="col-md-6 form_inside" translate="settings.details.loginFailed">Ostatnie nieudane logowanie: </label> <label class="info_header_normal col-md-6 form_inside" ng-show="$root.Principal.isAuthenticated()">{{vm.data.user.lastLoginFailure | date:\'yyyy-MM-dd\'}}</label> </div> <div class="row"> <label class="col-md-6 form_inside" translate="settings.details.passwordExpiration">Data wyga\u015Bni\u0119cia has\u0142a: </label> <label class="info_header_normal col-md-6 form_inside" ng-show="$root.Principal.isAuthenticated()">{{vm.data.user.user.passwordExpireDate | date:\'yyyy-MM-dd\'}}</label> </div> </fieldset> </form> </section> <hr ng-if="vm.data.user.clients.length"> <section class="container container-fluid" ng-controller="SettingsController" ng-if="vm.data.user.clients.length"> <h1 class="settings_header"> <span class="part-title" translate="settings.details.customers">Przypisani klienci</span><br><br> <td> <div ng-if="vm.data.user.clients.length == 0" translate="settings.none"></div> <div ng-if="vm.data.user.clients.length > 0" ng-repeat="client in vm.data.user.clients" ng-click="vm.clientNav(client)"><a>{{client.clientNumber}}</a></div> </td> </h1> </section> <hr> <section class="container container-fluid"> <section class="container container-fluid"> <div ng-show="vm.passwordChangeErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.passwordChangeErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only" translate="entity.action.close"> Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope" translate="{{vm.passwordChangeErrorText}}"></span></div> </div> <div ng-show="vm.passwordChangeSuccessText!=null" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert" type="success" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.passwordChangeSuccessText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span><span class="sr-only"> Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope" translate="{{vm.passwordChangeSuccessText}}"></span></div> </div> </section> <h1 class="settings_header"> <span class="part-title" translate="settings.passform.title">Zmiana has\u0142a</span> </h1> <form id="passwordChangeForm" class="block form" ng-submit="vm.resetPassword(user)" accept-charset="UTF-8" enctype="multipart/form-data" data-parsley-validate="data-parsley-validate"> <fieldset> <div class="form-group"> <label for="passwordChangeOld" class="control-label" translate="settings.passform.password">Podaj obecne has\u0142o:</label> <input class="form-control" type="password" name="passwordChangeOld" id="passwordChangeOld" required="required" autocomplete="new-password" ng-model="user.passwordChangeOld"> </div> <div class="form-group tooltip-left"> <label for="passwordChangeNew" class="control-label" translate="settings.passform.passwordNew">Podaj nowe has\u0142o:</label> <input class="form-control" type="password" name="passwordChangeNew" id="passwordChangeNew" tooltip-append-to-body="true" required="required" tooltip-placement="right" uib-tooltip-template="\'passwordTooltipTemplate.html\'" tooltip-trigger="focus mouseenter" tooltip-class="tooltip-text-align-left" ng-model="user.passwordChangeNew"> </div> <div class="form-group"> <label for="rePasswordChangeNew" class="control-label" translate="settings.passform.passwordConfirm">Ponownie podaj nowe has\u0142o:</label> <input class="form-control" type="password" name="rePasswordChangeNew" id="rePasswordChangeNew" nrequired="required" ng-model="user.rePasswordChangeNew"> </div> <button class="btn" name="submitChangePassword" type="submit" value="submitChangePassword"> <span translate="entity.action.save">Zapisz</span> <i class="fa fa-save"></i> </button> </fieldset> </form> </section> <hr> <section class="container container-fluid"> <section class="container container-fluid"> <div ng-show="vm.languageChangeErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.languageChangeErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only" translate="entity.action.close"> Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope" translate="{{vm.languageChangeErrorText}}"></span></div> </div> <div ng-show="vm.languageChangeSuccessText!=null" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert" type="success" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.languageChangeSuccessText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only" translate="entity.action.close"> Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope" translate="{{vm.languageChangeSuccessText}}"></span></div> </div> </section> <h1 class="settings_header"> <span class="part-title" translate="settings.langform.title">Zmiana domy\u015Blnego j\u0119zyka</span> </h1> <form id="languageChangeForm" class="langController block" ng-controller="JhiLanguageController as languageVm" ng-submit="vm.setLanguage();\n    ((vm.languageChangeErrorText)?null:(languageVm.changeLanguage(vm.language1)));\n    ((vm.languageChangeErrorText)?null:(vm.collapseNavbar()));" accept-charset="UTF-8" enctype="multipart/form-data" data-parsley-validate="data-parsley-validate"> <fieldset> <div class="form-group clear-margin-bottom" id="lang" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"> <select class="form-control" chosen ng-model="vm.language"> <option ng-repeat="language in languageVm.languages">{{language | findLanguageFromKey}}</option> </select> <br> </div> <button class="btn" name="submitChangeLanguage" value="submitChangeLanguage"> <span translate="entity.action.save">Zapisz</span> <i class="fa fa-save"></i> </button> </fieldset> </form> </section> <script type="text/ng-template" id="passwordTooltipTemplate.html"> <span ng-bind-html="vm.passwordTooltip()"></span> </script> </div> ');
$templateCache.put('app/views/roles/addRole.html','<div class="modal-header" xmlns="http://www.w3.org/1999/html"> <h1 class="title text-left"><span translate="roles.addingNewRole">Tworzenie nowej roli</span></h1> </div> <form id="resend" class="inline inline-search" accept-charset="UTF-8"> <div class="modal-body"> <div class="container-fluid"> <form class="form-inline"> <fieldset> <div class="form-group"> <label class="control-label" for="newName"><span translate="roles.roleName">Nazwa roli</span></label> <input class="form-control" id="newName" ng-model="vm.newRole.roleName" required> </div> <div class="form-group"> <label class="control-label" for="newDescription"><span translate="roles.roleDescription">Opis roli</span></label> <input class="form-control" id="newDescription" ng-model="vm.newRole.description"> </div> </fieldset> </form> <div height="10px"> <h3><span translate="roles.selectPermissions">Wybierz uprawnienia:</span></h3> <div ng-repeat="permission in vm.allPermissions"> <label> <input type="checkbox" value="{{permission.ediPermissionId}}" ng-checked="" ng-click="vm.toggleSelection($event,$index,permission)"> {{permission.permissionName}}  </label> </div> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary" ng-disabled="!vm.newRole.roleName" type="submit" ng-click="vm.modal.add()"><span translate="roles.add"> Dodaj</span> <i class="fa fa-plus"></i> </button> <button class="btn btn-warning" type="button" ng-click="vm.modal.cancel()"><span translate="roles.cancel"> Anuluj</span> <i class="fa fa-times"></i> </button> </div> </form> ');
$templateCache.put('app/views/roles/editRole.html','<div class="modal-header" xmlns="http://www.w3.org/1999/html"> <h1 class="title text-left"><span translate="roles.editRole">Edycja roli </span></h1> </div> <form id="resend" class="inline inline-search" accept-charset="UTF-8"> <div class="modal-body"> <div class="container-fluid"> <div class="form-inline"> <fieldset> <div class="form-group"> <label class="control-label" for="newName"><span translate="roles.roleName">Nazwa roli </span></label> <input class="form-control" id="newName" ng-model="vm.newRole.roleName" readonly="readonly"> </div> <div class="form-group"> <label class="control-label" for="newDescription"><span translate="roles.roleDescription">Opis roli </span></label> <input class="form-control" id="newDescription" ng-model="vm.newRole.description"> </div> </fieldset> </div> <div height="10px"> <h3><span translate="roles.selectPermissions">Wybierz uprawnienia: </span></h3> <div ng-repeat="permission in vm.allPermissions"> <label> <input type="checkbox" value="{{permission.ediPermissionId}}" ng-checked="permission.checked" ng-click="vm.toggleSelection($event,$index,permission)"> {{permission.permissionName}}  </label> </div> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary" type="submit" ng-click="vm.modal.update()"><span translate="roles.save"> Zapisz </span> <i class="fa fa-floppy-o"></i> </button> <button class="btn btn-warning" type="button" ng-click="vm.modal.delete()"><span translate="roles.delete"> Usu\u0144 </span> <i class="fa fa-trash"></i> </button> <button class="btn btn-warning" type="button" ng-click="vm.modal.cancel()"><span translate="roles.cancel"> Anuluj </span> <i class="fa fa-times"></i> </button> </div> </form> ');
$templateCache.put('app/views/roles/roles.html','<section class="container container-fluid" ng-if="$root.Principal.hasSystemAccess()"> <div id="fixed" class="container container-fluid embedded-page-padding" dynamic-height dh-element-id="#under-fixed"> <portal-alert></portal-alert> <div class="actionButtons row clear-margin-top"> <div class="col-xs-12"> <button id="AddRoleButton" title="Add role" ng-click="vm.goToAddRole()" class="btn btn-add btn-add-use"> <span translate="roles.add">Dodaj</span> <i class="fa fa-plus-square"></i> </button> </div> </div> </div> <div id="under-fixed"> <table id="fixtable" class="tablesorter latest" fix-table> <thead> <tr> <th><span translate="roles.ordinal"> Lp</span></th> <th> <span translate="roles.roleName">Nazwa roli</span> </th> <th> <span translate="roles.roleDescription">Opis roli</span> </th> </tr> </thead> <tbody> <tr ng-repeat="role in vm.roles" ng-click="vm.goToEditRole($event,$index,role)"> <td>{{$index+1}}</td> <td>{{ role.roleName}}</td> <td>{{ role.description}}</td> </tr> </tbody> <tfoot> <tr> <td colspan="3"></td> </tr> </tfoot> </table> </div> </section> ');
$templateCache.put('app/views/system-settings/system-settings.html','<div class="system-settings"> <section class="container-fluid embedded-page-padding" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <div ng-show="vm.getDataErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.getDataErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope">{{vm.getDataErrorText}}</span></div> </div> </section> <section class="container-fluid" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <h1 class="title text-left ng-scope clear-margin-top"><span translate="systemSettings.systemSettings.header">Ustawienia og\xF3lne</span></h1> <div class="voffset3"> <h6 for="passwordChangeInterval" translate="systemSettings.systemSettings.period1">Okres wa\u017Cno\u015Bci has\u0142a:</h6> <form id="intervalForm" name="intervalForm" class="form-inline voffset2"> <fieldset> <div class="form-group"> <label class="control-label" ng-show="vm.interval.current"><span translate="systemSettings.systemSettings.currentPeriod">Aktualny okres (w dniach) to</span>: {{vm.interval.current}}</label> <div> <div class="input-group"> <input class="form-control" ng-if="$root.Principal.hasSystemAccess()" type="number" id="passwordChangeInterval" required="required" min="1" ng-model="vm.interval.new"> <span class="input-group-addon multi-input"></span> <select class="form-control" ng-if="$root.Principal.hasSystemAccess()" ng-model="vm.interval.measure"> <option value="days" translate="systemSettings.systemSettings.days">dni</option> <option value="months" translate="systemSettings.systemSettings.months">miesi\u0105ce</option> <option value="years" translate="systemSettings.systemSettings.years">lata</option> </select> </div> </div> </div> <div class="form-group"> <label class="">&nbsp;</label> <div> <button ng-if="$root.Principal.hasSystemAccess()" type="submit" class="btn" ng-click="vm.interval.set()" ng-disabled="intervalForm.$invalid || intervalForm.$pending"> <span translate="systemSettings.systemSettings.set">Ustaw</span> <i class="fa fa-wrench"></i> </button> </div> </div> </fieldset> </form> </div> <div class="voffset5"> <h6 for="passwordChangeInterval" translate="systemSettings.systemSettings.period2">Okres wy\u015Bwietlania komunikatu przed up\u0142yni\u0119ciem wa\u017Cno\u015Bci has\u0142a:</h6> <form id="showIntervalForm" name="showIntervalForm" class="form-inline voffset2"> <fieldset> <div class="form-group"> <label class="control-label" ng-show="vm.showInterval.current"><span translate="systemSettings.systemSettings.currentPeriod">Aktualny okres (w dniach) to</span>: {{vm.showInterval.current}}</label> <div> <div class="input-group"> <input class="form-control" ng-if="$root.Principal.hasSystemAccess()" type="number" id="showPasswordChangeInterval" required="required" min="1" ng-model="vm.showInterval.new"> <span class="input-group-addon multi-input"></span> <select class="form-control" ng-if="$root.Principal.hasSystemAccess()" ng-model="vm.showInterval.measure"> <option value="days" translate="systemSettings.systemSettings.days">dni</option> <option value="months" translate="systemSettings.systemSettings.months">miesi\u0105ce</option> <option value="years" translate="systemSettings.systemSettings.years">lata</option> </select> </div> </div> </div> <div class="form-group"> <label class="">&nbsp;</label> <div> <button ng-if="$root.Principal.hasSystemAccess()" type="submit" class="btn" ng-click="vm.showInterval.set()" ng-disabled="showIntervalForm.$invalid || showIntervalForm.$pending"> <span translate="systemSettings.systemSettings.set">Ustaw</span> <i class="fa fa-wrench"></i> </button> </div> </div> </fieldset> </form> </div> </section> <hr> <section class="container container-fluid" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <div ng-show="vm.addingEmailTemplateErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.addingEmailTemplateErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope">{{vm.addingEmailTemplateErrorText}}</span></div> </div> <div ng-show="vm.addingEmailTemplateSuccessText!=null" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert" type="success" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.addingEmailTemplateSuccessText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope">{{vm.addingEmailTemplateSuccessText}}</span></div> </div> <h1 class="title text-left ng-scope"><span translate="systemSettings.addEmailTemplate.header">Dodaj szablon e-mail</span></h1> <div class="voffset3"> <form name="templateUploadForm" novalidate class="form"> <div class="form-group"> <label class="control-label" for="templateId"><span translate="systemSettings.addEmailTemplate.designation">Oznaczenie szablonu</span>:</label> <input class="form-control form-control-width-auto" type="text" id="templateId" required="required" ng-model="vm.template.name"> </div> <div class="form-group"> <label class="control-label"><span translate="systemSettings.getEmailTemplate.language">J\u0119zyk szablonu</span>:</label> <select class="form-control" ng-model="vm.template.language" style="width:100%"> <option ng-repeat="language in vm.languages" value="{{language.name}}">{{language.text()}}</option> </select> </div> <div class="form-group"> <label class="control-label"><span translate="systemSettings.addEmailTemplate.type">Typ szablonu</span>:</label> <select class="form-control" ng-model="vm.template.activity" style="width:100%"> <option ng-repeat="activity in vm.ActivityTypes" value="{{activity.name}}">{{activity.text()}}</option> </select> </div> <div class="form-group"> <div uib-dropdown class="dropdown pointer"> </div> <div name="html-input" ngf-select ngf-drop ng-model="file" ngf-multiple="false" ngf-allow-dir="false" ngf-drag-over-class="\'dragover\'" ngf-max-size="20MB" ngf-pattern="\'.html\'" ngf-accept="text/html" ngf-drop-available="dropAvailable" class="drop-box html-input" uib-tooltip="{{vm.htmlTooltip ? \'Dodawany dokument musi mie\u0107 odpowiednie rozszerzenie (.html).\' : \'\'}}" tooltip-placement="top"> {{file.name != null ? vm.translate(\'systemSettings.chosen1\') + " " + file.name + vm.translate(\'systemSettings.chosen2\') + ". "+ vm.translate(\'systemSettings.click_to_change\') + "." : vm.chooseOrDrop()}} </div> </div> <button type="submit" class="btn pull-right" ng-disabled="templateUploadForm.$invalid || templateUploadForm.$pending" ng-click="vm.chectUniqueNameAndType(file)"><span translate="systemSettings.addEmailTemplate.add">Dodaj</span> <i class="fa fa-plus"></i></button> </form> </div> </section> <hr> <section class="container container-fluid" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <h1 class="title text-left ng-scope"><span translate="systemSettings.getEmailTemplate.header">Pobierz szablon email</span></h1> <table class="tablesorter latest" fix-table> <thead> <tr> <th></th> <th translate="systemSettings.addEmailTemplate.designation">Oznaczenie szablonu</th> <th translate="systemSettings.getEmailTemplate.filename">Oryginalna nazwa pliku</th> <th translate="systemSettings.addEmailTemplate.type">Typ szablonu</th> <th translate="systemSettings.getEmailTemplate.language">J\u0119zyk</th> <th translate="systemSettings.getEmailTemplate.default">Domy\u015Blny</th> <th translate="systemSettings.getEmailTemplate.download">Pobieranie</th> </tr> </thead> <tbody> <tr ng-repeat="template in vm.dhlTemplates._embedded.dhlTemplates"> <td>{{$index+1+vm.dhlTemplates.page.size*vm.dhlTemplates.page.number}}</td> <td>{{template.name}}</td> <td>{{template.originalName}}</td> <td>{{vm.changeActionTypeToText(template.actionType)}}</td> <td>{{template.language}}</td> <td>{{(template.defaultTemplate)? vm.translate(\'yes\') : vm.translate(\'no\')}}</td> <td style="text-align: center"> <button class="btn" ng-click="vm.download(template.name, template.actionType, template.language, template.originalName)"> <span translate="systemSettings.getEmailTemplate.download2">Pobierz</span> <i class="fa fa-download"></i> </button> </td> </tr> </tbody> <tfoot> <tr> <td colspan="7"></td> </tr> </tfoot> </table> <div class="row" ng-if="vm.dhlTemplates._embedded.dhlTemplates.length > 0"> <br> <div class="col-sm-6 text-left"> <button class="btn" ng-disabled="!vm.dhlTemplates._links.first || (vm.dhlTemplates.page.number == 0)" ng-click="vm.listTemplates.first()"> <i class="fa fa-step-backward"></i> <span translate="systemSettings.getEmailTemplate.first">Pierwsza</span> </button> <button class="btn" ng-disabled="!vm.dhlTemplates._links.prev" ng-click="vm.listTemplates.previous()"> <i class="fa fa-chevron-left"></i> <span translate="systemSettings.getEmailTemplate.previous">Poprzednia</span> </button> </div> <div class="col-sm-6 text-right"> <button class="btn" ng-disabled="!vm.dhlTemplates._links.next" ng-click="vm.listTemplates.next()"> <span translate="systemSettings.getEmailTemplate.next">Nast\u0119pna</span> <i class="fa fa-chevron-right"></i> </button> <button class="btn" ng-disabled="!vm.dhlTemplates._links.last || (vm.dhlTemplates.page.number >= vm.dhlTemplates.page.totalPages-1)" ng-click="vm.listTemplates.last()"> <span translate="systemSettings.getEmailTemplate.last">Ostatnia</span> <i class="fa fa-step-forward"></i> </button> </div> </div> </section> <hr> <section class="container container-fluid" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <div ng-show="vm.addingEmailTitleErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.addingEmailTitleErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope">{{vm.addingEmailTitleErrorText}}</span></div> </div> <div ng-show="vm.addingEmailTitleSuccessText!=null" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert" type="success" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.addingEmailTitleSuccessText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope">{{vm.addingEmailTitleSuccessText}}</span></div> </div> <h1 class="title text-left ng-scope"><span translate="systemSettings.addSubjectTemplate.header">Dodaj szablon tematu</span></h1> <form name="titleUploadForm" novalidate class="form"> <div class="form-group"> <label class="control-label" for="templateName"><span translate="systemSettings.addEmailTemplate.designation">Oznaczenie szablonu</span>:</label> <input class="form-control form-control-width-auto" type="text" id="templateName" required="required" ng-model="vm.title.name"> </div> <div class="form-group"> <label class="control-label"><span translate="systemSettings.getEmailTemplate.language">J\u0119zyk szablonu</span>:</label> <select class="form-control" ng-model="vm.title.language" style="width:100%"> <option ng-repeat="language in vm.languages" value="{{language.name}}">{{language.text()}}</option> </select> </div> <div class="form-group"> <label class="control-label"><span translate="systemSettings.addEmailTemplate.type">Typ szablonu</span>:</label> <select class="form-control" ng-model="vm.title.activity" style="width:100%"> <option ng-repeat="activity in vm.ActivityTypes" value="{{activity.name}}">{{activity.text()}}</option> </select> </div> <div class="form-group"> <div uib-dropdown class="dropdown pointer"></div> </div> <div class="form-group"> <label class="control-label" for="templateTitle"><span translate="systemSettings.addSubjectTemplate.content">Tre\u015B\u0107 szablonu</span>:</label> <textarea class="form-control" id="titleArea" style="width:100%; min-height: 50px; resize: none" type="text" id="templateTitle" required="required" ng-model="vm.title.text"></textarea> </div> <div class="form-group"> <label class="control-label"><span translate="systemSettings.addSubjectTemplate.field">Dodaj pole specjalne</span>:</label> <div> <button type="button" class="btn" ng-click="vm.addClientNumber()"> <span translate="systemSettings.addSubjectTemplate.customer"> Nr klienta</span> <i class="fa fa-users"></i> </button> <button type="button" class="btn" ng-click="vm.addInvoiceNumber()"> <span translate="systemSettings.addSubjectTemplate.invoice"> Nr faktury</span> <i class="fa fa-file-text-o"></i> </button> <button type="button" class="btn" ng-click="vm.addInvoiceDate()"> <span translate="systemSettings.addSubjectTemplate.date">Data wystawienia faktury </span> <i class="fa fa-calendar"></i> </button> <button type="button" class="btn" ng-click="vm.addNettoValue()"> <span translate="systemSettings.addSubjectTemplate.net"> Warto\u015B\u0107 netto faktury</span> <i class="fa fa-money"></i> </button> <button type="submit" class="btn pull-right" ng-click="vm.checkTemplateTitle()"> <span translate="systemSettings.addEmailTemplate.add">Dodaj</span> <i class="fa fa-plus"></i> </button> </div> </div> </form> </section> <hr> <section class="container container-fluid" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <h1 class="title text-left ng-scope"><span translate="systemSettings.subjectTemplates.header">Szablony temat\xF3w e-mail</span></h1> <table id="fixtable" class="tablesorter latest" fix-table> <thead> <tr> <th></th> <th translate="systemSettings.addEmailTemplate.designation">Oznaczenie szablonu</th> <th translate="systemSettings.addEmailTemplate.type">Typ szablonu</th> <th translate="systemSettings.getEmailTemplate.language">J\u0119zyk</th> <th translate="systemSettings.getEmailTemplate.default">Domy\u015Blny</th> <th translate="systemSettings.addSubjectTemplate.content">Tre\u015B\u0107 szablonu</th> <!-- <th>Edycja</th> --> </tr> </thead> <tbody> <tr ng-repeat="title in vm.dhlTitles._embedded.dhlTemplates"> <td>{{$index+1+vm.dhlTitles.page.size*vm.dhlTitles.page.number}}</td> <td>{{title.name}}</td> <td>{{vm.changeActionTypeToText(title.actionType)}}</td> <td>{{title.language}}</td> <td>{{(title.defaultTemplate) ? vm.translate(\'yes\') : vm.translate(\'no\')}}</td> <td>{{title.content}}</td> </tr> </tbody> <tfoot> <tr> <td colspan="6"></td> </tr> </tfoot> </table> <div class="row" ng-if="vm.dhlTitles._embedded.dhlTemplates.length > 0"> <br> <div class="col-sm-6 text-left"> <button class="btn" ng-disabled="!vm.dhlTitles._links.first || (vm.dhlTitles.page.number == 0)" ng-click="vm.listTitles.first()"> <i class="fa fa-step-backward"></i> <span translate="systemSettings.getEmailTemplate.first">Pierwsza</span> </button> <button class="btn" ng-disabled="!vm.dhlTitles._links.prev" ng-click="vm.listTitles.previous()"> <i class="fa fa-chevron-left"></i> <span translate="systemSettings.getEmailTemplate.previous">Poprzednia</span> </button> </div> <div class="col-sm-6 text-right"> <button class="btn" ng-disabled="!vm.dhlTitles._links.next" ng-click="vm.listTitles.next()"> <span translate="systemSettings.getEmailTemplate.next">Nast\u0119pna</span> <i class="fa fa-chevron-right"></i> </button> <button class="btn" ng-disabled="!vm.dhlTitles._links.last || (vm.dhlTitles.page.number >= vm.dhlTitles.page.totalPages-1)" ng-click="vm.listTitles.last()"> <span translate="systemSettings.getEmailTemplate.last">Ostatnia</span> <i class="fa fa-step-forward"></i> </button> </div> </div> </section> <hr> <section class="container container-fluid" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <div ng-show="vm.clientErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.clientErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope">{{vm.clientErrorText}}</span></div> </div> <div ng-show="vm.clientSuccessText!=null" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert" type="success" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.clientSuccessText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope">{{vm.clientSuccessText}}</span></div> </div> <h1 class="title text-left ng-scope"><span translate="systemSettings.assignToUser.header">Przypisywanie szablonu do klienta</span></h1> <div> <form name="findUserForm" novalidate class="form voffset3"> <div class="form-group"> <label class="control-label" for="clientId"><span translate="systemSettings.assignToUser.edit">Podaj numer klienta</span>:</label> <input class="form-control form-control-width-auto" type="text" id="clientId" required="required" ng-model="vm.clientId"> </div> <button class="btn" ng-click="vm.getClientByNumber()"> <span translate="systemSettings.assignToUser.display">Wy\u015Bwietl</span> <i class="fa fa-eye"></i> </button> </form> </div> <div style="width:100%; overflow: auto" ng-show="vm.dhlClient && vm.client.templates.INVOICE_TOO_LARGE!=null"> <table class="tablesorter latest"> <thead> <tr> <th></th> <th>{{vm.ActivityTypes[0].text()}}</th> <th>{{vm.ActivityTypes[1].text()}}</th> <th>{{vm.ActivityTypes[2].text()}}</th> <th>{{vm.ActivityTypes[3].text()}}</th> <th>{{vm.ActivityTypes[4].text()}}</th> <th>{{vm.ActivityTypes[5].text()}}</th> <th>{{vm.ActivityTypes[6].text()}}</th> <th>{{vm.ActivityTypes[7].text()}}</th> <th>{{vm.ActivityTypes[8].text()}}</th> <th>{{vm.ActivityTypes[9].text()}}</th> <th>{{vm.ActivityTypes[10].text()}}</th> </tr> </thead> <tbody> <tr> <td translate="systemSettings.assignToUser.titlePL">Tytu\u0142 [PL]</td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titles.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'ACCOUNT_OPENED\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titles.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'EMAIL_ADDED\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titles.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'REGISTRATION_FAIL\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titles.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'PASSWORD_CHANGE\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titles.PAPER_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'PAPER_INVOICE\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titles.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titles.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titles.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titles.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titles.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'CORRECTION_INVOICE\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titles.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_TOO_LARGE\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> </tr> <tr> <td translate="systemSettings.assignToUser.contentPL">Tre\u015B\u0107 [PL]</td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templates.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'ACCOUNT_OPENED\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templates.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'EMAIL_ADDED\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templates.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'REGISTRATION_FAIL\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templates.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'PASSWORD_CHANGE\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templates.PAPER_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'PAPER_INVOICE\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templates.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templates.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templates.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templates.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templates.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'CORRECTION_INVOICE\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templates.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_TOO_LARGE\', language:\'pl\'} : true" style="width:100%"></select> <br> </div> </td> </tr> <tr> <td translate="systemSettings.assignToUser.titleEN">Tytu\u0142 [EN]</td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titlesEN.ACCOUNT_OPENED" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'ACCOUNT_OPENED\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titlesEN.EMAIL_ADDED" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'EMAIL_ADDED\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titlesEN.REGISTRATION_FAIL" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'REGISTRATION_FAIL\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titlesEN.PASSWORD_CHANGE" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'PASSWORD_CHANGE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titlesEN.PAPER_INVOICE" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'PAPER_INVOICE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titlesEN.INVOICE_WITH_LINK" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titlesEN.INVOICE_WITH_PDF" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titlesEN.INVOICE_WITH_LINK_AND_XLSX" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titlesEN.INVOICE_WITH_PDF_AND_XLSX" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titlesEN.CORRECTION_INVOICE" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'CORRECTION_INVOICE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.titlesEN.INVOICE_TOO_LARGE" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_TOO_LARGE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> </tr> <tr> <td translate="systemSettings.assignToUser.contentEN">Tre\u015B\u0107 [EN]</td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templatesEN.ACCOUNT_OPENED" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'ACCOUNT_OPENED\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templatesEN.EMAIL_ADDED" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'EMAIL_ADDED\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templatesEN.REGISTRATION_FAIL" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'REGISTRATION_FAIL\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templatesEN.PASSWORD_CHANGE" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'PASSWORD_CHANGE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templatesEN.PAPER_INVOICE" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'PAPER_INVOICE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templatesEN.INVOICE_WITH_LINK" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templatesEN.INVOICE_WITH_PDF" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templatesEN.INVOICE_WITH_LINK_AND_XLSX" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templatesEN.INVOICE_WITH_PDF_AND_XLSX" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templatesEN.CORRECTION_INVOICE" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'CORRECTION_INVOICE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.client.templatesEN.INVOICE_TOO_LARGE" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_TOO_LARGE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> </tr> </tbody> <tfoot> <tr> <td colspan="12"></td> </tr> </tfoot> </table> </div> <br> <button class="btn pull-right" ng-click="vm.sendNewUserTemplates()" ng-show="vm.dhlClient" translate="systemSettings.assignToUser.send">Prze\u015Blij</button> </section> </div> ');
$templateCache.put('app/views/users/usersPanel.html','<section class="container container-fluid" ui-view="innerContent" ng-if="$root.Principal.hasUserRead()"> </section> ');
$templateCache.put('app/views/clients/client/client.html','<div ng-if="$root.Principal.isAuthenticated()" class="embedded-page-padding"> <div class="row-fluid"> <div class="btn-enclose"> <button id="back" class="btn" ng-click="vm.nav.clients()"> <i class="fa fa-chevron-left"></i> <span translate="clients.client.back">Powr\xF3t</span> </button> </div> </div> <portal-alert></portal-alert> <div class="row voffset2" style="margin-left:0; margin-right:0"> <h1 class="title text-left"><span translate="clients.client.client">Klient</span></h1> <div class="col-md-5" style="padding-left:0px;padding-bottom: 10px"> <form id="clientForm" name="clientForm" novalidate> <table class="tablesorter latest"> <thead> <tr> <th></th> <th></th> </tr> </thead> <tbody> <tr> <td><span translate="clients.client.clientNumber">Numer Klienta</span></td> <td>{{vm.data.client.clientNumber}}</td> </tr> <tr> <td><span translate="clients.client.payerNumber">Numer p\u0142atnika</span></td> <td> <div click-to-edit ng-model="vm.data.client.payerNumber" data-maxlength="7" data-ng-pattern="/^[0-9]{7}$/" data-required="required"></div> </td> </tr> <tr> <td><span translate="clients.client.nipNumber">Numer NIP</span></td> <td> <div click-to-edit ng-model="vm.data.client.nip" data-maxlength="10" data-ng-pattern="/^[0-9]{10}$/"></div> </td> </tr> <tr> <td><span translate="clients.client.companyName">Nazwa firmy</span></td> <td> <div click-to-edit ng-model="vm.data.client.clientName" data-maxlength="255"></div> </td> </tr> <tr> <td><span translate="clients.client.documentsUsers">U\u017Cytkownicy e-faktury</span></td> <td> <div class="input-group" ng-if="($root.Principal.hasClientRead() && ! $root.Principal.hasAllDocumentsAccess()) || $root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <input class="form-control form-control-width-auto" id="documentsUsers" type="text" autocomplete="off" minlength="3" ng-model-options="{debounce:400}" ng-model="vm.data.userEmail" uib-typeahead="user for user in vm.user.getByEmail($viewValue)" typeahead-editable="true"> <span class="input-group-btn"> <button class="btn" ng-click="vm.user.add() "> <i class="fa fa-plus-square"></i> </button> <button class="btn" ng-click="vm.user.delete() " ng-disabled="vm.data.client.users.length==0 "> <i class="fa fa-minus-square"></i> </button> </span> </div> <div> <select class="form-control col-xs-12" multiple="multiple" ng-model="vm.selection" ng-options="user.email for user in vm.data.client.users | orderBy:email " ng-show="vm.data.client.users.length> 0"></select> </div> </td> </tr> <tr> <td><span translate="clients.client.receivablesUsers">U\u017Cytkownicy nale\u017Cno\u015Bci</span></td> <td> <div> <select class="form-control col-xs-12" ng-disabled="true" multiple="multiple" ng-model="ignore" ng-options="user.email for user in vm.data.client.receivablesUsers | orderBy:email " ng-show="vm.data.client.receivablesUsers.length> 0"></select> </div> </td> </tr> <tr> <td><span translate="clients.client.eInvoice">e-Faktura</span></td> <td> <input ng-if="$root.Principal.hasClientWrite()" id="clientEInvoiceAgreement" type="checkbox" ng-model="vm.data.client.eInvoiceAgreement"> <label for="clientEInvoiceAgreement" ng-show="vm.data.client.eInvoiceAgreement" translate="clients.client.yes">Tak</label> <label for="clientEInvoiceAgreement" ng-show="!vm.data.client.eInvoiceAgreement" translate="clients.client.no">Nie</label> </td> </tr> <tr> <td><span translate="clients.client.documentSendingMethod">Metoda wysy\u0142ki dokument\xF3w podstawowych</span></td> <td> <select id="clientDocSending" class="form-control" ng-if="$root.Principal.hasClientWrite()" ng-model="vm.data.client.docSending"> <option value="LINK">Link</option> <option value="PDF">PDF</option> <option value="LINK_XLSX" translate="clients.client.linkXlsx">Link oraz XLSX</option> <option value="PDF_XLSX" translate="clients.client.pdfXlsx">PDF oraz XLSX</option> </select> <span ng-if="! $root.Principal.hasClientWrite()">{{vm.data.client.docSending}}</span> </td> </tr> <tr> <td><span translate="clients.client.noteSendingMethod">Metoda wysy\u0142ki not ksi\u0119gowych</span></td> <td> <select id="clientNoteDocSending" class="form-control" ng-if="$root.Principal.hasClientWrite()" ng-model="vm.data.client.noteSending"> <option value="LINK">Link</option> <option value="PDF">PDF</option> <option value="LINK_XLSX" translate="clients.client.linkXlsx">Link oraz XLSX</option> <option value="PDF_XLSX" translate="clients.client.pdfXlsx">PDF oraz XLSX</option> </select> <span ng-if="! $root.Principal.hasClientWrite()">{{vm.data.client.noteSending}}</span> </td> </tr> <tr> <td><span translate="clients.client.correctionSendingMethod">Metoda wysy\u0142ki dokument\xF3w koryguj\u0105cych</span></td> <td> <!--\n                                <select id="clientCorrectingDocSending" class="form-control"\n                                        ng-if="$root.Principal.hasClientWrite()"\n                                        ng-model="vm.data.client.correctingDocSending">\n                                    <option value="LINK">Link</option>\n                                    <option value="PDF">PDF</option>\n                                    <option value="LINK_XLSX"><span translate="clients.client.linkXlsx">Link oraz XLSX</span></option>\n                                    <option value="PDF_XLSX"><span translate="clients.client.pdfXlsx">PDF oraz XLSX</span></option>\n                                </select> <span ng-if="! $root.Principal.hasClientWrite()">{{vm.data.client.correctingDocSending}}</span>\n--> <select id="clientCorrectingDocSending" class="form-control" ng-if="$root.Principal.hasClientWrite()"> <option value="LINK">Link</option> </select><span ng-if="! $root.Principal.hasClientWrite()">Link</span> </td> </tr> <tr> <td><span translate="clients.client.contactPerson">Osoba kontaktowa</span></td> <td> <div click-to-edit ng-model="vm.data.client.contactPerson" data-maxlength="50"></div> </td> </tr> <tr> <td> <span translate="clients.client.contactNumber">Telefon kontaktowy</span> </td> <td> <div click-to-edit ng-model="vm.data.client.phoneNumber" id="newClientPhoneNumber"> </td> </tr> <tr ng-if="$root.Principal.hasClientWrite()"> <td><span translate="clients.client.remarks">Uwagi</span></td> <td> <div click-to-edit ng-model="vm.data.client.notes" data-maxlength="100" textarea></div> </td> </tr> </tbody> <tfoot> <tr> <td colspan="2"></td> </tr> </tfoot> </table> <div ng-if="($root.Principal.hasClientRead() && ! $root.Principal.hasAllDocumentsAccess()) || $root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()" class="btn-enclose text-center"> <button class="btn" ng-click="vm.client.update()" ng-disabled="clientForm.$invalid || clientForm.$pending"> <span translate="clients.client.save">Zapisz </span><i class="fa fa-save"></i> </button> <button class="btn" ng-click="vm.client.cancel()"> <span translate="clients.client.cancel">Anuluj </span><i class="fa fa-times"></i> </button> </div> </form> </div> </div> <hr> <div ng-show="vm.clientErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.clientErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope">{{vm.clientErrorText}}</span> </div> </div> <div ng-show="vm.clientSuccessText!=null" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert" type="success" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.clientSuccessText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope">{{vm.clientSuccessText}}</span> </div> </div> <div class="row-fluid" ng-if="$root.Principal.hasTemplateAccess()"> <div class=""> <div style="width: 100%; overflow: auto" ng-show="vm.data.client.ediClientId && vm.clientTemplates.templates.INVOICE_TOO_LARGE != undefined && vm.clientTemplates.templates.INVOICE_TOO_LARGE != null && vm.clientTemplates.templates.INVOICE_TOO_LARGE != \'\'"> <h1 class="title text-left"><span translate="clients.client.emailTemplates">Szablony e-mail</span></h1> <table id="fixtable2" class="tablesorter latest"> <thead> <tr> <th></th> <th>{{vm.ActivityTypes[0].text()}}</th> <th>{{vm.ActivityTypes[1].text()}}</th> <th>{{vm.ActivityTypes[2].text()}}</th> <th>{{vm.ActivityTypes[3].text()}}</th> <th>{{vm.ActivityTypes[4].text()}}</th> <th>{{vm.ActivityTypes[5].text()}}</th> <th>{{vm.ActivityTypes[6].text()}}</th> <th>{{vm.ActivityTypes[7].text()}}</th> <th>{{vm.ActivityTypes[8].text()}}</th> <th>{{vm.ActivityTypes[9].text()}}</th> <th>{{vm.ActivityTypes[10].text()}}</th> </tr> </thead> <tbody> <tr> <td><span translate="clients.client.titlePL">Tytu\u0142 [PL]</span></td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titles.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'ACCOUNT_OPENED\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titles.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'EMAIL_ADDED\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titles.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'REGISTRATION_FAIL\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titles.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'PASSWORD_CHANGE\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titles.PAPER_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'PAPER_INVOICE\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titles.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titles.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titles.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titles.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titles.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'CORRECTION_INVOICE\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titles.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_TOO_LARGE\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> </tr> <tr> <td><span translate="clients.client.contentPL">Tre\u015B\u0107 [PL]</span></td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templates.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'ACCOUNT_OPENED\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templates.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'EMAIL_ADDED\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templates.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'REGISTRATION_FAIL\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templates.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'PASSWORD_CHANGE\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templates.PAPER_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'PAPER_INVOICE\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templates.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templates.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templates.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templates.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templates.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'CORRECTION_INVOICE\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templates.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_TOO_LARGE\', language:\'pl\'} : true" style="width: 100%"></select> <br> </div> </td> </tr> <tr> <td translate="clients.client.titleEN">Tytu\u0142 [EN]</td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.ACCOUNT_OPENED" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'ACCOUNT_OPENED\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.EMAIL_ADDED" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'EMAIL_ADDED\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.REGISTRATION_FAIL" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'REGISTRATION_FAIL\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.PASSWORD_CHANGE" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'PASSWORD_CHANGE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.PAPER_INVOICE" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'PAPER_INVOICE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.INVOICE_WITH_LINK" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.INVOICE_WITH_PDF" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.INVOICE_WITH_LINK_AND_XLSX" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.INVOICE_WITH_PDF_AND_XLSX" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.CORRECTION_INVOICE" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'CORRECTION_INVOICE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.INVOICE_TOO_LARGE" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_TOO_LARGE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> </tr> <tr> <td translate="clients.client.contentEN">Tre\u015B\u0107 [EN]</td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.ACCOUNT_OPENED" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'ACCOUNT_OPENED\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.EMAIL_ADDED" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'EMAIL_ADDED\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.REGISTRATION_FAIL" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'REGISTRATION_FAIL\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.PASSWORD_CHANGE" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'PASSWORD_CHANGE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.PAPER_INVOICE" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'PAPER_INVOICE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.INVOICE_WITH_LINK" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.INVOICE_WITH_PDF" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.INVOICE_WITH_LINK_AND_XLSX" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.INVOICE_WITH_PDF_AND_XLSX" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.CORRECTION_INVOICE" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'CORRECTION_INVOICE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.INVOICE_TOO_LARGE" ng-options="titleEn.name for titleEn in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_TOO_LARGE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> </tr> </tbody> <tfoot> <tr> <td colspan="12"></td> </tr> </tfoot> </table> </div> <br> <button class="btn pull-right" ng-click="vm.sendNewUserTemplates()" ng-show="vm.data.client.ediClientId && vm.clientTemplates.templates.INVOICE_TOO_LARGE != undefined &&\n                    vm.clientTemplates.templates.INVOICE_TOO_LARGE != null && vm.clientTemplates.templates.INVOICE_TOO_LARGE != \'\'"> <span translate="clients.client.save">Zapisz </span> <i class="fa fa-save"></i> </button> </div> </div> </div> ');
$templateCache.put('app/views/clients/clients/clients.html','<div id="fixed" class="container container-fluid embedded-page-padding"> <portal-alert></portal-alert> <form id="filter" class="form-inline" accept-charset="UTF-8"> <fieldset> <div class="form-group"> <label class="control-label" for="searchSAPId"><span translate="clients.clients.sapNumber">Numer SAP</span>:</label> <input class="form-control margin-bottom" type="text" id="searchSAPId" ng-model="vm.filter.data.clientNumber"> </div> <div class="form-group"> <label class="control-label" for="searchClientName"><span translate="clients.clients.name">Nazwa</span>:</label> <input class="form-control margin-bottom" type="text" id="searchClientName" ng-model="vm.filter.data.clientName"> </div> <div class="form-group"> <label class="control-label" for="searchClientUserLogin"><span translate="clients.clients.userEmail">E-mail u\u017Cytkownika</span>:</label> <input class="form-control margin-bottom" type="text" id="searchClientUserLogin" ng-model="vm.filter.data.email"> </div> <div class="form-group"> <label class="">&nbsp;</label> <div> <button type="submit" data-role="search" class="btn margin-bottom" value="search" ng-click="vm.client.current()"> <span translate="clients.clients.search">Szukaj</span> <i class="fa fa-search"></i> </button> </div> </div> <div class="form-group"> <label class="">&nbsp;</label> <div> <button id="delete" class="btn margin-bottom" ng-click="vm.filter.clear()"> <span translate="clients.clients.clean">Czy\u015B\u0107</span> <i class="fa fa-eraser"></i> </button> </div> </div> </fieldset> </form> <div class="actionButtons row" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <div class="col-xs-12"> <button type="submit" class="btn btn-add btn-add-use" ng-click="vm.client.new()"><span translate="clients.clients.add"> Dodaj</span> <i class="fa fa-plus-square"></i> </button> </div> </div> </div> <div id="under-fixed"> <div class="row text-center" ng-show="vm.data._embedded != null && vm.data._embedded.dhlClientPortalEntryResources.length == 0"> <h2><strong><span translate="clients.clients.noResults">Brak klient\xF3w spe\u0142niaj\u0105cych podane kryteria wyszukiwania</span></strong></h2> </div> <div ng-show="vm.data._embedded.dhlClientPortalEntryResources.length > 0"> <table id="fixtable" class="tablesorter latest" fix-table> <thead> <tr> <th><span translate="clients.clients.ordinal">Lp</span></th> <th><span translate="clients.clients.name">Nazwa</span></th> <th><span translate="clients.clients.clientNumber">Numer klienta</span></th> <th><span translate="clients.clients.payerNumber">Numer p\u0142atnika</span></th> <th><span translate="clients.clients.userEmails">Adresy e-mail u\u017Cytkownik\xF3w</span></th> <th><span translate="clients.clients.eInvoiceAcceptance">Zgoda na e-Faktury</span></th> </tr> </thead> <tbody ng-repeat="entry in vm.data._embedded.dhlClientPortalEntryResources" ng-dblclick="vm.nav.client(entry.client)"> <tr> <td>{{$index+1+vm.data.page.size*vm.data.page.number}}</td> <td>{{entry.client.clientName}}</td> <td>{{entry.client.clientNumber}}</td> <td>{{entry.client.payerNumber}}</td> <td> <span ng-if="entry.user == null" translate="clients.clients.none"> Brak </span> <span ng-if="entry.user != null"> {{entry.user.email}} </span> </td> <td> <span ng-if="entry.client.eInvoiceAgreement != null && entry.client.eInvoiceAgreement" translate="clients.newClient.yes"></span> <span ng-if="entry.client.eInvoiceAgreement != null && !entry.client.eInvoiceAgreement" translate="clients.newClient.no"></span> </td> </tr> </tbody> <tfoot> <tr> <td colspan="6"></td> </tr> </tfoot> </table> </div> <div class="row actionButtons" ng-if="vm.data._embedded.dhlClientPortalEntryResources.length > 0"> <div class="col-sm-6 text-left"> <button class="btn" ng-disabled="!vm.data._links.first || (vm.data.page.number == 0)" ng-click="vm.client.first()"> <i class="fa fa-step-backward"></i><span translate="clients.clients.first">Pierwsza </span></button> <button class="btn" ng-disabled="!vm.data._links.prev" ng-click="vm.client.previous()"> <i class="fa fa-chevron-left"></i><span translate="clients.clients.previous">Poprzednia </span></button> </div> <div class="col-sm-6 text-right"> <button class="btn" ng-disabled="!vm.data._links.next" ng-click="vm.client.next()"> <span translate="clients.clients.next">Nast\u0119pna</span> <i class="fa fa-chevron-right"></i> </button> <button class="btn" ng-disabled="!vm.data._links.last || (vm.data.page.number >= vm.data.page.totalPages-1)" ng-click="vm.client.last()"> <span translate="clients.clients.last">Ostatnia</span> <i class="fa fa-step-forward"></i> </button> </div> </div> <div ng-show=" $root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess() " class="voffset3"> <h1 class="title"><span translate="clients.clients.groupClientManagement">Grupowe zarz\u0105dzanie klientami</span></h1> <div ng-show="vm.management.status===\'failed\'" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert " type="danger " close="alert.close($ctrl.alerts) "> <button ng-show="true " type="button " class="close" ng-click="vm.addingEmailTemplateErrorText=null " aria-hidden="false "> <span aria-hidden="true ">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope" translate="clients.clients.actionFailed">Akcja nie powiod\u0142a si\u0119. Spr\xF3buj ponownie p\xF3\u017Aniej lub skontaktuj sie z administratorem.</span></div> </div> <div ng-show="vm.management.status===\'succeeded\'" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert " type="success " close="alert.close($ctrl.alerts) "> <button ng-show="true " type="button " class="close" ng-click="vm.addingEmailTemplateSuccessText=null " aria-hidden="false "> <span aria-hidden="true ">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope" translate="clients.clients.actionSuccess">Akcja zako\u0144czona sukcesem.</span></div> </div> <div> <div ngf-drop ngf-select ng-model="vm.management.file " class="drop-box" ngf-drag-over-class=" \'dragover\' " ngf-multiple="false " ngf-allow-dir="false " accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet "><span translate="clients.clients.dropXlsx">Upu\u015B\u0107 skoroszyt Excel (*.XLSX) z danymi</span></div> <div ngf-no-file-drop> <div class="button" ngf-select ng-model="vm.management.file " ngf-multiple="false " ngf-allow-dir="false " accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet "> Wybierz skoroszyt Excel (*.XLSX) z danymi</div> </div> <uib-progressbar ng-class="{active : !vm.management.done, \'progress-striped\' : !vm.management.done} " value="vm.management.progress " type="{{vm.management.status}} " ng-show="vm.management.progress !=0 "><span style="color:white; white-space:nowrap" translate="{{vm.management.message}}"></span></uib-progressbar> <div width="100%" style="overflow-x: auto; text-align: center" ng-show="vm.management.errors.length> 0"> <h2><strong><span translate="clients.clients.fixFile">Napraw plik r\u0119cznie i za\u0142aduj go ponownie</span></strong></h2> <table class="tablesorter latest" fix-table> <thead> <tr> <th></th> <th><span translate="clients.clients.cell">Kom\xF3rka</span></th> <th><span translate="clients.clients.error">B\u0142\u0105d</span></th> </tr> </thead> <tbody> <tr ng-repeat="error in vm.management.errors"> <td>{{$index+1}}</td> <td>{{error.field}}</td> <td> <span ng-if="error.message.endsWith(\'wrong_file_format\')" translate="clients.clients.wrongFile"></span> <span ng-if="error.message.endsWith(\'required\')" translate="clients.clients.required"></span> <span ng-if="error.message.endsWith(\'not_found\')" translate="clients.clients.notFound"></span> <span ng-if="error.message.endsWith(\'not_found_client\')" translate="clients.clients.notFoundClient"></span> <span ng-if="error.message.endsWith(\'wrong\')" translate="clients.clients.wrong"></span> <span ng-if="error.message.endsWith(\'multiple_add\')" translate="clients.clients.multipleAdd"></span> <span ng-if="error.message.endsWith(\'client_exists\')" translate="clients.clients.clientExists"></span> <span ng-if="error.message.endsWith(\'multiple\')" translate="clients.clients.multiple"></span> </td> </tr> </tbody> <tfoot> <tr> <td colspan="16"></td> </tr> </tfoot> </table> </div> <div width="100%" style="overflow-x: auto" ng-show="vm.actions.length > 0"> <table class="tablesorter latest" fix-table> <thead> <tr> <th></th> <th><span translate="clients.clients.action">Akcja</span></th> <th><span translate="clients.clients.clientNumber">Nr Klienta</span></th> <th><span translate="clients.clients.payerNumber">Nr p\u0142atnika</span></th> <th><span translate="clients.clients.clientName">Nazwa Klienta</span></th> <th><span translate="clients.clients.contactPerson">Osoba kontaktowa</span></th> <th><span translate="clients.clients.contactNumber">Telefon kontaktowy</span></th> <th><span translate="clients.clients.addLogin">Login - dodaj/aktualizuj</span></th> <th><span translate="clients.clients.deleteLogin">Login - usu\u0144</span></th> <th><span translate="clients.clients.portalLanguage">J\u0119zyk portalu</span></th> <th><span translate="clients.clients.templateType">Typ szablonu</span></th> <th><span translate="clients.clients.emailTemplate">Szablon e-mail</span></th> <th><span translate="clients.clients.subjectTemplate">Szablon tematu</span></th> <th><span translate="clients.clients.eInvoice">Czy e-billing?</span></th> <th><span translate="clients.clients.documentSendingMethod">Metoda wysy\u0142ki dokument\xF3w podstawowych</span></th> <th><span translate="clients.clients.correctionSendingMethod">Metoda wysy\u0142ki korekt</span></th> <th><span translate="clients.clients.remarks">Uwagi</span></th> </tr> </thead> <tbody> <tr ng-repeat="action in vm.actions"> <td>{{$index+1}}</td> <td>{{action.actionType}}</td> <td>{{action.clientNumber}}</td> <td>{{action.payerNumber}}</td> <td>{{action.clientName}}</td> <td>{{action.contactPerson}}</td> <td>{{action.phoneNumber}}</td> <td>{{action.loginAddUpdate}}</td> <td>{{action.loginDelete}}</td> <td>{{action.accountLanguage}}</td> <td>{{action.templateType}}</td> <td>{{action.emailTemplate}}</td> <td>{{action.subjectTemplate}}</td> <td><span ng-if="action.eBilling != null" translate="{{action.eBilling ? \'clients.newClient.yes\' : \'clients.newClient.no\'}}"></span></td> <td>{{action.documentDeliveryMethod}}</td> <td>{{action.correctingDocumentDeliveryMethod}}</td> <td>{{action.notes}}</td> </tr> </tbody> <tfoot> <tr> <td colspan="17"></td> </tr> </tfoot> </table> </div> <div class="btn-enclose text-left" ng-show="vm.actions.length > 0"> <button class="btn" ng-disabled="!(vm.actions.length > 0)" ng-click="vm.management.manage()"> <span translate="clients.clients.accept">Zatwierd\u017A zmiany</span> <i class="fa fa-check"></i> </button> <button class="btn" ng-disabled="!(vm.actions.length > 0)" ng-click="vm.management.cancel()"> <span translate="clients.clients.cancel">Anuluj</span> <i class="fa fa-times"></i> </button> </div> </div> </div> </div> ');
$templateCache.put('app/views/clients/newClient/newClient.html','<div class="modal-header"> <h3 class="modal-title"><span translate="clients.newClient.title">Dodawanie nowego klienta</span></h3> </div> <div ng-show="vm.data.duplicateEmailError!=null"> <br> <div class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.data.duplicateEmailError=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope" translate="clients.client.duplicateEmail">{{vm.data.duplicateEmailError}}</span> </div> </div> </div> <form class="" id="newClient" name="newClient" class="form" accept-charset="UTF-8" novalidate> <div class="modal-body"> <div class="container-fluid"> <div class="row"> <table class="property-table"> <tr> <td> <label for="newClientNumber"><span translate="clients.newClient.clientNumber">Numer klienta:</span></label> </td> <td> <input class="form-control form-control-width-auto input-sm input-smallest" type="text" id="newClientNumber" required="required" ng-model="vm.data.clientNumber" maxlength="7" ng-change="vm.modal.clientCheck()" ng-pattern="/[0-9]{7}/" ng-model-options="{allowInvalid:true}"> <span ng-show="vm.data.clients.length != 0" style="color: #d40511" translate="clients.newClient.clientExists">Klient istnieje</span> </td> </tr> <tr> <td> <label for="newClientPayerNumber"><span translate="clients.newClient.payerNumber">Numer p\u0142atnika:</span></label> </td> <td> <input class="form-control form-control-width-auto input-sm input-smallest" type="text" id="newClientPayerNumber" ng-model="vm.data.payerNumber" maxlength="7" ng-pattern="/[0-9]{7}/" ng-model-options="{allowInvalid:true}"> </td> </tr> <tr> <td> <label for="newClientName"><span translate="clients.newClient.clientName">Nazwa klienta:</span></label> </td> <td> <input class="form-control form-control-width-auto input-sm input-smallest" type="text" id="newClientName" required="required" maxlength="255" ng-model="vm.data.clientName"> </td> </tr> <tr> <td> <label for="newClientUsers"><span translate="clients.newClient.userEmails">Adresy e-mail u\u017Cytkownik\xF3w:</span></label> </td> <td> <div class="input-group form-control-width-auto"> <input class="form-control form-control-width-auto input-sm input-smallest" id="newClientUsers" type="text" autocomplete="off" minlength="3" ng-model="vm.data.user" ng-model-options="{debounce: 300}" uib-typeahead="user for user in vm.user.getByEmail($viewValue)" typeahead-editable="true" ng-pattern="/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/" ng-model-options="{allowInvalid:true}"> <span class="input-group-btn"> <button class="btn btn-smallest" ng-click="vm.user.add()"> <i class="fa fa-plus-square"></i> </button> <button class="btn btn-smallest" ng-click="vm.user.delete() " ng-disabled="vm.data.users.length==0 "> <i class="fa fa-minus-square"></i> </button> </span> </div> <div> <select class="col-xs-12 input-sm" style="height: 54px" multiple="multiple" ng-model="vm.selection " ng-options="user.email for user in vm.data.users | orderBy:email " ng-show="vm.data.users.length> 0"></select> </div> </td> </tr> <tr> <td> <label for="newClientEInvoice"><span translate="clients.newClient.eInvoiceAcceptance">Zgoda na e-Faktury:</span></label> </td> <td> <select class="form-control form-control-width-auto input-sm input-smallest" id="newClientEInvoice" required="required" ng-model="vm.data.eInvoiceAgreement"> <option value="true" selected="selected"><span translate="clients.newClient.yes">Tak</span></option> <option value="false"><span translate="clients.newClient.no">Nie</span></option> </select> </td> </tr> <tr> <td> <label for="newClientLanguage"><span translate="clients.newClient.portalLanguage">J\u0119zyk portalu:</span></label> </td> <td> <select class="form-control form-control-width-auto input-sm input-smallest" id="newClientLanguage" required="required" ng-model="vm.data.portalLang"> <option value="PL" selected="selected">Polski</option> <option value="EN">English</option> </select> </td> </tr> <tr> <td> <label for="newClientDocSending"><span translate="clients.newClient.documentSendingMethod">Metoda wysy\u0142ki dokument\xF3w podstawowych:</span></label> </td> <td> <select class="form-control form-control-width-auto input-sm input-smallest" id="newClientDocSending" required="required" ng-model="vm.data.docSending"> <option value="LINK" selected="selected">Link</option> <option value="PDF">PDF</option> <option value="LINK_XLSX">{{vm.linkXlsx}}</option> <option value="PDF_XLSX">{{vm.pdfXlsx}}</option> </select> </td> </tr> <tr> <td><span translate="clients.client.noteSendingMethod">Metoda wysy\u0142ki not ksi\u0119gowych</span></td> <td> <select id="newClientNoteDocSending" class="form-control form-control-width-auto input-sm input-smallest" ng-model="vm.data.noteSending"> <option value="LINK">Link</option> <option value="PDF">PDF</option> <option value="LINK_XLSX" translate="clients.client.linkXlsx">Link oraz XLSX</option> <option value="PDF_XLSX" translate="clients.client.pdfXlsx">PDF oraz XLSX</option> </select> </td> </tr> <tr> <td> <label for="newClientCorrectingDocSending"><span translate="clients.newClient.correctionSendingMethod">Metoda wysy\u0142ki dokument\xF3w koryguj\u0105cych:</span></label> </td> <td> <select class="form-control form-control-width-auto input-sm input-smallest" id="newClientCorrectingDocSending" required="required" ng-model="vm.data.correctingDocSending"> <option value="LINK" selected="selected">Link</option> <!-- waiting for DHL templates\n                                <option value="PDF">PDF</option>\n                                <option value="LINK_XLSX">{{vm.linkXlsx}}</option>\n                                <option value="PDF_XLSX">{{vm.pdfXlsx}}</option>--> </select> </td> </tr> <tr> <td> <label for="newClientNIP"><span translate="clients.newClient.clientNip">NIP klienta:</span></label> </td> <td> <input class="form-control form-control-width-auto input-sm input-smallest" type="text" id="newClientNIP" minlength="10" maxlength="10" ng-model="vm.data.nip" ng-pattern="/[0-9]{10}/" ng-model-options="{allowInvalid:true}"> </td> </tr> <tr> <td> <label for="newClientContactPerson "><span translate="clients.newClient.contactPerson">Osoba kontaktowa:</span></label> </td> <td> <input class="form-control form-control-width-auto input-sm input-smallest" type="text" id="newClientContactPerson" ng-model="vm.data.contactPerson"> </td> </tr> <tr> <td> <label for="newClientPhoneNumber"><span translate="clients.newClient.contactNumber">Telefon kontaktowy:</span></label> </td> <td> <input class="form-control form-control-width-auto input-sm input-smallest" type="text" id="newClientPhoneNumber" ng-model="vm.data.phoneNumber"> </td> </tr> <tr> <td> <label for="newClientNotes"><span translate="clients.newClient.remarks">Uwagi:</span></label> </td> <td> <textarea class="form-control form-control-width-auto" id="newClientNotes" rows="2" cols="70" ng-model="vm.data.notes" maxlength="100"></textarea> </td> </tr> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-sm" type="submit" ng-click="vm.modal.add()" ng-disabled="newClient.$invalid || newClient.$pending || vm.data.users.length == 0 || vm.data.clients.length != 0"> <span translate="clients.newClient.add">Dodaj</span> <i class="fa fa-plus-square"></i> </button> <button class="btn btn-warning btn-sm" type="button" ng-click="vm.modal.cancel()"> <span translate="clients.newClient.cancel">Anuluj</span> <i class="fa fa-times"></i> </button> </div> </form> ');
$templateCache.put('app/views/login/passwordExpired/passwordExpired.html','<div class="modal-header"> <h3 class="modal-title">Wyga\u015Bni\u0119cie has\u0142a</h3> </div> <form id="newClient" name="newClient" class="" accept-charset="UTF-8"> <div class="modal-body"> <div class="container-fluid"> Twoje has\u0142o wyga\u015Bnie za {{vm.data.days}} dni. </div> </div> <div class="modal-footer"> <!--         <button class="btn btn-primary" type="submit" ng-click="vm.modal.add()" ng-disabled="newClient.$invalid || newClient.$pending"> Dodaj\n            <i class="fa fa-plus-square"></i>\n        </button> --> <button class="btn btn-warning" type="button" ng-click="vm.modal.ok()"> OK <!-- <i class="fa fa-times"></i> --> </button> </div> </form> ');
$templateCache.put('app/views/pending-cases/rejection-modal/rejection.modal.html','<div class="modal-header"> <h1 class="modal-title title" id="modal-title"> <span translate="pendingCases.rejectionModal.title"> Odrzucenie rejestracji </span> </h1> </div> <div class="modal-body" id="modal-body"> <p> <span translate="pendingCases.rejectionModal.reason"> Podaj przyczyn\u0119 odrzucenia rejestracji: </span> </p> <br> <textarea style="width:100%; min-height: 54px; resize: none" type="text" ng-model="vm.reason"></textarea> </div> <div class="modal-footer"> <button class="btn" type="button" ng-click="vm.modal.go(vm.reason)"> <span translate="pendingCases.rejectionModal.continue">Kontynuuj</span> </button> <button class="btn" type="button" ng-click="vm.modal.cancel()"> <span translate="pendingCases.rejectionModal.cancel">Anuluj</span> </button> </div> ');
$templateCache.put('app/views/system-settings/template-upload-modal/system-settings.modal.html','<div class="modal-header"> <h1 class="modal-title title" id="modal-title" translate="systemSettings.addEmailTemplate.attention">Uwaga!</h1> </div> <div class="modal-body" id="modal-body" translate="systemSettings.addEmailTemplate.msg"> Szablon o podanym oznaczeniu i typie akcji znajduje si\u0119 ju\u017C w portalu. Aby nadpisa\u0107 plik znajduj\u0105cy si\u0119 w portalu wybierz "Kontynuuj". Aby zachowa\u0107 oba szablony wybierz "Anuluj", zmie\u0144 oznaczenie Twojego szablonu w formularzu i ponownie wci\u015Bnij przycisk "Dodaj". </div> <div class="modal-footer"> <button class="btn btn-primary" type="button" ng-click="vm.modal.go()" translate="systemSettings.addEmailTemplate.continue">Kontynuuj</button> <button class="btn btn-warning" type="button" ng-click="vm.modal.cancel()" translate="systemSettings.addEmailTemplate.cancel">Anuluj</button> </div> ');
$templateCache.put('app/views/users/newUser/newUser.html','<div class="modal-header"> <h3 class="modal-title"> <span translate="users.newUser.title">Dodawanie nowego u\u017Cytkownika</span> </h3> </div> <div class="user"> <form id="newUserForm" name="newUserForm" class="user form-inline inline-search form-padding" accept-charset="UTF-8"> <div class="modal-body"> <portal-alert></portal-alert> <div class="container-fluid"> <form class="form-inline"> <fieldset> <div class="form-group"> <label for="newUserLogin" class="control-label"><span translate="users.newUser.email">E-mail:</span></label> <email id="newUserLogin"> </div> <div class="form-group"> <label class="control-label" for="newUserPassword"> <span translate="users.newUser.password">Has\u0142o:</span> </label> <input class="form-control" type="password" id="newUserPassword" autocomplete="off" required="required" ng-model="vm.data.password"> </div> </fieldset> </form> </div> </div> <div class="modal-footer"> <button class="btn btn-primary" type="submit" ng-click="vm.modal.add()" ng-disabled="newUserForm.$invalid || newUserForm.$pending"> <span translate="users.newUser.add">Dodaj</span> <i class="fa fa-plus-square"></i> </button> <button class="btn btn-warning" type="button" ng-click="vm.modal.cancel()"> <span translate="users.newUser.cancel">Anuluj</span> <i class="fa fa-times"></i> </button> </div> </form> </div> ');
$templateCache.put('app/views/users/report/userReport.html','<div class="modal-header"> <h3 class="modal-title"><span translate="users.report.title">Generowanie raportu</span></h3> </div> <form id="userReport" class="voffset4" accept-charset="UTF-8"> <div class="modal-body"> <uib-tabset active="vm.active"> <uib-tab index="0" heading="{{ vm.translate(\'users.report.listHeader\') }}"> <div class="container-fluid"> <div class="form-inline row"> <fieldset class="col-xs-12" style="margin-top:15px"> <div class="form-group"> <label class="control-label" for="reportUserLogin"><span translate="users.report.email">E-mail:</span></label> <input class="form-control margin-bottom" type="text" id="reportUserLogin" ng-model="vm.filter.email"> </div> <div class="form-group"> <label class="control-label" for="reportUserSAPId"><span translate="users.report.clientSapNumber">Numer SAP klienta:</span></label> <input class="form-control margin-bottom" type="text" id="reportUserSAPId" ng-model="vm.filter.clientNumber"> </div> <div class="form-group"> <label class="control-label" for="reportUserClientName"><span translate="users.report.clientName">Nazwa klienta:</span></label> <input class="form-control margin-bottom" type="text" id="reportUserClientName" ng-model="vm.filter.clientName"> </div> </fieldset> </div> </div> </uib-tab> <uib-tab index="1" heading="{{ vm.translate(\'users.report.activitiesHeader\') }}"> <div class="container-fluid"> <div class="row form form-small"> <fieldset class="col-xs-12" style="margin-top:15px"> <div class="form-group clear-margin-bottom"> <label class="control-label"><span translate="users.report.changeDate">Data zmiany</span>:</label> <md-datepicker class="datepicker" id="reportUserActivityDateFrom" name="date_end" ng-model="vm.filter.activityDateFrom" md-placeholder="{{ vm.translate(\'from\') }}"></md-datepicker> <md-datepicker class="datepicker" id="reportUserActivityDateTo" ng-model="vm.filter.activityDateTo" md-placeholder="{{ vm.translate(\'to\') }}"></md-datepicker> </div> <br> <div class="form-group"> <label class="control-label"><span translate="users.report.userType">Rodzaj u\u017Cytkownika: </span></label> <select class="form-control margin-bottom input-sm" id="reportUserActivityUserType" ng-model="vm.filter.activityUserTypes"> <option value="" selected="selected"></option> <option value="SYSTEM" translate="users.report.system"></option> <option value="DHL_USER" translate="users.report.dhl_user"></option> <option value="CLIENT_USER" translate="users.report.client_user"></option> </select> </div> <div class="form-group"> <label class="control-label" for="reportUserClientName"><span translate="users.report.changeOperator">Operator zmiany: </span></label> <input class="form-control margin-bottom input-sm" type="text" id="reportUserActivityOperator" ng-model="vm.filter.activityOperators"> </div> <div class="form-group"> <label class="control-label"><span translate="users.report.userLogin">Login u\u017Cytkownika: </span></label> <input class="form-control margin-bottom input-sm" type="text" id="reportUserActivityAction" ng-model="vm.filter.activityUserEmails"> </div> <br> <div class="form-group"> <label class="control-label"><span translate="users.report.activityType">Rodzaj akcji / aktywno\u015Bci: </span></label> <select class="form-control margin-bottom input-sm" id="actionTypeMultiselect" ng-model="vm.filter.activityActionTypes" multiple="multiple"> <option value="LOGIN_ADDED">{{ vm.translate(\'users.report.addLogin\') }}</option> <option value="DHL_USER_ADDED">{{ vm.translate(\'users.report.addNewUser\') }}</option> <option value="HTML_DOCUMENT_SEEN">{{ vm.translate(\'users.report.htmlDocumentSeen\') }}</option> <option value="PDF_DOCUMENT_SEEN">{{ vm.translate(\'users.report.pdfDocumentSeen\') }}</option> <option value="XLSX_DOCUMENT_SEEN">{{ vm.translate(\'users.report.xlsxDocumetSeen\') }}</option> <option value="DOCUMENT_DELETED">{{ vm.translate(\'users.report.documentDeleted\') }}</option> <option value="DOCUMENT_CREATED">{{ vm.translate(\'users.report.documentCreated\') }}</option> <option value="DOCUMENT_SENT">{{ vm.translate(\'users.report.documentSent\') }}</option> <option value="DOCUMENT_SENT_AGAIN">{{ vm.translate(\'users.report.documentSentAgain\') }}</option> <option value="DOCUMENT_APPROVED">{{ vm.translate(\'users.report.documentApproved\') }}</option> <option value="CLIENT_ACCOUNT_REJECTED">{{ vm.translate(\'users.report.clientAcountRejected\') }}</option> <option value="CLIENT_ACCOUNT_CONFIRMED">{{ vm.translate(\'users.report.clientAccountConfirmed\') }}</option> <option value="LP_SCAN_DOWNLOADED">{{ vm.translate(\'users.report.lpScanDownloaded\') }}</option> <option value="LOGIN_DELETED">{{ vm.translate(\'users.report.loginDeleted\') }}</option> <option value="DHL_USER_DELETED">{{ vm.translate(\'users.report.userDeleted\') }}</option> <option value="SAP_PROFILE_CREATED">{{ vm.translate(\'users.report.sapProfileCreated\') }}</option> <option value="REGISTRATION_APPROVAL_SENT">{{ vm.translate(\'users.report.registrationApprovalSent\') }}</option> <option value="REGISTRATION_REJECTION_SENT">{{ vm.translate(\'users.report.registrationRejectionSent\') }}</option> <option value="E_BILLING_CHANGE">{{ vm.translate(\'users.report.eBillingChange\') }}</option> <option value="PASSWORD_CHANGE">{{ vm.translate(\'users.report.passwordChange\') }}</option> <option value="LANGUAGE_CHANGE">{{ vm.translate(\'users.report.languageChange\') }}</option> <option value="CORRECTIVE_DOCUMENT_DELIVERY_METHOD_CHANGE">{{ vm.translate(\'users.report.correctiveDocumentDeliveryMethodChange\') }}</option> <option value="DOCUMENT_DELIVERY_METHOD_CHANGE">{{ vm.translate(\'users.report.documentDeliveryMethodChange\') }}</option> <option value="MAIL_TEMPLATE_CHANGE">{{ vm.translate(\'users.report.mailTemplateChange\') }}</option> <option value="MAIL_SUBJECT_CHANGE">{{ vm.translate(\'users.report.mailSubjectChange\') }}</option> <option value="DHL_USER_AUTHORITIES_CHANGE">{{ vm.translate(\'users.report.dhlUserAuthoritiesChange\') }}</option> <option value="NOTES_CHANGE">{{ vm.translate(\'users.report.notesChange\') }}</option> <option value="CONTACT_PERSON_CHANGE">{{ vm.translate(\'users.report.contactPersonChange\') }}</option> <option value="PAYER_NUMBER_CHANGE">{{ vm.translate(\'users.report.payerNumberChange\') }}</option> <option value="NIP_CHANGE">{{ vm.translate(\'users.report.NIPChange\') }}</option> <option value="CLIENT_NAME_CHANGE">{{ vm.translate(\'users.report.clientNameChange\') }}</option> <option value="PHONE_NUMBER_CHANGE">{{ vm.translate(\'users.report.phoneNumberChange\') }}</option> <option value="PASSWORD_CHANGE_INTERVAL_CHANGE">{{ vm.translate(\'users.report.passwordChangeIntervalChange\') }}</option> <option value="PASSWORD_SHOW_CHANGE_INTERVAL_CHANGE">{{ vm.translate(\'users.report.passwordShowChangeIntervalChange\') }}</option> <option value="EMAIL_SUBJECT_TEMPLATE_ADDED">{{ vm.translate(\'users.report.emailSubjectTemplateAdded\') }}</option> <option value="EMAIL_TEMPLATE_ADDED">{{ vm.translate(\'users.report.emailTemplateAdded\') }}</option> <option value="RECEIVABLES_VIEWED">{{ vm.translate(\'users.report.receivablesSeen\') }}</option> </select> </div> <div class="form-group"> <label class="control-label"><span translate="users.report.clientName">Nazwa klienta:</span></label> <input class="form-control margin-bottom input-sm" type="text" id="reportUserActivityClientNames" ng-model="vm.filter.activityClientNames"> </div> <div class="form-group"> <label class="control-label"><span translate="users.report.clientSapNumber">Numer SAP klienta: </span></label> <input class="form-control margin-bottom input-sm" type="text" id="reportUserActivityClientNumbers" ng-model="vm.filter.activityClientNumbers" smart-float> </div> <br> <div class="form-group"> <label class="control-label"><span translate="users.report.documentNumber">Numer dokumentu: </span></label> <input class="form-control margin-bottom input-sm" type="text" id="reportUserActivityDocumentNumbers" ng-model="vm.filter.activityDocumentNumbers" smart-float> </div> <div class="form-group"> <label class="control-label"><span translate="users.report.documentType">Typ dokumentu:</span></label> <select class="form-control margin-bottom input-sm" name="doc_type" id="doc_type" ng-model="vm.filter.activityDocumentTypes"> <option default value="">-- {{ vm.translate(\'documents.document.choose\') }} --</option> <option value="invoice">{{ vm.translate(\'documents.document.invoice\') }}</option> <option value="correction">{{ vm.translate(\'documents.document.correctingInvoice\') }}</option> <option value="note">{{ vm.translate(\'documents.document.accountingNote\') }}</option> </select> </div> <div class="form-group"> <label class="control-label"><span translate="users.report.oldUsers">Nie omijaj archiwalnych u\u017Cytkownik\xF3w: </span></label> <input type="checkbox" class="form-check-input" id="useArchiveUsers" ng-model="vm.filter.useArchiveUsers"> </div> <!--1.       Wg daty zmiany \u2013 zakresu dat (zawsze nale\u017Cy poda\u0107 przedzia\u0142 dat)\n                                2.       Wg rodzaju u\u017Cytkownika.\n                                3.       Wg operatora zmiany \u2013 z mo\u017Cliwo\u015Bci\u0105 wyboru jednego lub wielu operator\xF3w zmiany.\n                                4.       Wg loginu u\u017Cytkownika - z mo\u017Cliwo\u015Bci\u0105 wyboru jednego lub wielu u\u017Cytkownik\xF3w.\n                                5.       Wg rodzaju akcji / aktywno\u015Bci - z mo\u017Cliwo\u015Bci\u0105 wyboru jednej lub wielu aktywno\u015Bci.\n                                6.       Wg nazwy klienta.\n                                7.       Wg nr klienta (SAP) \u2013 z mo\u017Cliwo\u015Bci\u0105 wyboru jednego lub wielu nr klient\xF3w\n                                8.       Wg nr dokumentu \u2013 z mo\u017Cliwo\u015Bci\u0105 wyboru jednego lub wielu nr dokument\xF3w lub wg zakresu dokument\xF3w.\n                                9.       Wg rodzaju dokumentu. --> </fieldset> </div> </div> </uib-tab> </uib-tabset> </div> <div class="modal-footer"> <a target="_blank" ng-click="vm.modal.generate()" ng-href="{{vm.modal.getGenerateURL()}}" class="btn"> <span translate="users.report.generateRaport">Generuj raport</span> <i class="fa fa-table"></i> </a> <button class="btn" type="button" ng-click="vm.modal.cancel()"> <span translate="users.report.cancel">Anuluj</span> <i class="fa fa-times"></i> </button> </div> </form> ');
$templateCache.put('app/views/users/user/user.html','<div class="row-fluid embedded-page-padding" ng-if="($root.Principal.hasUserRead() || $root.Principal.hasUserWrite())"> <div class="btn-enclose"> <button id="back" class="btn" ng-click="vm.nav.users()"> <i class="fa fa-chevron-left"></i> <span translate="users.user.back">Powr\xF3t</span> </button> </div> </div> <br> <div ng-show="vm.rolesChangeError!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.rolesChangeError=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope" translate="users.user.rolesUpdateError">Error occured when updating roles</span> </div> </div> <div ng-show="vm.rolesChangeSuccess!=null" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert" type="success" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.rolesChangeSuccess=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope" translate="users.user.rolesUpdateSuccess">Roles update successful</span> </div> </div> <portal-alert></portal-alert> <h1 class="row-fluid title text-left"> <span translate="users.user.title">U\u017Cytkownik</span> </h1> <div class="row"> <div class="col-md-5 container"> <table id="fixtable" class="tablesorter latest row-fluid"> <thead> <tr> <th></th> <th></th> </tr> </thead> <tbody> <tr> <td><span translate="users.user.emailAdres">Adres e-mail</span></td> <td>{{vm.data .user.email}} </td> </tr> <tr> <td><span translate="users.user.activationDate">Data pierwszej aktywacji</span></td> <td>{{vm.data.user.firstActivationDate.activityTime | date:\'yyyy-MM-dd HH:mm:ss\'}}</td> </tr> <tr> <td><span translate="users.user.lastChangeDate">Data ostatniej zmiany</span></td> <td>{{vm.data.user.lastActivityDate.activityTime | date:\'yyyy-MM-dd HH:mm:ss\'}}</td> </tr> <tr> <td><span translate="users.user.receivables.isLockedDocuments">Czy dost\u0119p do dokument\xF3w jest zablokowany?</span></td> <td>{{vm.data.user.documentsLocked ? vm.translate(\'yes\') : vm.translate(\'no\')}}</td> </tr> <tr> <td><span translate="users.user.isLocked">Czy konto jest zablokowane?</span></td> <td>{{vm.data.user.locked ? vm.translate(\'yes\') : vm.translate(\'no\')}}</td> </tr> <tr> <td><span translate="users.user.isActive">Czy konto jest aktywowane?</span></td> <td>{{vm.data.user.activated ? vm.translate(\'yes\') : vm.translate(\'no\')}}</td> </tr> <tr> <td><span translate="users.user.passwordExpirationDate">Data wyga\u015Bni\u0119cia has\u0142a</span></td> <td>{{vm.data.user.passwordExpireDate | date:\'yyyy-MM-dd HH:mm:ss\'}}</td> </tr> <tr> <td><span translate="users.user.lastSuccessfulLogin">Ostatnie poprawne logowanie</span></td> <td>{{vm.data.user.lastSuccessfulLoginDate.activityTime | date:\'yyyy-MM-dd HH:mm:ss\'}}</td> </tr> <tr> <td><span translate="users.user.lastFailedLogin">Ostatnie niepoprawne logowania</span></td> <td> <span ng-repeat="fail in vm.data.user.lastFailedLoginDate">{{fail.activityTime | date:\'yyyy-MM-dd HH:mm:ss\'}}<br></span> </td> </tr> <tr> <td><span translate="users.user.clients_">Klienci</span></td> <td> <div ng-if="vm.data.user.clients.length == 0">{{vm.translate(\'users.users.none\')}}</div> <div ng-if="vm.data.user.clients.length > 0" ng-repeat="client in vm.data.user.clients" ng-click="vm.nav.client(client)"><a>{{client.clientNumber}}</a></div> </td> </tr> </tbody> <tfoot> <tr> <td colspan="2"></td> </tr> </tfoot> </table> <div class="btn-enclose text-center row-fluid"> <button class="btn col-xs-12 col-lg-5" ng-click="vm.user.clients()" ng-if="$root.Principal.hasUserWrite()"> <span translate="users.user.manageClients">Zarz\u0105dzanie klientami </span> <i class="fa fa-users"></i> </button> <button class="btn col-xs-12 col-lg-5" confirm="vm.user.resetPassword()" ng-if="$root.Principal.hasUserWrite()"> <span translate="users.user.resetPassword">Resetuj has\u0142o </span> <i class="fa fa-key"></i> </button> <button class="btn col-xs-12 col-lg-5" confirm="vm.user.unlockDocuments()" ng-disabled="!vm.data.user.documentsLocked" ng-if="!$root.Principal.hasSystemAccess() && $root.Principal.hasTemplateAccess()"> <span translate="users.user.receivables.unlockDocuments">Odblokuj dokumenty</span> <i class="fa fa-unlock"></i> </button> <button class="btn col-xs-12 col-lg-5" confirm="vm.user.lockDocuments()" ng-disabled="vm.data.user.documentsLocked" ng-if="!$root.Principal.hasSystemAccess() && $root.Principal.hasTemplateAccess()"> <span translate="users.user.receivables.lockDocuments">Zablokuj dokumenty</span> <i class="fa fa-ban"></i> </button> <button class="btn col-xs-12 col-lg-5" confirm="vm.user.unlock()" ng-if="$root.Principal.hasUserWrite()" ng-disabled="!vm.data.user.locked"> <span translate="users.user.unlockAccount">Odblokuj konto </span> <i class="fa fa-unlock"></i> </button> <button class="btn col-xs-12 col-lg-5" confirm="vm.user.lock()" ng-if="$root.Principal.hasUserWrite()" ng-disabled="vm.data.user.locked"> <span translate="users.user.lockAccount">Zablokuj konto </span> <i class="fa fa-ban"></i> </button> <button class="btn col-xs-12 col-lg-5" confirm="vm.user.delete()" confirm-message="{{vm.deleteMessage}}" ng-if="$root.Principal.hasUserWrite() && vm.deleteMessage != null"> <span translate="users.user.deleteAccount">Usu\u0144 konto </span> <i class="fa fa-trash-o"></i> </button> </div> </div> <div class="col-md-5 col-md-push-2" ng-if="$root.Principal.hasSystemAccess()"> <table class="tablesorter latest"> <thead> <tr> <th><span translate="users.user.roleName">Nazwa roli</span></th> <th><span translate="users.user.active">Aktywna</span></th> </tr> </thead> <tbody> <tr ng-repeat="role in vm.data.roles" ng-click="role.active = !role.active"> <td>{{role.roleName}}</td> <td> <input type="checkbox" ng-model="role.active" ng-click="role.active = !role.active"> </td> </tr> </tbody> <tfoot> <tr> <td colspan="2"></td> </tr> </tfoot> </table> <div class="voffset1"> <button class="btn col-xs-12 col-lg-5" ng-click="vm.roles.change()"> <span translate="users.user.updateRoles">Aktualizuj role </span> <i class="fa fa-pencil"></i> </button> </div> </div> </div> <div class="row-fluid"> </div> ');
$templateCache.put('app/views/users/users/users.html','<div id="fixed" class="container container-fluid embedded-page-padding"> <portal-alert></portal-alert> <form id="filter" class="form-inline" accept-charset="UTF-8"> <fieldset> <div class="form-group"> <label class="control-label" for="searchUserLogin"><span translate="users.search.email">E-mail:</span></label> <input class="form-control" type="text" id="searchUserLogin" ng-model="vm.filter.data.email"> </div> <div class="form-group"> <label for="searchUserSAPId"><span translate="users.search.clientSapNumber">Numer SAP klienta:</span></label> <input class="form-control" type="text" id="searchUserSAPId" ng-model="vm.filter.data.clientNumber"> </div> <div class="form-group"> <label for="searchUserClientName"><span translate="users.search.clientName">Nazwa klienta:</span></label> <input class="form-control" type="text" id="searchUserClientName" ng-model="vm.filter.data.clientName"> </div> <div class="form-group"> <label class="">&nbsp;</label> <div> <button type="submit" data-role="search" class="btn" value="search" ng-click="vm.list.current()"> <span translate="users.search.search">Szukaj</span> <i class="fa fa-search"></i> </button> </div> </div> <div class="form-group"> <label class="">&nbsp;</label> <div> <button id="delete" class="btn" ng-click="vm.filter.clear()"> <span translate="users.search.clean">Czy\u015B\u0107</span> <i class="fa fa-eraser"></i> </button> </div> </div> </fieldset> </form> <div class="actionButtons row"> <div class="col-xs-6"> <button type="submit" class="btn btn-add btn-add-use" ng-click="vm.user.form()" ng-if="$root.Principal.hasUserRead() && ($root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess())"> <span translate="users.table.add">Dodaj</span> <i class="fa fa-plus-square"></i> </button> </div> <div class="col-xs-6 text-right"> <button class="btn" ng-click="vm.report.form()"> <span translate="users.table.generateReport">Wygeneruj raport</span> <i class="fa fa-table"></i> </button> </div> </div> </div> <div id="under-fixed"> <div class="row text-center" ng-show="vm.data._embedded != null && vm.data._embedded.dhlUserPortalEntryResources.length == 0"> <h2><strong translate="users.errors.noUsersFound">Brak u\u017Cytkownik\xF3w spe\u0142niaj\u0105cych podane kryteria wyszukiwania</strong></h2> </div> <div ng-show="vm.data._embedded.dhlUserPortalEntryResources.length > 0" style="width: 100%; overflow-x : auto"> <table id="fixtable" class="tablesorter latest users-table" fix-table> <thead> <tr> <th><span translate="users.table.ordinal">Lp</span></th> <th><span translate="users.table.email">E-mail</span></th> <th><span translate="users.table.clients">Klienci</span></th> <th><span translate="users.table.lastCorretLogin">Ostatnie poprawne logowanie</span></th> <th><span translate="users.table.lastIncorrectLogin">Ostatnie niepoprawne logowanie</span></th> </tr> </thead> <tbody ng-repeat="entry in vm.data._embedded.dhlUserPortalEntryResources" ng-dblclick="vm.nav.user(entry.user)"> <tr> <td>{{$index+1+vm.data.page.size*vm.data.page.number}}</td> <td>{{entry.user.email}}</td> <td>{{entry.client ? entry.client.clientNumber : vm.translate(\'users.users.none\')}}</td> <td>{{entry.lastSuccessfulLogin ? entry.lastSuccessfulLogin : vm.translate(\'users.users.none\') | date:\'yyyy-MM-dd HH:mm:ss\'}}</td> <td> <span ng-show="entry.lastFailedLogins.length > 0" ng-repeat="fail in entry.lastFailedLogins">{{fail | date:\'yyyy-MM-dd HH:mm:ss\'}}<br> </span> <span ng-show="entry.lastFailedLogins.length == 0">{{ vm.translate(\'users.users.none\') }}</span></td> </tr> </tbody> <tfoot> <tr> <td colspan="5"></td> </tr> </tfoot> </table> </div> <div class="row actionButtons" ng-if="vm.data._embedded.dhlUserPortalEntryResources.length > 0"> <div class="col-sm-6 text-left"> <button class="btn" ng-disabled="!vm.data._links.first || (vm.data.page.number == 0)" ng-click="vm.list.first()"> <i class="fa fa-step-backward"></i> <span translate="users.table.first">Pierwsza</span> </button> <button class="btn" ng-disabled="!vm.data._links.prev" ng-click="vm.list.previous()"> <i class="fa fa-chevron-left"></i> <span translate="users.table.previous">Poprzednia</span> </button> </div> <div class="col-sm-6 text-right"> <button class="btn" ng-disabled="!vm.data._links.next" ng-click="vm.list.next()"> <span translate="users.table.next">Nast\u0119pna</span> <i class="fa fa-chevron-right"></i> </button> <button class="btn" ng-disabled="!vm.data._links.last || (vm.data.page.number >= vm.data.page.totalPages-1)" ng-click="vm.list.last()"> <span translate="users.table.last">Ostatnia</span> <i class="fa fa-step-forward"></i> </button> </div> </div> </div> ');
$templateCache.put('app/views/users/user/clients/userClients.html','<div class="modal-header"> <h3 class="modal-title"> <span translate="users.user.clients.assignToListTitle">Przypisanie u\u017Cytkownika do klient\xF3w</span> </h3> </div> <uib-tabset active="active" class="modal-body"> <uib-tab index="0" heading="{{vm.translate(\'users.user.clients.heading1\')}}"> <form class="container" style="width: 100%"> <div class="row"> <fieldset class="col-xs-12" style="margin:15px 0"> <div style="display: table-cell"> <label for="usersClientNumberAdd"> <strong><span translate="users.user.clients.clientNumber">Numer klienta:</span></strong></label> <br> <input class="form-control" type="text" id="usersClientNumberAdd" ng-model="vm.data.clientNumber" ng-change="vm.clients.lookup()"> </div> <div style="display: table-cell; padding-left: 10px"> <strong><span translate="users.user.clients.client">Klient:</span></strong> <div style="margin-top:8px">{{vm.data.clientName == null ? vm.translate(\'users.user.notFound\') : vm.data.clientName}}</div> </div> </fieldset> </div> <div class="row modal-footer"> <button class="btn btn-primary" type="submit" ng-click="vm.clients.addClient()" ng-disabled="vm.data.clientName == null || vm.data.clientName == \'\'"> <span translate="users.user.clients.assignToClient">Przypisz do klienta</span> <i class="fa fa-plus"></i> </button> <button class="btn btn-warning" type="button" ng-click="vm.modal.cancel()"> <span translate="users.user.clients.cancel">Anuluj</span> <i class="fa fa-times"></i> </button> </div> </form> </uib-tab> <uib-tab index="1" heading="{{vm.translate(\'users.user.clients.heading2\')}}"> <form class="container" style="width: 100%"> <div class="row"> <fieldset class="col-xs-12" style="margin:15px 0"> <div style="display: table-cell"> <label for="usersClientNumberDel"> <strong><span translate="users.user.clients.clientNumber">Numer klienta:</span></strong></label> <br> <input class="form-control" type="text" id="usersClientNumberDel" ng-model="vm.data.clientNumber" ng-change="vm.clients.lookup()"> </div> <div style="display: table-cell; padding-left: 10px"> <strong><span translate="users.user.clients.client">Klient:</span></strong> <div style="margin-top:8px">{{vm.data.clientName == null ? vm.translate(\'users.user.notFound\') : vm.data.clientName}}</div> </div> </fieldset> </div> <div class="row modal-footer"> <button class="btn btn-primary" type="submit" ng-click="vm.clients.removeClient()" ng-disabled="vm.data.clientName == null || vm.data.clientName == \'\'"> <span translate="users.user.clients.deleteFromlistButton">Usu\u0144 z listy</span> <i class="fa fa-trash"></i> </button> <button class="btn btn-warning" type="button" ng-click="vm.modal.cancel()"> <span translate="users.user.clients.cancel"> Anuluj</span> <i class="fa fa-times"></i> </button> </div> </form> </uib-tab> <uib-tab index="2" heading="{{vm.translate(\'users.user.clients.heading3\')}}"> <form class="container" style="width: 100%"> <div class="row"> <fieldset class="col-xs-12" style="margin:15px 0"> <label> <span translate="users.user.clients.confirmation"> Czy jeste\u015B pewien, \u017Ce chcesz usun\u0105\u0107 tego U\u017Cytkownika z wszystkich list klient\xF3w? </span> </label> </fieldset> </div> <div class="row modal-footer"> <button class="btn btn-primary" type="submit" ng-click="vm.clients.removeAllClients()"> <span translate="users.user.clients.deleteFromAllListsButton">Usu\u0144 z wszystkich list</span> <i class="fa fa-trash"></i> </button> <button class="btn btn-warning" type="button" ng-click="vm.modal.cancel()"> <span translate="users.user.clients.cancel">Anuluj</span> <i class="fa fa-times"></i> </button> </div> </form> </uib-tab> </uib-tabset> ');}]);})();